var _possibleConstructorReturn = require("/root/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/root/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/root/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

module.exports = function (t) {
  var e = {};

  function n(r) {
    if (e[r]) return e[r].exports;
    var o = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = t, n.c = e, n.d = function (t, e, r) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var o in t) {
      n.d(r, o, function (e) {
        return t[e];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 32);
}([function (t, e, n) {
  function r(t) {
    if (t) return function (t) {
      for (var e in r.prototype) {
        t[e] = r.prototype[e];
      }

      return t;
    }(t);
  }

  t.exports = r, r.prototype.on = r.prototype.addEventListener = function (t, e) {
    return this._callbacks = this._callbacks || {}, (this._callbacks["$" + t] = this._callbacks["$" + t] || []).push(e), this;
  }, r.prototype.once = function (t, e) {
    function n() {
      this.off(t, n), e.apply(this, arguments);
    }

    return n.fn = e, this.on(t, n), this;
  }, r.prototype.off = r.prototype.removeListener = r.prototype.removeAllListeners = r.prototype.removeEventListener = function (t, e) {
    if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this;
    var n,
        r = this._callbacks["$" + t];
    if (!r) return this;
    if (1 == arguments.length) return delete this._callbacks["$" + t], this;

    for (var o = 0; o < r.length; o++) {
      if ((n = r[o]) === e || n.fn === e) {
        r.splice(o, 1);
        break;
      }
    }

    return this;
  }, r.prototype.emit = function (t) {
    this._callbacks = this._callbacks || {};
    var e = [].slice.call(arguments, 1),
        n = this._callbacks["$" + t];
    if (n) for (var r = 0, o = (n = n.slice(0)).length; r < o; ++r) {
      n[r].apply(this, e);
    }
    return this;
  }, r.prototype.listeners = function (t) {
    return this._callbacks = this._callbacks || {}, this._callbacks["$" + t] || [];
  }, r.prototype.hasListeners = function (t) {
    return !!this.listeners(t).length;
  };
}, function (t, e, n) {
  var r,
      o = n(52),
      i = n(24),
      s = n(54),
      a = n(55),
      c = n(56);
  "undefined" != typeof ArrayBuffer && (r = n(57));
  var u = "undefined" != typeof navigator && /Android/i.test(navigator.userAgent),
      l = "undefined" != typeof navigator && /PhantomJS/i.test(navigator.userAgent),
      f = u || l;
  e.protocol = 3;
  var h = e.packets = {
    open: 0,
    close: 1,
    ping: 2,
    pong: 3,
    message: 4,
    upgrade: 5,
    noop: 6
  },
      p = o(h),
      d = {
    type: "error",
    data: "parser error"
  },
      y = n(58);

  function g(t, e, n) {
    for (var r = new Array(t.length), o = a(t.length, n), i = function i(t, n, o) {
      e(n, function (e, n) {
        r[t] = n, o(e, r);
      });
    }, s = 0; s < t.length; s++) {
      i(s, t[s], o);
    }
  }

  e.encodePacket = function (t, n, r, o) {
    "function" == typeof n && (o = n, n = !1), "function" == typeof r && (o = r, r = null);
    var i = void 0 === t.data ? void 0 : t.data.buffer || t.data;
    if ("undefined" != typeof ArrayBuffer && i instanceof ArrayBuffer) return function (t, n, r) {
      if (!n) return e.encodeBase64Packet(t, r);
      var o = t.data,
          i = new Uint8Array(o),
          s = new Uint8Array(1 + o.byteLength);
      s[0] = h[t.type];

      for (var a = 0; a < i.length; a++) {
        s[a + 1] = i[a];
      }

      return r(s.buffer);
    }(t, n, o);
    if (void 0 !== y && i instanceof y) return function (t, n, r) {
      if (!n) return e.encodeBase64Packet(t, r);
      if (f) return function (t, n, r) {
        if (!n) return e.encodeBase64Packet(t, r);
        var o = new FileReader();
        return o.onload = function () {
          e.encodePacket({
            type: t.type,
            data: o.result
          }, n, !0, r);
        }, o.readAsArrayBuffer(t.data);
      }(t, n, r);
      var o = new Uint8Array(1);
      o[0] = h[t.type];
      var i = new y([o.buffer, t.data]);
      return r(i);
    }(t, n, o);
    if (i && i.base64) return function (t, n) {
      var r = "b" + e.packets[t.type] + t.data.data;
      return n(r);
    }(t, o);
    var s = h[t.type];
    return void 0 !== t.data && (s += r ? c.encode(String(t.data), {
      strict: !1
    }) : String(t.data)), o("" + s);
  }, e.encodeBase64Packet = function (t, n) {
    var r,
        o = "b" + e.packets[t.type];

    if (void 0 !== y && t.data instanceof y) {
      var i = new FileReader();
      return i.onload = function () {
        var t = i.result.split(",")[1];
        n(o + t);
      }, i.readAsDataURL(t.data);
    }

    try {
      r = String.fromCharCode.apply(null, new Uint8Array(t.data));
    } catch (e) {
      for (var s = new Uint8Array(t.data), a = new Array(s.length), c = 0; c < s.length; c++) {
        a[c] = s[c];
      }

      r = String.fromCharCode.apply(null, a);
    }

    return o += btoa(r), n(o);
  }, e.decodePacket = function (t, n, r) {
    if (void 0 === t) return d;

    if ("string" == typeof t) {
      if ("b" === t.charAt(0)) return e.decodeBase64Packet(t.substr(1), n);
      if (r && !1 === (t = function (t) {
        try {
          t = c.decode(t, {
            strict: !1
          });
        } catch (t) {
          return !1;
        }

        return t;
      }(t))) return d;
      var o = t.charAt(0);
      return Number(o) == o && p[o] ? t.length > 1 ? {
        type: p[o],
        data: t.substring(1)
      } : {
        type: p[o]
      } : d;
    }

    o = new Uint8Array(t)[0];
    var i = s(t, 1);
    return y && "blob" === n && (i = new y([i])), {
      type: p[o],
      data: i
    };
  }, e.decodeBase64Packet = function (t, e) {
    var n = p[t.charAt(0)];
    if (!r) return {
      type: n,
      data: {
        base64: !0,
        data: t.substr(1)
      }
    };
    var o = r.decode(t.substr(1));
    return "blob" === e && y && (o = new y([o])), {
      type: n,
      data: o
    };
  }, e.encodePayload = function (t, n, r) {
    "function" == typeof n && (r = n, n = null);
    var o = i(t);
    if (n && o) return y && !f ? e.encodePayloadAsBlob(t, r) : e.encodePayloadAsArrayBuffer(t, r);
    if (!t.length) return r("0:");
    g(t, function (t, r) {
      e.encodePacket(t, !!o && n, !1, function (t) {
        r(null, function (t) {
          return t.length + ":" + t;
        }(t));
      });
    }, function (t, e) {
      return r(e.join(""));
    });
  }, e.decodePayload = function (t, n, r) {
    if ("string" != typeof t) return e.decodePayloadAsBinary(t, n, r);
    var o;
    if ("function" == typeof n && (r = n, n = null), "" === t) return r(d, 0, 1);

    for (var i, s, a = "", c = 0, u = t.length; c < u; c++) {
      var l = t.charAt(c);

      if (":" === l) {
        if ("" === a || a != (i = Number(a))) return r(d, 0, 1);
        if (a != (s = t.substr(c + 1, i)).length) return r(d, 0, 1);

        if (s.length) {
          if (o = e.decodePacket(s, n, !1), d.type === o.type && d.data === o.data) return r(d, 0, 1);
          if (!1 === r(o, c + i, u)) return;
        }

        c += i, a = "";
      } else a += l;
    }

    return "" !== a ? r(d, 0, 1) : void 0;
  }, e.encodePayloadAsArrayBuffer = function (t, n) {
    if (!t.length) return n(new ArrayBuffer(0));
    g(t, function (t, n) {
      e.encodePacket(t, !0, !0, function (t) {
        return n(null, t);
      });
    }, function (t, e) {
      var r = e.reduce(function (t, e) {
        var n;
        return t + (n = "string" == typeof e ? e.length : e.byteLength).toString().length + n + 2;
      }, 0),
          o = new Uint8Array(r),
          i = 0;
      return e.forEach(function (t) {
        var e = "string" == typeof t,
            n = t;

        if (e) {
          for (var r = new Uint8Array(t.length), s = 0; s < t.length; s++) {
            r[s] = t.charCodeAt(s);
          }

          n = r.buffer;
        }

        o[i++] = e ? 0 : 1;
        var a = n.byteLength.toString();

        for (s = 0; s < a.length; s++) {
          o[i++] = parseInt(a[s]);
        }

        o[i++] = 255;

        for (r = new Uint8Array(n), s = 0; s < r.length; s++) {
          o[i++] = r[s];
        }
      }), n(o.buffer);
    });
  }, e.encodePayloadAsBlob = function (t, n) {
    g(t, function (t, n) {
      e.encodePacket(t, !0, !0, function (t) {
        var e = new Uint8Array(1);

        if (e[0] = 1, "string" == typeof t) {
          for (var r = new Uint8Array(t.length), o = 0; o < t.length; o++) {
            r[o] = t.charCodeAt(o);
          }

          t = r.buffer, e[0] = 0;
        }

        var i = (t instanceof ArrayBuffer ? t.byteLength : t.size).toString(),
            s = new Uint8Array(i.length + 1);

        for (o = 0; o < i.length; o++) {
          s[o] = parseInt(i[o]);
        }

        if (s[i.length] = 255, y) {
          var a = new y([e.buffer, s.buffer, t]);
          n(null, a);
        }
      });
    }, function (t, e) {
      return n(new y(e));
    });
  }, e.decodePayloadAsBinary = function (t, n, r) {
    "function" == typeof n && (r = n, n = null);

    for (var o = t, i = []; o.byteLength > 0;) {
      for (var a = new Uint8Array(o), c = 0 === a[0], u = "", l = 1; 255 !== a[l]; l++) {
        if (u.length > 310) return r(d, 0, 1);
        u += a[l];
      }

      o = s(o, 2 + u.length), u = parseInt(u);
      var f = s(o, 0, u);
      if (c) try {
        f = String.fromCharCode.apply(null, new Uint8Array(f));
      } catch (t) {
        var h = new Uint8Array(f);
        f = "";

        for (l = 0; l < h.length; l++) {
          f += String.fromCharCode(h[l]);
        }
      }
      i.push(f), o = s(o, u);
    }

    var p = i.length;
    i.forEach(function (t, o) {
      r(e.decodePacket(t, n, !0), o, p);
    });
  };
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = n(34);
  Object.defineProperty(e, "validator", {
    enumerable: !0,
    get: function get() {
      return i(r).default;
    }
  });
  var o = n(15);

  function i(t) {
    return t && t.__esModule ? t : {
      default: t
    };
  }

  Object.defineProperty(e, "logger", {
    enumerable: !0,
    get: function get() {
      return i(o).default;
    }
  });
}, function (t, e) {
  var n,
      r,
      o = t.exports = {};

  function i() {
    throw new Error("setTimeout has not been defined");
  }

  function s() {
    throw new Error("clearTimeout has not been defined");
  }

  function a(t) {
    if (n === setTimeout) return setTimeout(t, 0);
    if ((n === i || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);

    try {
      return n(t, 0);
    } catch (e) {
      try {
        return n.call(null, t, 0);
      } catch (e) {
        return n.call(this, t, 0);
      }
    }
  }

  !function () {
    try {
      n = "function" == typeof setTimeout ? setTimeout : i;
    } catch (t) {
      n = i;
    }

    try {
      r = "function" == typeof clearTimeout ? clearTimeout : s;
    } catch (t) {
      r = s;
    }
  }();
  var c,
      u = [],
      l = !1,
      f = -1;

  function h() {
    l && c && (l = !1, c.length ? u = c.concat(u) : f = -1, u.length && p());
  }

  function p() {
    if (!l) {
      var t = a(h);
      l = !0;

      for (var e = u.length; e;) {
        for (c = u, u = []; ++f < e;) {
          c && c[f].run();
        }

        f = -1, e = u.length;
      }

      c = null, l = !1, function (t) {
        if (r === clearTimeout) return clearTimeout(t);
        if ((r === s || !r) && clearTimeout) return r = clearTimeout, clearTimeout(t);

        try {
          r(t);
        } catch (e) {
          try {
            return r.call(null, t);
          } catch (e) {
            return r.call(this, t);
          }
        }
      }(t);
    }
  }

  function d(t, e) {
    this.fun = t, this.array = e;
  }

  function y() {}

  o.nextTick = function (t) {
    var e = new Array(arguments.length - 1);
    if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
      e[n - 1] = arguments[n];
    }
    u.push(new d(t, e)), 1 !== u.length || l || a(p);
  }, d.prototype.run = function () {
    this.fun.apply(null, this.array);
  }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = y, o.addListener = y, o.once = y, o.off = y, o.removeListener = y, o.removeAllListeners = y, o.emit = y, o.prependListener = y, o.prependOnceListener = y, o.listeners = function (t) {
    return [];
  }, o.binding = function (t) {
    throw new Error("process.binding is not supported");
  }, o.cwd = function () {
    return "/";
  }, o.chdir = function (t) {
    throw new Error("process.chdir is not supported");
  }, o.umask = function () {
    return 0;
  };
}, function (t, e) {
  var n;

  n = function () {
    return this;
  }();

  try {
    n = n || Function("return this")() || (0, eval)("this");
  } catch (t) {
    "object" == typeof window && (n = window);
  }

  t.exports = n;
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = n(33);
  Object.defineProperty(e, "Repository", {
    enumerable: !0,
    get: function get() {
      return r.Repository;
    }
  });
}, function (t, e, n) {
  (function (r) {
    function o() {
      var t;

      try {
        t = e.storage.debug;
      } catch (t) {}

      return !t && void 0 !== r && "env" in r && (t = r.env.DEBUG), t;
    }

    (e = t.exports = n(39)).log = function () {
      return "object" == typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }, e.formatArgs = function (t) {
      var n = this.useColors;
      if (t[0] = (n ? "%c" : "") + this.namespace + (n ? " %c" : " ") + t[0] + (n ? "%c " : " ") + "+" + e.humanize(this.diff), !n) return;
      var r = "color: " + this.color;
      t.splice(1, 0, r, "color: inherit");
      var o = 0,
          i = 0;
      t[0].replace(/%[a-zA-Z%]/g, function (t) {
        "%%" !== t && (o++, "%c" === t && (i = o));
      }), t.splice(i, 0, r);
    }, e.save = function (t) {
      try {
        null == t ? e.storage.removeItem("debug") : e.storage.debug = t;
      } catch (t) {}
    }, e.load = o, e.useColors = function () {
      if ("undefined" != typeof window && window.process && "renderer" === window.process.type) return !0;
      if ("undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return !1;
      return "undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }, e.storage = "undefined" != typeof chrome && void 0 !== chrome.storage ? chrome.storage.local : function () {
      try {
        return window.localStorage;
      } catch (t) {}
    }(), e.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], e.formatters.j = function (t) {
      try {
        return JSON.stringify(t);
      } catch (t) {
        return "[UnexpectedJSONParseError]: " + t.message;
      }
    }, e.enable(o());
  }).call(this, n(3));
}, function (t, e) {
  e.encode = function (t) {
    var e = "";

    for (var n in t) {
      t.hasOwnProperty(n) && (e.length && (e += "&"), e += encodeURIComponent(n) + "=" + encodeURIComponent(t[n]));
    }

    return e;
  }, e.decode = function (t) {
    for (var e = {}, n = t.split("&"), r = 0, o = n.length; r < o; r++) {
      var i = n[r].split("=");
      e[decodeURIComponent(i[0])] = decodeURIComponent(i[1]);
    }

    return e;
  };
}, function (t, e) {
  t.exports = function (t, e) {
    var n = function n() {};

    n.prototype = e.prototype, t.prototype = new n(), t.prototype.constructor = t;
  };
}, function (t, e, n) {
  (function (r) {
    function o() {
      var t;

      try {
        t = e.storage.debug;
      } catch (t) {}

      return !t && void 0 !== r && "env" in r && (t = r.env.DEBUG), t;
    }

    (e = t.exports = n(59)).log = function () {
      return "object" == typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }, e.formatArgs = function (t) {
      var n = this.useColors;
      if (t[0] = (n ? "%c" : "") + this.namespace + (n ? " %c" : " ") + t[0] + (n ? "%c " : " ") + "+" + e.humanize(this.diff), !n) return;
      var r = "color: " + this.color;
      t.splice(1, 0, r, "color: inherit");
      var o = 0,
          i = 0;
      t[0].replace(/%[a-zA-Z%]/g, function (t) {
        "%%" !== t && (o++, "%c" === t && (i = o));
      }), t.splice(i, 0, r);
    }, e.save = function (t) {
      try {
        null == t ? e.storage.removeItem("debug") : e.storage.debug = t;
      } catch (t) {}
    }, e.load = o, e.useColors = function () {
      if ("undefined" != typeof window && window.process && "renderer" === window.process.type) return !0;
      if ("undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return !1;
      return "undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }, e.storage = "undefined" != typeof chrome && void 0 !== chrome.storage ? chrome.storage.local : function () {
      try {
        return window.localStorage;
      } catch (t) {}
    }(), e.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], e.formatters.j = function (t) {
      try {
        return JSON.stringify(t);
      } catch (t) {
        return "[UnexpectedJSONParseError]: " + t.message;
      }
    }, e.enable(o());
  }).call(this, n(3));
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Domain = void 0;

  var r = n(5),
      o = function (t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for (var n in t) {
      if (Object.prototype.hasOwnProperty.call(t, n)) {
        var r = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(t, n) : {};
        r.get || r.set ? Object.defineProperty(e, n, r) : e[n] = t[n];
      }
    }
    return e.default = t, e;
  }(n(2));

  e.Domain =
  /*#__PURE__*/
  function () {
    function _class(t) {
      _classCallCheck(this, _class);

      if (this.defaultOptions = {
        protocol: "https",
        host: "grep-grainger-dev-api.azurewebsites.net",
        port: "",
        basePath: "",
        timeout: 15e3,
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        },
        fetchProps: {}
      }, !o.validator.validate([{
        object: t
      }])) return o.logger.error("Your configuration is not a valid object.");
      "auth" in t && t.auth.headers && (this.defaultOptions.headers = t.auth.headers), "endpoint" in t && this.setConfig(t.endpoint);
    }

    _createClass(_class, [{
      key: "setConfig",
      value: function setConfig() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign(this.defaultOptions, t);
      }
    }, {
      key: "request",
      value: function request() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var i = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (!o.validator.validate([{
          string: t
        }, {
          object: e
        }, {
          object: n
        }, {
          object: i
        }])) return o.logger.error("Request param types are incorrect.");
        var s = this.setConfig(n);
        return new r.Repository(s).getItem(t, e, i);
      }
    }]);

    return _class;
  }();
}, function (t, e, n) {
  var r = n(41)("socket.io-parser"),
      o = n(0),
      i = n(44),
      s = n(19),
      a = n(20);

  function c() {}

  e.protocol = 4, e.types = ["CONNECT", "DISCONNECT", "EVENT", "ACK", "ERROR", "BINARY_EVENT", "BINARY_ACK"], e.CONNECT = 0, e.DISCONNECT = 1, e.EVENT = 2, e.ACK = 3, e.ERROR = 4, e.BINARY_EVENT = 5, e.BINARY_ACK = 6, e.Encoder = c, e.Decoder = f;
  var u = e.ERROR + '"encode error"';

  function l(t) {
    var n = "" + t.type;

    if (e.BINARY_EVENT !== t.type && e.BINARY_ACK !== t.type || (n += t.attachments + "-"), t.nsp && "/" !== t.nsp && (n += t.nsp + ","), null != t.id && (n += t.id), null != t.data) {
      var o = function (t) {
        try {
          return JSON.stringify(t);
        } catch (t) {
          return !1;
        }
      }(t.data);

      if (!1 === o) return u;
      n += o;
    }

    return r("encoded %j as %s", t, n), n;
  }

  function f() {
    this.reconstructor = null;
  }

  function h(t) {
    this.reconPack = t, this.buffers = [];
  }

  function p(t) {
    return {
      type: e.ERROR,
      data: "parser error: " + t
    };
  }

  c.prototype.encode = function (t, n) {
    (r("encoding packet %j", t), e.BINARY_EVENT === t.type || e.BINARY_ACK === t.type) ? function (t, e) {
      i.removeBlobs(t, function (t) {
        var n = i.deconstructPacket(t),
            r = l(n.packet),
            o = n.buffers;
        o.unshift(r), e(o);
      });
    }(t, n) : n([l(t)]);
  }, o(f.prototype), f.prototype.add = function (t) {
    var n;
    if ("string" == typeof t) n = function (t) {
      var n = 0,
          o = {
        type: Number(t.charAt(0))
      };
      if (null == e.types[o.type]) return p("unknown packet type " + o.type);

      if (e.BINARY_EVENT === o.type || e.BINARY_ACK === o.type) {
        for (var i = ""; "-" !== t.charAt(++n) && (i += t.charAt(n), n != t.length);) {
          ;
        }

        if (i != Number(i) || "-" !== t.charAt(n)) throw new Error("Illegal attachments");
        o.attachments = Number(i);
      }

      if ("/" === t.charAt(n + 1)) for (o.nsp = ""; ++n;) {
        var a = t.charAt(n);
        if ("," === a) break;
        if (o.nsp += a, n === t.length) break;
      } else o.nsp = "/";
      var c = t.charAt(n + 1);

      if ("" !== c && Number(c) == c) {
        for (o.id = ""; ++n;) {
          var a = t.charAt(n);

          if (null == a || Number(a) != a) {
            --n;
            break;
          }

          if (o.id += t.charAt(n), n === t.length) break;
        }

        o.id = Number(o.id);
      }

      if (t.charAt(++n)) {
        var u = function (t) {
          try {
            return JSON.parse(t);
          } catch (t) {
            return !1;
          }
        }(t.substr(n)),
            l = !1 !== u && (o.type === e.ERROR || s(u));

        if (!l) return p("invalid payload");
        o.data = u;
      }

      return r("decoded %s as %j", t, o), o;
    }(t), e.BINARY_EVENT === n.type || e.BINARY_ACK === n.type ? (this.reconstructor = new h(n), 0 === this.reconstructor.reconPack.attachments && this.emit("decoded", n)) : this.emit("decoded", n);else {
      if (!a(t) && !t.base64) throw new Error("Unknown type: " + t);
      if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
      (n = this.reconstructor.takeBinaryData(t)) && (this.reconstructor = null, this.emit("decoded", n));
    }
  }, f.prototype.destroy = function () {
    this.reconstructor && this.reconstructor.finishedReconstruction();
  }, h.prototype.takeBinaryData = function (t) {
    if (this.buffers.push(t), this.buffers.length === this.reconPack.attachments) {
      var e = i.reconstructPacket(this.reconPack, this.buffers);
      return this.finishedReconstruction(), e;
    }

    return null;
  }, h.prototype.finishedReconstruction = function () {
    this.reconPack = null, this.buffers = [];
  };
}, function (t, e, n) {
  "use strict";

  (function (t) {
    /*!
     * The buffer module from node.js, for the browser.
     *
     * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
     * @license  MIT
     */
    var r = n(45),
        o = n(46),
        i = n(47);

    function s() {
      return c.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
    }

    function a(t, e) {
      if (s() < e) throw new RangeError("Invalid typed array length");
      return c.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = c.prototype : (null === t && (t = new c(e)), t.length = e), t;
    }

    function c(t, e, n) {
      if (!(c.TYPED_ARRAY_SUPPORT || this instanceof c)) return new c(t, e, n);

      if ("number" == typeof t) {
        if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
        return f(this, t);
      }

      return u(this, t, e, n);
    }

    function u(t, e, n, r) {
      if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
      return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, n, r) {
        if (e.byteLength, n < 0 || e.byteLength < n) throw new RangeError("'offset' is out of bounds");
        if (e.byteLength < n + (r || 0)) throw new RangeError("'length' is out of bounds");
        e = void 0 === n && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, n) : new Uint8Array(e, n, r);
        c.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = c.prototype : t = h(t, e);
        return t;
      }(t, e, n, r) : "string" == typeof e ? function (t, e, n) {
        "string" == typeof n && "" !== n || (n = "utf8");
        if (!c.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
        var r = 0 | d(e, n),
            o = (t = a(t, r)).write(e, n);
        o !== r && (t = t.slice(0, o));
        return t;
      }(t, e, n) : function (t, e) {
        if (c.isBuffer(e)) {
          var n = 0 | p(e.length);
          return 0 === (t = a(t, n)).length ? t : (e.copy(t, 0, 0, n), t);
        }

        if (e) {
          if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (r = e.length) != r ? a(t, 0) : h(t, e);
          if ("Buffer" === e.type && i(e.data)) return h(t, e.data);
        }

        var r;
        throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
      }(t, e);
    }

    function l(t) {
      if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
      if (t < 0) throw new RangeError('"size" argument must not be negative');
    }

    function f(t, e) {
      if (l(e), t = a(t, e < 0 ? 0 : 0 | p(e)), !c.TYPED_ARRAY_SUPPORT) for (var n = 0; n < e; ++n) {
        t[n] = 0;
      }
      return t;
    }

    function h(t, e) {
      var n = e.length < 0 ? 0 : 0 | p(e.length);
      t = a(t, n);

      for (var r = 0; r < n; r += 1) {
        t[r] = 255 & e[r];
      }

      return t;
    }

    function p(t) {
      if (t >= s()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s().toString(16) + " bytes");
      return 0 | t;
    }

    function d(t, e) {
      if (c.isBuffer(t)) return t.length;
      if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
      "string" != typeof t && (t = "" + t);
      var n = t.length;
      if (0 === n) return 0;

      for (var r = !1;;) {
        switch (e) {
          case "ascii":
          case "latin1":
          case "binary":
            return n;

          case "utf8":
          case "utf-8":
          case void 0:
            return L(t).length;

          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return 2 * n;

          case "hex":
            return n >>> 1;

          case "base64":
            return q(t).length;

          default:
            if (r) return L(t).length;
            e = ("" + e).toLowerCase(), r = !0;
        }
      }
    }

    function y(t, e, n) {
      var r = t[e];
      t[e] = t[n], t[n] = r;
    }

    function g(t, e, n, r, o) {
      if (0 === t.length) return -1;

      if ("string" == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = o ? 0 : t.length - 1), n < 0 && (n = t.length + n), n >= t.length) {
        if (o) return -1;
        n = t.length - 1;
      } else if (n < 0) {
        if (!o) return -1;
        n = 0;
      }

      if ("string" == typeof e && (e = c.from(e, r)), c.isBuffer(e)) return 0 === e.length ? -1 : v(t, e, n, r, o);
      if ("number" == typeof e) return e &= 255, c.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? o ? Uint8Array.prototype.indexOf.call(t, e, n) : Uint8Array.prototype.lastIndexOf.call(t, e, n) : v(t, [e], n, r, o);
      throw new TypeError("val must be string, number or Buffer");
    }

    function v(t, e, n, r, o) {
      var i,
          s = 1,
          a = t.length,
          c = e.length;

      if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
        if (t.length < 2 || e.length < 2) return -1;
        s = 2, a /= 2, c /= 2, n /= 2;
      }

      function u(t, e) {
        return 1 === s ? t[e] : t.readUInt16BE(e * s);
      }

      if (o) {
        var l = -1;

        for (i = n; i < a; i++) {
          if (u(t, i) === u(e, -1 === l ? 0 : i - l)) {
            if (-1 === l && (l = i), i - l + 1 === c) return l * s;
          } else -1 !== l && (i -= i - l), l = -1;
        }
      } else for (n + c > a && (n = a - c), i = n; i >= 0; i--) {
        for (var f = !0, h = 0; h < c; h++) {
          if (u(t, i + h) !== u(e, h)) {
            f = !1;
            break;
          }
        }

        if (f) return i;
      }

      return -1;
    }

    function m(t, e, n, r) {
      n = Number(n) || 0;
      var o = t.length - n;
      r ? (r = Number(r)) > o && (r = o) : r = o;
      var i = e.length;
      if (i % 2 != 0) throw new TypeError("Invalid hex string");
      r > i / 2 && (r = i / 2);

      for (var s = 0; s < r; ++s) {
        var a = parseInt(e.substr(2 * s, 2), 16);
        if (isNaN(a)) return s;
        t[n + s] = a;
      }

      return s;
    }

    function _(t, e, n, r) {
      return H(L(e, t.length - n), t, n, r);
    }

    function b(t, e, n, r) {
      return H(function (t) {
        for (var e = [], n = 0; n < t.length; ++n) {
          e.push(255 & t.charCodeAt(n));
        }

        return e;
      }(e), t, n, r);
    }

    function w(t, e, n, r) {
      return b(t, e, n, r);
    }

    function C(t, e, n, r) {
      return H(q(e), t, n, r);
    }

    function k(t, e, n, r) {
      return H(function (t, e) {
        for (var n, r, o, i = [], s = 0; s < t.length && !((e -= 2) < 0); ++s) {
          n = t.charCodeAt(s), r = n >> 8, o = n % 256, i.push(o), i.push(r);
        }

        return i;
      }(e, t.length - n), t, n, r);
    }

    function E(t, e, n) {
      return 0 === e && n === t.length ? r.fromByteArray(t) : r.fromByteArray(t.slice(e, n));
    }

    function F(t, e, n) {
      n = Math.min(t.length, n);

      for (var r = [], o = e; o < n;) {
        var i,
            s,
            a,
            c,
            u = t[o],
            l = null,
            f = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
        if (o + f <= n) switch (f) {
          case 1:
            u < 128 && (l = u);
            break;

          case 2:
            128 == (192 & (i = t[o + 1])) && (c = (31 & u) << 6 | 63 & i) > 127 && (l = c);
            break;

          case 3:
            i = t[o + 1], s = t[o + 2], 128 == (192 & i) && 128 == (192 & s) && (c = (15 & u) << 12 | (63 & i) << 6 | 63 & s) > 2047 && (c < 55296 || c > 57343) && (l = c);
            break;

          case 4:
            i = t[o + 1], s = t[o + 2], a = t[o + 3], 128 == (192 & i) && 128 == (192 & s) && 128 == (192 & a) && (c = (15 & u) << 18 | (63 & i) << 12 | (63 & s) << 6 | 63 & a) > 65535 && c < 1114112 && (l = c);
        }
        null === l ? (l = 65533, f = 1) : l > 65535 && (l -= 65536, r.push(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), r.push(l), o += f;
      }

      return function (t) {
        var e = t.length;
        if (e <= A) return String.fromCharCode.apply(String, t);
        var n = "",
            r = 0;

        for (; r < e;) {
          n += String.fromCharCode.apply(String, t.slice(r, r += A));
        }

        return n;
      }(r);
    }

    e.Buffer = c, e.SlowBuffer = function (t) {
      +t != t && (t = 0);
      return c.alloc(+t);
    }, e.INSPECT_MAX_BYTES = 50, c.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
      try {
        var t = new Uint8Array(1);
        return t.__proto__ = {
          __proto__: Uint8Array.prototype,
          foo: function foo() {
            return 42;
          }
        }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength;
      } catch (t) {
        return !1;
      }
    }(), e.kMaxLength = s(), c.poolSize = 8192, c._augment = function (t) {
      return t.__proto__ = c.prototype, t;
    }, c.from = function (t, e, n) {
      return u(null, t, e, n);
    }, c.TYPED_ARRAY_SUPPORT && (c.prototype.__proto__ = Uint8Array.prototype, c.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && c[Symbol.species] === c && Object.defineProperty(c, Symbol.species, {
      value: null,
      configurable: !0
    })), c.alloc = function (t, e, n) {
      return function (t, e, n, r) {
        return l(e), e <= 0 ? a(t, e) : void 0 !== n ? "string" == typeof r ? a(t, e).fill(n, r) : a(t, e).fill(n) : a(t, e);
      }(null, t, e, n);
    }, c.allocUnsafe = function (t) {
      return f(null, t);
    }, c.allocUnsafeSlow = function (t) {
      return f(null, t);
    }, c.isBuffer = function (t) {
      return !(null == t || !t._isBuffer);
    }, c.compare = function (t, e) {
      if (!c.isBuffer(t) || !c.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
      if (t === e) return 0;

      for (var n = t.length, r = e.length, o = 0, i = Math.min(n, r); o < i; ++o) {
        if (t[o] !== e[o]) {
          n = t[o], r = e[o];
          break;
        }
      }

      return n < r ? -1 : r < n ? 1 : 0;
    }, c.isEncoding = function (t) {
      switch (String(t).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return !0;

        default:
          return !1;
      }
    }, c.concat = function (t, e) {
      if (!i(t)) throw new TypeError('"list" argument must be an Array of Buffers');
      if (0 === t.length) return c.alloc(0);
      var n;
      if (void 0 === e) for (e = 0, n = 0; n < t.length; ++n) {
        e += t[n].length;
      }
      var r = c.allocUnsafe(e),
          o = 0;

      for (n = 0; n < t.length; ++n) {
        var s = t[n];
        if (!c.isBuffer(s)) throw new TypeError('"list" argument must be an Array of Buffers');
        s.copy(r, o), o += s.length;
      }

      return r;
    }, c.byteLength = d, c.prototype._isBuffer = !0, c.prototype.swap16 = function () {
      var t = this.length;
      if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");

      for (var e = 0; e < t; e += 2) {
        y(this, e, e + 1);
      }

      return this;
    }, c.prototype.swap32 = function () {
      var t = this.length;
      if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");

      for (var e = 0; e < t; e += 4) {
        y(this, e, e + 3), y(this, e + 1, e + 2);
      }

      return this;
    }, c.prototype.swap64 = function () {
      var t = this.length;
      if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");

      for (var e = 0; e < t; e += 8) {
        y(this, e, e + 7), y(this, e + 1, e + 6), y(this, e + 2, e + 5), y(this, e + 3, e + 4);
      }

      return this;
    }, c.prototype.toString = function () {
      var t = 0 | this.length;
      return 0 === t ? "" : 0 === arguments.length ? F(this, 0, t) : function (t, e, n) {
        var r = !1;
        if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
        if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
        if ((n >>>= 0) <= (e >>>= 0)) return "";

        for (t || (t = "utf8");;) {
          switch (t) {
            case "hex":
              return P(this, e, n);

            case "utf8":
            case "utf-8":
              return F(this, e, n);

            case "ascii":
              return T(this, e, n);

            case "latin1":
            case "binary":
              return j(this, e, n);

            case "base64":
              return E(this, e, n);

            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return x(this, e, n);

            default:
              if (r) throw new TypeError("Unknown encoding: " + t);
              t = (t + "").toLowerCase(), r = !0;
          }
        }
      }.apply(this, arguments);
    }, c.prototype.equals = function (t) {
      if (!c.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
      return this === t || 0 === c.compare(this, t);
    }, c.prototype.inspect = function () {
      var t = "",
          n = e.INSPECT_MAX_BYTES;
      return this.length > 0 && (t = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (t += " ... ")), "<Buffer " + t + ">";
    }, c.prototype.compare = function (t, e, n, r, o) {
      if (!c.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
      if (void 0 === e && (e = 0), void 0 === n && (n = t ? t.length : 0), void 0 === r && (r = 0), void 0 === o && (o = this.length), e < 0 || n > t.length || r < 0 || o > this.length) throw new RangeError("out of range index");
      if (r >= o && e >= n) return 0;
      if (r >= o) return -1;
      if (e >= n) return 1;
      if (this === t) return 0;

      for (var i = (o >>>= 0) - (r >>>= 0), s = (n >>>= 0) - (e >>>= 0), a = Math.min(i, s), u = this.slice(r, o), l = t.slice(e, n), f = 0; f < a; ++f) {
        if (u[f] !== l[f]) {
          i = u[f], s = l[f];
          break;
        }
      }

      return i < s ? -1 : s < i ? 1 : 0;
    }, c.prototype.includes = function (t, e, n) {
      return -1 !== this.indexOf(t, e, n);
    }, c.prototype.indexOf = function (t, e, n) {
      return g(this, t, e, n, !0);
    }, c.prototype.lastIndexOf = function (t, e, n) {
      return g(this, t, e, n, !1);
    }, c.prototype.write = function (t, e, n, r) {
      if (void 0 === e) r = "utf8", n = this.length, e = 0;else if (void 0 === n && "string" == typeof e) r = e, n = this.length, e = 0;else {
        if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
        e |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
      }
      var o = this.length - e;
      if ((void 0 === n || n > o) && (n = o), t.length > 0 && (n < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
      r || (r = "utf8");

      for (var i = !1;;) {
        switch (r) {
          case "hex":
            return m(this, t, e, n);

          case "utf8":
          case "utf-8":
            return _(this, t, e, n);

          case "ascii":
            return b(this, t, e, n);

          case "latin1":
          case "binary":
            return w(this, t, e, n);

          case "base64":
            return C(this, t, e, n);

          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return k(this, t, e, n);

          default:
            if (i) throw new TypeError("Unknown encoding: " + r);
            r = ("" + r).toLowerCase(), i = !0;
        }
      }
    }, c.prototype.toJSON = function () {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    var A = 4096;

    function T(t, e, n) {
      var r = "";
      n = Math.min(t.length, n);

      for (var o = e; o < n; ++o) {
        r += String.fromCharCode(127 & t[o]);
      }

      return r;
    }

    function j(t, e, n) {
      var r = "";
      n = Math.min(t.length, n);

      for (var o = e; o < n; ++o) {
        r += String.fromCharCode(t[o]);
      }

      return r;
    }

    function P(t, e, n) {
      var r = t.length;
      (!e || e < 0) && (e = 0), (!n || n < 0 || n > r) && (n = r);

      for (var o = "", i = e; i < n; ++i) {
        o += N(t[i]);
      }

      return o;
    }

    function x(t, e, n) {
      for (var r = t.slice(e, n), o = "", i = 0; i < r.length; i += 2) {
        o += String.fromCharCode(r[i] + 256 * r[i + 1]);
      }

      return o;
    }

    function O(t, e, n) {
      if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
      if (t + e > n) throw new RangeError("Trying to access beyond buffer length");
    }

    function S(t, e, n, r, o, i) {
      if (!c.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (e > o || e < i) throw new RangeError('"value" argument is out of bounds');
      if (n + r > t.length) throw new RangeError("Index out of range");
    }

    function R(t, e, n, r) {
      e < 0 && (e = 65535 + e + 1);

      for (var o = 0, i = Math.min(t.length - n, 2); o < i; ++o) {
        t[n + o] = (e & 255 << 8 * (r ? o : 1 - o)) >>> 8 * (r ? o : 1 - o);
      }
    }

    function B(t, e, n, r) {
      e < 0 && (e = 4294967295 + e + 1);

      for (var o = 0, i = Math.min(t.length - n, 4); o < i; ++o) {
        t[n + o] = e >>> 8 * (r ? o : 3 - o) & 255;
      }
    }

    function I(t, e, n, r, o, i) {
      if (n + r > t.length) throw new RangeError("Index out of range");
      if (n < 0) throw new RangeError("Index out of range");
    }

    function D(t, e, n, r, i) {
      return i || I(t, 0, n, 4), o.write(t, e, n, r, 23, 4), n + 4;
    }

    function M(t, e, n, r, i) {
      return i || I(t, 0, n, 8), o.write(t, e, n, r, 52, 8), n + 8;
    }

    c.prototype.slice = function (t, e) {
      var n,
          r = this.length;
      if ((t = ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), (e = void 0 === e ? r : ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), e < t && (e = t), c.TYPED_ARRAY_SUPPORT) (n = this.subarray(t, e)).__proto__ = c.prototype;else {
        var o = e - t;
        n = new c(o, void 0);

        for (var i = 0; i < o; ++i) {
          n[i] = this[i + t];
        }
      }
      return n;
    }, c.prototype.readUIntLE = function (t, e, n) {
      t |= 0, e |= 0, n || O(t, e, this.length);

      for (var r = this[t], o = 1, i = 0; ++i < e && (o *= 256);) {
        r += this[t + i] * o;
      }

      return r;
    }, c.prototype.readUIntBE = function (t, e, n) {
      t |= 0, e |= 0, n || O(t, e, this.length);

      for (var r = this[t + --e], o = 1; e > 0 && (o *= 256);) {
        r += this[t + --e] * o;
      }

      return r;
    }, c.prototype.readUInt8 = function (t, e) {
      return e || O(t, 1, this.length), this[t];
    }, c.prototype.readUInt16LE = function (t, e) {
      return e || O(t, 2, this.length), this[t] | this[t + 1] << 8;
    }, c.prototype.readUInt16BE = function (t, e) {
      return e || O(t, 2, this.length), this[t] << 8 | this[t + 1];
    }, c.prototype.readUInt32LE = function (t, e) {
      return e || O(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3];
    }, c.prototype.readUInt32BE = function (t, e) {
      return e || O(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
    }, c.prototype.readIntLE = function (t, e, n) {
      t |= 0, e |= 0, n || O(t, e, this.length);

      for (var r = this[t], o = 1, i = 0; ++i < e && (o *= 256);) {
        r += this[t + i] * o;
      }

      return r >= (o *= 128) && (r -= Math.pow(2, 8 * e)), r;
    }, c.prototype.readIntBE = function (t, e, n) {
      t |= 0, e |= 0, n || O(t, e, this.length);

      for (var r = e, o = 1, i = this[t + --r]; r > 0 && (o *= 256);) {
        i += this[t + --r] * o;
      }

      return i >= (o *= 128) && (i -= Math.pow(2, 8 * e)), i;
    }, c.prototype.readInt8 = function (t, e) {
      return e || O(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t];
    }, c.prototype.readInt16LE = function (t, e) {
      e || O(t, 2, this.length);
      var n = this[t] | this[t + 1] << 8;
      return 32768 & n ? 4294901760 | n : n;
    }, c.prototype.readInt16BE = function (t, e) {
      e || O(t, 2, this.length);
      var n = this[t + 1] | this[t] << 8;
      return 32768 & n ? 4294901760 | n : n;
    }, c.prototype.readInt32LE = function (t, e) {
      return e || O(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
    }, c.prototype.readInt32BE = function (t, e) {
      return e || O(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
    }, c.prototype.readFloatLE = function (t, e) {
      return e || O(t, 4, this.length), o.read(this, t, !0, 23, 4);
    }, c.prototype.readFloatBE = function (t, e) {
      return e || O(t, 4, this.length), o.read(this, t, !1, 23, 4);
    }, c.prototype.readDoubleLE = function (t, e) {
      return e || O(t, 8, this.length), o.read(this, t, !0, 52, 8);
    }, c.prototype.readDoubleBE = function (t, e) {
      return e || O(t, 8, this.length), o.read(this, t, !1, 52, 8);
    }, c.prototype.writeUIntLE = function (t, e, n, r) {
      (t = +t, e |= 0, n |= 0, r) || S(this, t, e, n, Math.pow(2, 8 * n) - 1, 0);
      var o = 1,
          i = 0;

      for (this[e] = 255 & t; ++i < n && (o *= 256);) {
        this[e + i] = t / o & 255;
      }

      return e + n;
    }, c.prototype.writeUIntBE = function (t, e, n, r) {
      (t = +t, e |= 0, n |= 0, r) || S(this, t, e, n, Math.pow(2, 8 * n) - 1, 0);
      var o = n - 1,
          i = 1;

      for (this[e + o] = 255 & t; --o >= 0 && (i *= 256);) {
        this[e + o] = t / i & 255;
      }

      return e + n;
    }, c.prototype.writeUInt8 = function (t, e, n) {
      return t = +t, e |= 0, n || S(this, t, e, 1, 255, 0), c.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1;
    }, c.prototype.writeUInt16LE = function (t, e, n) {
      return t = +t, e |= 0, n || S(this, t, e, 2, 65535, 0), c.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : R(this, t, e, !0), e + 2;
    }, c.prototype.writeUInt16BE = function (t, e, n) {
      return t = +t, e |= 0, n || S(this, t, e, 2, 65535, 0), c.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : R(this, t, e, !1), e + 2;
    }, c.prototype.writeUInt32LE = function (t, e, n) {
      return t = +t, e |= 0, n || S(this, t, e, 4, 4294967295, 0), c.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : B(this, t, e, !0), e + 4;
    }, c.prototype.writeUInt32BE = function (t, e, n) {
      return t = +t, e |= 0, n || S(this, t, e, 4, 4294967295, 0), c.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : B(this, t, e, !1), e + 4;
    }, c.prototype.writeIntLE = function (t, e, n, r) {
      if (t = +t, e |= 0, !r) {
        var o = Math.pow(2, 8 * n - 1);
        S(this, t, e, n, o - 1, -o);
      }

      var i = 0,
          s = 1,
          a = 0;

      for (this[e] = 255 & t; ++i < n && (s *= 256);) {
        t < 0 && 0 === a && 0 !== this[e + i - 1] && (a = 1), this[e + i] = (t / s >> 0) - a & 255;
      }

      return e + n;
    }, c.prototype.writeIntBE = function (t, e, n, r) {
      if (t = +t, e |= 0, !r) {
        var o = Math.pow(2, 8 * n - 1);
        S(this, t, e, n, o - 1, -o);
      }

      var i = n - 1,
          s = 1,
          a = 0;

      for (this[e + i] = 255 & t; --i >= 0 && (s *= 256);) {
        t < 0 && 0 === a && 0 !== this[e + i + 1] && (a = 1), this[e + i] = (t / s >> 0) - a & 255;
      }

      return e + n;
    }, c.prototype.writeInt8 = function (t, e, n) {
      return t = +t, e |= 0, n || S(this, t, e, 1, 127, -128), c.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1;
    }, c.prototype.writeInt16LE = function (t, e, n) {
      return t = +t, e |= 0, n || S(this, t, e, 2, 32767, -32768), c.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : R(this, t, e, !0), e + 2;
    }, c.prototype.writeInt16BE = function (t, e, n) {
      return t = +t, e |= 0, n || S(this, t, e, 2, 32767, -32768), c.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : R(this, t, e, !1), e + 2;
    }, c.prototype.writeInt32LE = function (t, e, n) {
      return t = +t, e |= 0, n || S(this, t, e, 4, 2147483647, -2147483648), c.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : B(this, t, e, !0), e + 4;
    }, c.prototype.writeInt32BE = function (t, e, n) {
      return t = +t, e |= 0, n || S(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), c.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : B(this, t, e, !1), e + 4;
    }, c.prototype.writeFloatLE = function (t, e, n) {
      return D(this, t, e, !0, n);
    }, c.prototype.writeFloatBE = function (t, e, n) {
      return D(this, t, e, !1, n);
    }, c.prototype.writeDoubleLE = function (t, e, n) {
      return M(this, t, e, !0, n);
    }, c.prototype.writeDoubleBE = function (t, e, n) {
      return M(this, t, e, !1, n);
    }, c.prototype.copy = function (t, e, n, r) {
      if (n || (n = 0), r || 0 === r || (r = this.length), e >= t.length && (e = t.length), e || (e = 0), r > 0 && r < n && (r = n), r === n) return 0;
      if (0 === t.length || 0 === this.length) return 0;
      if (e < 0) throw new RangeError("targetStart out of bounds");
      if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
      if (r < 0) throw new RangeError("sourceEnd out of bounds");
      r > this.length && (r = this.length), t.length - e < r - n && (r = t.length - e + n);
      var o,
          i = r - n;
      if (this === t && n < e && e < r) for (o = i - 1; o >= 0; --o) {
        t[o + e] = this[o + n];
      } else if (i < 1e3 || !c.TYPED_ARRAY_SUPPORT) for (o = 0; o < i; ++o) {
        t[o + e] = this[o + n];
      } else Uint8Array.prototype.set.call(t, this.subarray(n, n + i), e);
      return i;
    }, c.prototype.fill = function (t, e, n, r) {
      if ("string" == typeof t) {
        if ("string" == typeof e ? (r = e, e = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), 1 === t.length) {
          var o = t.charCodeAt(0);
          o < 256 && (t = o);
        }

        if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
        if ("string" == typeof r && !c.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
      } else "number" == typeof t && (t &= 255);

      if (e < 0 || this.length < e || this.length < n) throw new RangeError("Out of range index");
      if (n <= e) return this;
      var i;
      if (e >>>= 0, n = void 0 === n ? this.length : n >>> 0, t || (t = 0), "number" == typeof t) for (i = e; i < n; ++i) {
        this[i] = t;
      } else {
        var s = c.isBuffer(t) ? t : L(new c(t, r).toString()),
            a = s.length;

        for (i = 0; i < n - e; ++i) {
          this[i + e] = s[i % a];
        }
      }
      return this;
    };
    var U = /[^+\/0-9A-Za-z-_]/g;

    function N(t) {
      return t < 16 ? "0" + t.toString(16) : t.toString(16);
    }

    function L(t, e) {
      var n;
      e = e || 1 / 0;

      for (var r = t.length, o = null, i = [], s = 0; s < r; ++s) {
        if ((n = t.charCodeAt(s)) > 55295 && n < 57344) {
          if (!o) {
            if (n > 56319) {
              (e -= 3) > -1 && i.push(239, 191, 189);
              continue;
            }

            if (s + 1 === r) {
              (e -= 3) > -1 && i.push(239, 191, 189);
              continue;
            }

            o = n;
            continue;
          }

          if (n < 56320) {
            (e -= 3) > -1 && i.push(239, 191, 189), o = n;
            continue;
          }

          n = 65536 + (o - 55296 << 10 | n - 56320);
        } else o && (e -= 3) > -1 && i.push(239, 191, 189);

        if (o = null, n < 128) {
          if ((e -= 1) < 0) break;
          i.push(n);
        } else if (n < 2048) {
          if ((e -= 2) < 0) break;
          i.push(n >> 6 | 192, 63 & n | 128);
        } else if (n < 65536) {
          if ((e -= 3) < 0) break;
          i.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
        } else {
          if (!(n < 1114112)) throw new Error("Invalid code point");
          if ((e -= 4) < 0) break;
          i.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
        }
      }

      return i;
    }

    function q(t) {
      return r.toByteArray(function (t) {
        if ((t = function (t) {
          return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
        }(t).replace(U, "")).length < 2) return "";

        for (; t.length % 4 != 0;) {
          t += "=";
        }

        return t;
      }(t));
    }

    function H(t, e, n, r) {
      for (var o = 0; o < r && !(o + n >= e.length || o >= t.length); ++o) {
        e[o + n] = t[o];
      }

      return o;
    }
  }).call(this, n(4));
}, function (t, e, n) {
  var r = n(50);

  t.exports = function (t) {
    var e = t.xdomain,
        n = t.xscheme,
        o = t.enablesXDR;

    try {
      if ("undefined" != typeof XMLHttpRequest && (!e || r)) return new XMLHttpRequest();
    } catch (t) {}

    try {
      if ("undefined" != typeof XDomainRequest && !n && o) return new XDomainRequest();
    } catch (t) {}

    if (!e) try {
      return new self[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (t) {}
  };
}, function (t, e, n) {
  var r = n(1),
      o = n(0);

  function i(t) {
    this.path = t.path, this.hostname = t.hostname, this.port = t.port, this.secure = t.secure, this.query = t.query, this.timestampParam = t.timestampParam, this.timestampRequests = t.timestampRequests, this.readyState = "", this.agent = t.agent || !1, this.socket = t.socket, this.enablesXDR = t.enablesXDR, this.pfx = t.pfx, this.key = t.key, this.passphrase = t.passphrase, this.cert = t.cert, this.ca = t.ca, this.ciphers = t.ciphers, this.rejectUnauthorized = t.rejectUnauthorized, this.forceNode = t.forceNode, this.isReactNative = t.isReactNative, this.extraHeaders = t.extraHeaders, this.localAddress = t.localAddress;
  }

  t.exports = i, o(i.prototype), i.prototype.onError = function (t, e) {
    var n = new Error(t);
    return n.type = "TransportError", n.description = e, this.emit("error", n), this;
  }, i.prototype.open = function () {
    return "closed" !== this.readyState && "" !== this.readyState || (this.readyState = "opening", this.doOpen()), this;
  }, i.prototype.close = function () {
    return "opening" !== this.readyState && "open" !== this.readyState || (this.doClose(), this.onClose()), this;
  }, i.prototype.send = function (t) {
    if ("open" !== this.readyState) throw new Error("Transport not open");
    this.write(t);
  }, i.prototype.onOpen = function () {
    this.readyState = "open", this.writable = !0, this.emit("open");
  }, i.prototype.onData = function (t) {
    var e = r.decodePacket(t, this.socket.binaryType);
    this.onPacket(e);
  }, i.prototype.onPacket = function (t) {
    this.emit("packet", t);
  }, i.prototype.onClose = function () {
    this.readyState = "closed", this.emit("close");
  };
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  e.default = new (
  /*#__PURE__*/
  function () {
    function _class2() {
      _classCallCheck(this, _class2);

      this.debug = 0, this.checkDebugStatus();
    }

    _createClass(_class2, [{
      key: "checkDebugStatus",
      value: function checkDebugStatus() {
        return "object" == typeof window && (this.debug = new URLSearchParams(window.location.search).has("debug")), this.debug;
      }
    }, {
      key: "log",
      value: function log() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var n = t;
        return e > 1 && (n = new Error().stack), this.debug && console.log(n), n;
      }
    }, {
      key: "error",
      value: function error() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        return this.log(t, 2);
      }
    }]);

    return _class2;
  }())();
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  e.HTTP =
  /*#__PURE__*/
  function () {
    function _class3() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, _class3);

      this.config = t;
    }

    _createClass(_class3, [{
      key: "request",
      value: function request() {
        var _this = this;

        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new Promise(function (n, r) {
          var o;

          var i = _this.getFetchData(e);

          fetch(t, i).then(function (t) {
            o = _this.headersToObject(t.headers);
            var e = null;
            return e = t.ok ? 202 === t.status || 401 === t.status ? new Promise(function (t) {
              return t({});
            }) : t.json() : new Promise(function (e, n) {
              return n(t.statusText);
            });
          }).then(function (t) {
            n({
              data: t,
              headers: o
            });
          }).catch(function (t) {
            return r(t);
          });
        });
      }
    }, {
      key: "headersToObject",
      value: function headersToObject(t) {
        var e = {};
        return t && t.entries && t.forEach(function (t, n) {
          e[n] = t;
        }), e;
      }
    }, {
      key: "getFetchData",
      value: function getFetchData() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = this.config.fetchProps;
        return e.method = this.config.method, e.headers = new Headers(Object.assign(t.headers || {}, this.config.headers)), ["POST"].indexOf(this.config.method) > -1 && (e.body = JSON.stringify(t)), e;
      }
    }]);

    return _class3;
  }();
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Socket = void 0;

  var r,
      o = n(37),
      i = (r = o) && r.__esModule ? r : {
    default: r
  },
      s = function (t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for (var n in t) {
      if (Object.prototype.hasOwnProperty.call(t, n)) {
        var r = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(t, n) : {};
        r.get || r.set ? Object.defineProperty(e, n, r) : e[n] = t[n];
      }
    }
    return e.default = t, e;
  }(n(2));

  e.Socket =
  /*#__PURE__*/
  function () {
    function _class4() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

      _classCallCheck(this, _class4);

      if (!e || "" === e) return s.logger.log("Cannot validate Socket url");
      this.config = t, this.url = e, this.connect(e);
    }

    _createClass(_class4, [{
      key: "request",
      value: function request() {
        var _this2 = this;

        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new Promise(function (n) {
          var r = t.replace(_this2.url, "");
          if (_this2.connecting) _this2.retryRequest(r, e).then(function (t) {
            return n(t);
          });else {
            if (!_this2.connection) return _this2.connect(r).then(function () {
              _this2.send(r, e).then(function (t) {
                return n(t);
              });
            });
            if (_this2.connection.connected) return _this2.send(r, e).then(function (t) {
              return n(t);
            });
          }
          return !1;
        });
      }
    }, {
      key: "retryRequest",
      value: function retryRequest() {
        var _this3 = this;

        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new Promise(function (n) {
          var r = setInterval(function () {
            return _this3.connection.connected && (clearInterval(r), _this3.send(t, e).then(function (t) {
              return n(t);
            })), !1;
          }, 1e3);
        });
      }
    }, {
      key: "connect",
      value: function connect() {
        var _this4 = this;

        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        return new Promise(function (e, n) {
          _this4.config && "token" in _this4.config ? (_this4.connection = (0, i.default)(t, {
            query: {
              token: _this4.config.token
            }
          }), _this4.connecting = !0, _this4.connection.on("connect", function () {
            s.logger.log("Socket connected"), _this4.connecting = !1;
          }), _this4.connection.on("disconnect", function () {
            s.logger.log("Socket Connection Closed");
          }), _this4.connection.on("error", function () {
            n(_this4.connection), s.logger.log("Socket Connection Error");
          }), e(_this4.connection)) : n(Error("No token found"));
        });
      }
    }, {
      key: "onEvent",
      value: function onEvent() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.connection ? this.connection.on(t, e) : s.logger.log("No active socket connection. Cannot handle event ".concat(t));
      }
    }, {
      key: "send",
      value: function send() {
        var _this5 = this;

        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new Promise(function (n) {
          return _this5.connection.on(t, function (e) {
            n(e), _this5.connection.removeListener(t);
          }), _this5.connection.emit(t, e);
        });
      }
    }]);

    return _class4;
  }();
}, function (t, e) {
  var n = /^(?:(?![^:@]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
      r = ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"];

  t.exports = function (t) {
    var e = t,
        o = t.indexOf("["),
        i = t.indexOf("]");
    -1 != o && -1 != i && (t = t.substring(0, o) + t.substring(o, i).replace(/:/g, ";") + t.substring(i, t.length));

    for (var s = n.exec(t || ""), a = {}, c = 14; c--;) {
      a[r[c]] = s[c] || "";
    }

    return -1 != o && -1 != i && (a.source = e, a.host = a.host.substring(1, a.host.length - 1).replace(/;/g, ":"), a.authority = a.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), a.ipv6uri = !0), a;
  };
}, function (t, e) {
  var n = {}.toString;

  t.exports = Array.isArray || function (t) {
    return "[object Array]" == n.call(t);
  };
}, function (t, e, n) {
  (function (e) {
    t.exports = function (t) {
      return n && e.isBuffer(t) || r && (t instanceof ArrayBuffer || o(t));
    };

    var n = "function" == typeof e && "function" == typeof e.isBuffer,
        r = "function" == typeof ArrayBuffer,
        o = function o(t) {
      return "function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(t) : t.buffer instanceof ArrayBuffer;
    };
  }).call(this, n(12).Buffer);
}, function (t, e, n) {
  var r = n(48),
      o = n(27),
      i = n(0),
      s = n(11),
      a = n(28),
      c = n(29),
      u = n(6)("socket.io-client:manager"),
      l = n(26),
      f = n(65),
      h = Object.prototype.hasOwnProperty;

  function p(t, e) {
    if (!(this instanceof p)) return new p(t, e);
    t && "object" == typeof t && (e = t, t = void 0), (e = e || {}).path = e.path || "/socket.io", this.nsps = {}, this.subs = [], this.opts = e, this.reconnection(!1 !== e.reconnection), this.reconnectionAttempts(e.reconnectionAttempts || 1 / 0), this.reconnectionDelay(e.reconnectionDelay || 1e3), this.reconnectionDelayMax(e.reconnectionDelayMax || 5e3), this.randomizationFactor(e.randomizationFactor || .5), this.backoff = new f({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    }), this.timeout(null == e.timeout ? 2e4 : e.timeout), this.readyState = "closed", this.uri = t, this.connecting = [], this.lastPing = null, this.encoding = !1, this.packetBuffer = [];
    var n = e.parser || s;
    this.encoder = new n.Encoder(), this.decoder = new n.Decoder(), this.autoConnect = !1 !== e.autoConnect, this.autoConnect && this.open();
  }

  t.exports = p, p.prototype.emitAll = function () {
    for (var t in this.emit.apply(this, arguments), this.nsps) {
      h.call(this.nsps, t) && this.nsps[t].emit.apply(this.nsps[t], arguments);
    }
  }, p.prototype.updateSocketIds = function () {
    for (var t in this.nsps) {
      h.call(this.nsps, t) && (this.nsps[t].id = this.generateId(t));
    }
  }, p.prototype.generateId = function (t) {
    return ("/" === t ? "" : t + "#") + this.engine.id;
  }, i(p.prototype), p.prototype.reconnection = function (t) {
    return arguments.length ? (this._reconnection = !!t, this) : this._reconnection;
  }, p.prototype.reconnectionAttempts = function (t) {
    return arguments.length ? (this._reconnectionAttempts = t, this) : this._reconnectionAttempts;
  }, p.prototype.reconnectionDelay = function (t) {
    return arguments.length ? (this._reconnectionDelay = t, this.backoff && this.backoff.setMin(t), this) : this._reconnectionDelay;
  }, p.prototype.randomizationFactor = function (t) {
    return arguments.length ? (this._randomizationFactor = t, this.backoff && this.backoff.setJitter(t), this) : this._randomizationFactor;
  }, p.prototype.reconnectionDelayMax = function (t) {
    return arguments.length ? (this._reconnectionDelayMax = t, this.backoff && this.backoff.setMax(t), this) : this._reconnectionDelayMax;
  }, p.prototype.timeout = function (t) {
    return arguments.length ? (this._timeout = t, this) : this._timeout;
  }, p.prototype.maybeReconnectOnOpen = function () {
    !this.reconnecting && this._reconnection && 0 === this.backoff.attempts && this.reconnect();
  }, p.prototype.open = p.prototype.connect = function (t, e) {
    if (u("readyState %s", this.readyState), ~this.readyState.indexOf("open")) return this;
    u("opening %s", this.uri), this.engine = r(this.uri, this.opts);
    var n = this.engine,
        o = this;
    this.readyState = "opening", this.skipReconnect = !1;
    var i = a(n, "open", function () {
      o.onopen(), t && t();
    }),
        s = a(n, "error", function (e) {
      if (u("connect_error"), o.cleanup(), o.readyState = "closed", o.emitAll("connect_error", e), t) {
        var n = new Error("Connection error");
        n.data = e, t(n);
      } else o.maybeReconnectOnOpen();
    });

    if (!1 !== this._timeout) {
      var c = this._timeout;
      u("connect attempt will timeout after %d", c);
      var l = setTimeout(function () {
        u("connect attempt timed out after %d", c), i.destroy(), n.close(), n.emit("error", "timeout"), o.emitAll("connect_timeout", c);
      }, c);
      this.subs.push({
        destroy: function destroy() {
          clearTimeout(l);
        }
      });
    }

    return this.subs.push(i), this.subs.push(s), this;
  }, p.prototype.onopen = function () {
    u("open"), this.cleanup(), this.readyState = "open", this.emit("open");
    var t = this.engine;
    this.subs.push(a(t, "data", c(this, "ondata"))), this.subs.push(a(t, "ping", c(this, "onping"))), this.subs.push(a(t, "pong", c(this, "onpong"))), this.subs.push(a(t, "error", c(this, "onerror"))), this.subs.push(a(t, "close", c(this, "onclose"))), this.subs.push(a(this.decoder, "decoded", c(this, "ondecoded")));
  }, p.prototype.onping = function () {
    this.lastPing = new Date(), this.emitAll("ping");
  }, p.prototype.onpong = function () {
    this.emitAll("pong", new Date() - this.lastPing);
  }, p.prototype.ondata = function (t) {
    this.decoder.add(t);
  }, p.prototype.ondecoded = function (t) {
    this.emit("packet", t);
  }, p.prototype.onerror = function (t) {
    u("error", t), this.emitAll("error", t);
  }, p.prototype.socket = function (t, e) {
    var n = this.nsps[t];

    if (!n) {
      n = new o(this, t, e), this.nsps[t] = n;
      var r = this;
      n.on("connecting", i), n.on("connect", function () {
        n.id = r.generateId(t);
      }), this.autoConnect && i();
    }

    function i() {
      ~l(r.connecting, n) || r.connecting.push(n);
    }

    return n;
  }, p.prototype.destroy = function (t) {
    var e = l(this.connecting, t);
    ~e && this.connecting.splice(e, 1), this.connecting.length || this.close();
  }, p.prototype.packet = function (t) {
    u("writing packet %j", t);
    var e = this;
    t.query && 0 === t.type && (t.nsp += "?" + t.query), e.encoding ? e.packetBuffer.push(t) : (e.encoding = !0, this.encoder.encode(t, function (n) {
      for (var r = 0; r < n.length; r++) {
        e.engine.write(n[r], t.options);
      }

      e.encoding = !1, e.processPacketQueue();
    }));
  }, p.prototype.processPacketQueue = function () {
    if (this.packetBuffer.length > 0 && !this.encoding) {
      var t = this.packetBuffer.shift();
      this.packet(t);
    }
  }, p.prototype.cleanup = function () {
    u("cleanup");

    for (var t = this.subs.length, e = 0; e < t; e++) {
      this.subs.shift().destroy();
    }

    this.packetBuffer = [], this.encoding = !1, this.lastPing = null, this.decoder.destroy();
  }, p.prototype.close = p.prototype.disconnect = function () {
    u("disconnect"), this.skipReconnect = !0, this.reconnecting = !1, "opening" === this.readyState && this.cleanup(), this.backoff.reset(), this.readyState = "closed", this.engine && this.engine.close();
  }, p.prototype.onclose = function (t) {
    u("onclose"), this.cleanup(), this.backoff.reset(), this.readyState = "closed", this.emit("close", t), this._reconnection && !this.skipReconnect && this.reconnect();
  }, p.prototype.reconnect = function () {
    if (this.reconnecting || this.skipReconnect) return this;
    var t = this;
    if (this.backoff.attempts >= this._reconnectionAttempts) u("reconnect failed"), this.backoff.reset(), this.emitAll("reconnect_failed"), this.reconnecting = !1;else {
      var e = this.backoff.duration();
      u("will wait %dms before reconnect attempt", e), this.reconnecting = !0;
      var n = setTimeout(function () {
        t.skipReconnect || (u("attempting reconnect"), t.emitAll("reconnect_attempt", t.backoff.attempts), t.emitAll("reconnecting", t.backoff.attempts), t.skipReconnect || t.open(function (e) {
          e ? (u("reconnect attempt error"), t.reconnecting = !1, t.reconnect(), t.emitAll("reconnect_error", e.data)) : (u("reconnect success"), t.onreconnect());
        }));
      }, e);
      this.subs.push({
        destroy: function destroy() {
          clearTimeout(n);
        }
      });
    }
  }, p.prototype.onreconnect = function () {
    var t = this.backoff.attempts;
    this.reconnecting = !1, this.backoff.reset(), this.updateSocketIds(), this.emitAll("reconnect", t);
  };
}, function (t, e, n) {
  var r = n(13),
      o = n(51),
      i = n(61),
      s = n(62);
  e.polling = function (t) {
    var e = !1,
        n = !1,
        s = !1 !== t.jsonp;

    if ("undefined" != typeof location) {
      var a = "https:" === location.protocol,
          c = location.port;
      c || (c = a ? 443 : 80), e = t.hostname !== location.hostname || c !== t.port, n = t.secure !== a;
    }

    if (t.xdomain = e, t.xscheme = n, "open" in new r(t) && !t.forceJSONP) return new o(t);
    if (!s) throw new Error("JSONP disabled");
    return new i(t);
  }, e.websocket = s;
}, function (t, e, n) {
  var r = n(14),
      o = n(7),
      i = n(1),
      s = n(8),
      a = n(25),
      c = n(9)("engine.io-client:polling");
  t.exports = l;
  var u = null != new (n(13))({
    xdomain: !1
  }).responseType;

  function l(t) {
    var e = t && t.forceBase64;
    u && !e || (this.supportsBinary = !1), r.call(this, t);
  }

  s(l, r), l.prototype.name = "polling", l.prototype.doOpen = function () {
    this.poll();
  }, l.prototype.pause = function (t) {
    var e = this;

    function n() {
      c("paused"), e.readyState = "paused", t();
    }

    if (this.readyState = "pausing", this.polling || !this.writable) {
      var r = 0;
      this.polling && (c("we are currently polling - waiting to pause"), r++, this.once("pollComplete", function () {
        c("pre-pause polling complete"), --r || n();
      })), this.writable || (c("we are currently writing - waiting to pause"), r++, this.once("drain", function () {
        c("pre-pause writing complete"), --r || n();
      }));
    } else n();
  }, l.prototype.poll = function () {
    c("polling"), this.polling = !0, this.doPoll(), this.emit("poll");
  }, l.prototype.onData = function (t) {
    var e = this;
    c("polling got data %s", t);
    i.decodePayload(t, this.socket.binaryType, function (t, n, r) {
      if ("opening" === e.readyState && e.onOpen(), "close" === t.type) return e.onClose(), !1;
      e.onPacket(t);
    }), "closed" !== this.readyState && (this.polling = !1, this.emit("pollComplete"), "open" === this.readyState ? this.poll() : c('ignoring poll - transport state "%s"', this.readyState));
  }, l.prototype.doClose = function () {
    var t = this;

    function e() {
      c("writing close packet"), t.write([{
        type: "close"
      }]);
    }

    "open" === this.readyState ? (c("transport open - closing"), e()) : (c("transport not open - deferring close"), this.once("open", e));
  }, l.prototype.write = function (t) {
    var e = this;
    this.writable = !1;

    var n = function n() {
      e.writable = !0, e.emit("drain");
    };

    i.encodePayload(t, this.supportsBinary, function (t) {
      e.doWrite(t, n);
    });
  }, l.prototype.uri = function () {
    var t = this.query || {},
        e = this.secure ? "https" : "http",
        n = "";
    return !1 !== this.timestampRequests && (t[this.timestampParam] = a()), this.supportsBinary || t.sid || (t.b64 = 1), t = o.encode(t), this.port && ("https" === e && 443 !== Number(this.port) || "http" === e && 80 !== Number(this.port)) && (n = ":" + this.port), t.length && (t = "?" + t), e + "://" + (-1 !== this.hostname.indexOf(":") ? "[" + this.hostname + "]" : this.hostname) + n + this.path + t;
  };
}, function (t, e, n) {
  (function (e) {
    var r = n(53),
        o = Object.prototype.toString,
        i = "function" == typeof Blob || "undefined" != typeof Blob && "[object BlobConstructor]" === o.call(Blob),
        s = "function" == typeof File || "undefined" != typeof File && "[object FileConstructor]" === o.call(File);

    t.exports = function t(n) {
      if (!n || "object" != typeof n) return !1;

      if (r(n)) {
        for (var o = 0, a = n.length; o < a; o++) {
          if (t(n[o])) return !0;
        }

        return !1;
      }

      if ("function" == typeof e && e.isBuffer && e.isBuffer(n) || "function" == typeof ArrayBuffer && n instanceof ArrayBuffer || i && n instanceof Blob || s && n instanceof File) return !0;
      if (n.toJSON && "function" == typeof n.toJSON && 1 === arguments.length) return t(n.toJSON(), !0);

      for (var c in n) {
        if (Object.prototype.hasOwnProperty.call(n, c) && t(n[c])) return !0;
      }

      return !1;
    };
  }).call(this, n(12).Buffer);
}, function (t, e, n) {
  "use strict";

  var r,
      o = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""),
      i = 64,
      s = {},
      a = 0,
      c = 0;

  function u(t) {
    var e = "";

    do {
      e = o[t % i] + e, t = Math.floor(t / i);
    } while (t > 0);

    return e;
  }

  function l() {
    var t = u(+new Date());
    return t !== r ? (a = 0, r = t) : t + "." + u(a++);
  }

  for (; c < i; c++) {
    s[o[c]] = c;
  }

  l.encode = u, l.decode = function (t) {
    var e = 0;

    for (c = 0; c < t.length; c++) {
      e = e * i + s[t.charAt(c)];
    }

    return e;
  }, t.exports = l;
}, function (t, e) {
  var n = [].indexOf;

  t.exports = function (t, e) {
    if (n) return t.indexOf(e);

    for (var r = 0; r < t.length; ++r) {
      if (t[r] === e) return r;
    }

    return -1;
  };
}, function (t, e, n) {
  var r = n(11),
      o = n(0),
      i = n(64),
      s = n(28),
      a = n(29),
      c = n(6)("socket.io-client:socket"),
      u = n(7),
      l = n(24);
  t.exports = p;
  var f = {
    connect: 1,
    connect_error: 1,
    connect_timeout: 1,
    connecting: 1,
    disconnect: 1,
    error: 1,
    reconnect: 1,
    reconnect_attempt: 1,
    reconnect_failed: 1,
    reconnect_error: 1,
    reconnecting: 1,
    ping: 1,
    pong: 1
  },
      h = o.prototype.emit;

  function p(t, e, n) {
    this.io = t, this.nsp = e, this.json = this, this.ids = 0, this.acks = {}, this.receiveBuffer = [], this.sendBuffer = [], this.connected = !1, this.disconnected = !0, this.flags = {}, n && n.query && (this.query = n.query), this.io.autoConnect && this.open();
  }

  o(p.prototype), p.prototype.subEvents = function () {
    if (!this.subs) {
      var t = this.io;
      this.subs = [s(t, "open", a(this, "onopen")), s(t, "packet", a(this, "onpacket")), s(t, "close", a(this, "onclose"))];
    }
  }, p.prototype.open = p.prototype.connect = function () {
    return this.connected ? this : (this.subEvents(), this.io.open(), "open" === this.io.readyState && this.onopen(), this.emit("connecting"), this);
  }, p.prototype.send = function () {
    var t = i(arguments);
    return t.unshift("message"), this.emit.apply(this, t), this;
  }, p.prototype.emit = function (t) {
    if (f.hasOwnProperty(t)) return h.apply(this, arguments), this;
    var e = i(arguments),
        n = {
      type: (void 0 !== this.flags.binary ? this.flags.binary : l(e)) ? r.BINARY_EVENT : r.EVENT,
      data: e,
      options: {}
    };
    return n.options.compress = !this.flags || !1 !== this.flags.compress, "function" == typeof e[e.length - 1] && (c("emitting packet with ack id %d", this.ids), this.acks[this.ids] = e.pop(), n.id = this.ids++), this.connected ? this.packet(n) : this.sendBuffer.push(n), this.flags = {}, this;
  }, p.prototype.packet = function (t) {
    t.nsp = this.nsp, this.io.packet(t);
  }, p.prototype.onopen = function () {
    if (c("transport is open - connecting"), "/" !== this.nsp) if (this.query) {
      var t = "object" == typeof this.query ? u.encode(this.query) : this.query;
      c("sending connect packet with query %s", t), this.packet({
        type: r.CONNECT,
        query: t
      });
    } else this.packet({
      type: r.CONNECT
    });
  }, p.prototype.onclose = function (t) {
    c("close (%s)", t), this.connected = !1, this.disconnected = !0, delete this.id, this.emit("disconnect", t);
  }, p.prototype.onpacket = function (t) {
    var e = t.nsp === this.nsp,
        n = t.type === r.ERROR && "/" === t.nsp;
    if (e || n) switch (t.type) {
      case r.CONNECT:
        this.onconnect();
        break;

      case r.EVENT:
      case r.BINARY_EVENT:
        this.onevent(t);
        break;

      case r.ACK:
      case r.BINARY_ACK:
        this.onack(t);
        break;

      case r.DISCONNECT:
        this.ondisconnect();
        break;

      case r.ERROR:
        this.emit("error", t.data);
    }
  }, p.prototype.onevent = function (t) {
    var e = t.data || [];
    c("emitting event %j", e), null != t.id && (c("attaching ack callback to event"), e.push(this.ack(t.id))), this.connected ? h.apply(this, e) : this.receiveBuffer.push(e);
  }, p.prototype.ack = function (t) {
    var e = this,
        n = !1;
    return function () {
      if (!n) {
        n = !0;
        var o = i(arguments);
        c("sending ack %j", o), e.packet({
          type: l(o) ? r.BINARY_ACK : r.ACK,
          id: t,
          data: o
        });
      }
    };
  }, p.prototype.onack = function (t) {
    var e = this.acks[t.id];
    "function" == typeof e ? (c("calling ack %s with %j", t.id, t.data), e.apply(this, t.data), delete this.acks[t.id]) : c("bad ack %s", t.id);
  }, p.prototype.onconnect = function () {
    this.connected = !0, this.disconnected = !1, this.emit("connect"), this.emitBuffered();
  }, p.prototype.emitBuffered = function () {
    var t;

    for (t = 0; t < this.receiveBuffer.length; t++) {
      h.apply(this, this.receiveBuffer[t]);
    }

    for (this.receiveBuffer = [], t = 0; t < this.sendBuffer.length; t++) {
      this.packet(this.sendBuffer[t]);
    }

    this.sendBuffer = [];
  }, p.prototype.ondisconnect = function () {
    c("server disconnect (%s)", this.nsp), this.destroy(), this.onclose("io server disconnect");
  }, p.prototype.destroy = function () {
    if (this.subs) {
      for (var t = 0; t < this.subs.length; t++) {
        this.subs[t].destroy();
      }

      this.subs = null;
    }

    this.io.destroy(this);
  }, p.prototype.close = p.prototype.disconnect = function () {
    return this.connected && (c("performing disconnect (%s)", this.nsp), this.packet({
      type: r.DISCONNECT
    })), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
  }, p.prototype.compress = function (t) {
    return this.flags.compress = t, this;
  }, p.prototype.binary = function (t) {
    return this.flags.binary = t, this;
  };
}, function (t, e) {
  t.exports = function (t, e, n) {
    return t.on(e, n), {
      destroy: function destroy() {
        t.removeListener(e, n);
      }
    };
  };
}, function (t, e) {
  var n = [].slice;

  t.exports = function (t, e) {
    if ("string" == typeof e && (e = t[e]), "function" != typeof e) throw new Error("bind() requires a function");
    var r = n.call(arguments, 2);
    return function () {
      return e.apply(t, r.concat(n.call(arguments)));
    };
  };
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.CacheManager = void 0;
  var r = n(66);

  e.CacheManager =
  /*#__PURE__*/
  function () {
    function _class5() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, _class5);

      this.config = t;
    }

    _createClass(_class5, [{
      key: "getCacheData",
      value: function getCacheData() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        return new Promise(function (e, n) {
          r.LocalStorage.get(t).then(function (t) {
            null !== t && t && e(JSON.parse(t)), e({});
          }).catch(function (t) {
            return n(t);
          });
        });
      }
    }, {
      key: "setCacheData",
      value: function setCacheData() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.config.timeout || (this.config.timeout = 0), r.LocalStorage.put(t, JSON.stringify(e), this.config.timeout);
      }
    }, {
      key: "isCacheData",
      value: function isCacheData() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        return r.LocalStorage.keyExists(t).then(function (t) {
          return Promise.resolve(t);
        });
      }
    }, {
      key: "deleteCacheData",
      value: function deleteCacheData() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        r.LocalStorage.removeKey(t);
      }
    }]);

    return _class5;
  }();
}, function (t, e, n) {
  var r = n(68);

  t.exports =
  /*#__PURE__*/
  function () {
    "use strict";

    function _class6(t) {
      _classCallCheck(this, _class6);

      this.persistent = t, this._lootBag = {}, this._timeout = null;
    }

    _createClass(_class6, [{
      key: "get",
      value: function get(t) {
        var _this6 = this;

        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return new r(function (n) {
          if (_this6.persistent) {
            if (t in localStorage) {
              var _r = JSON.parse(localStorage.getItem(t));

              null === _this6._timeout && null === _r.kt ? n(_r.v) : _this6._isCacheStale(_r) ? _this6.removeKey(t).then(function () {
                n(e);
              }) : n(_r.v);
            } else n(e);
          } else t in _this6._lootBag ? null === _this6._timeout && null === _this6._lootBag.kt ? n(_this6._lootBag[t].v) : _this6._isCacheStale(_this6._lootBag[t]) ? _this6.removeKey(t).then(function () {
            n(e);
          }) : n(_this6._lootBag[t].v) : n(e);
        });
      }
    }, {
      key: "put",
      value: function put(t, e) {
        var _this7 = this;

        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        return new r(function (r) {
          var o = {
            v: e,
            t: _this7._getNow(),
            kt: n
          };
          _this7.persistent ? (localStorage.setItem(t, JSON.stringify(o)), r()) : (_this7._lootBag[t] = o, r());
        });
      }
    }, {
      key: "removeKey",
      value: function removeKey(t) {
        var _this8 = this;

        return new r(function (e) {
          _this8.persistent ? t in localStorage && localStorage.removeItem(t) : t in _this8._lootBag && delete _this8._lootBag[t], e();
        });
      }
    }, {
      key: "runGarbageCollector",
      value: function runGarbageCollector() {
        var _this9 = this;

        return new r(function (t) {
          var e = [];

          if (_this9.persistent) {
            var _arr = Object.keys(localStorage);

            for (var _i = 0; _i < _arr.length; _i++) {
              var _t = _arr[_i];

              var _n = JSON.parse(localStorage.getItem(_t));

              null === _this9._timeout && null === _n.kt || _this9._isCacheStale(_n) && (localStorage.removeItem(_t), e.push(_t));
            }
          } else {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = _this9._lootBag[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _t2 = _step.value;
                null === _this9._timeout && null === _this9._lootBag[_t2].kt || _this9._isCacheStale(_this9._lootBag[_t2]) && (delete _this9._lootBag[_t2], e.push(_t2));
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }

          t(e);
        });
      }
    }, {
      key: "keyExists",
      value: function keyExists(t) {
        var _this10 = this;

        return new r(function (e) {
          if (_this10.persistent) {
            if (t in localStorage) {
              var _n2 = JSON.parse(localStorage.getItem(t));

              null === _this10._timeout && null === _n2.kt ? e(!0) : _this10._isCacheStale(_n2) ? _this10.removeKey(t).then(function () {
                e(!1);
              }) : e(!0);
            } else e(!1);
          } else t in _this10._lootBag ? null === _this10._timeout && null === _this10._lootBag.kt ? e(!0) : _this10._isCacheStale(_this10._lootBag[t]) ? (e(!1), _this10.removeKey(t).then(function () {})) : e(!0) : e(!1);
        });
      }
    }, {
      key: "clear",
      value: function clear() {
        var _this11 = this;

        return new r(function (t) {
          _this11.persistent ? (localStorage.clear(), t()) : (_this11._lootBag = {}, t());
        });
      }
    }, {
      key: "keys",
      value: function keys() {
        var _this12 = this;

        return new r(function (t) {
          _this12.persistent ? t(Object.keys(localStorage)) : t(Object.keys(_this12._lootBag));
        });
      }
    }, {
      key: "isLocalStorageAvailable",
      value: function isLocalStorageAvailable() {
        return new r(function (t) {
          var e = new Date().getTime().toString(),
              n = e;

          try {
            localStorage.setItem(e, n), localStorage.removeItem(e), t(!0);
          } catch (e) {
            t(!1);
          }
        });
      }
    }, {
      key: "_getNow",
      value: function _getNow() {
        return parseInt(Date.now() / 1e3, 10);
      }
    }, {
      key: "_isCacheStale",
      value: function _isCacheStale(t) {
        var e = t.t,
            n = null === t.kt ? this._timeout : t.kt;
        return this._getNow() - e > n;
      }
    }, {
      key: "timeoutInSeconds",
      set: function set(t) {
        this._timeout = t;
      },
      get: function get() {
        return this._timeout;
      }
    }]);

    return _class6;
  }();
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = n(5);
  Object.keys(r).forEach(function (t) {
    "default" !== t && "__esModule" !== t && Object.defineProperty(e, t, {
      enumerable: !0,
      get: function get() {
        return r[t];
      }
    });
  });
  var o = n(72);
  Object.keys(o).forEach(function (t) {
    "default" !== t && "__esModule" !== t && Object.defineProperty(e, t, {
      enumerable: !0,
      get: function get() {
        return o[t];
      }
    });
  });
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Repository = void 0;

  var r = function (t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for (var n in t) {
      if (Object.prototype.hasOwnProperty.call(t, n)) {
        var r = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(t, n) : {};
        r.get || r.set ? Object.defineProperty(e, n, r) : e[n] = t[n];
      }
    }
    return e.default = t, e;
  }(n(2)),
      o = n(35),
      i = n(30);

  e.Repository =
  /*#__PURE__*/
  function () {
    function _class7() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, _class7);

      if (!r.validator.validate([{
        object: t
      }])) return r.logger.error("Cannot validate Repository config");
      this.endpoint = new o.Endpoint(t), this.cacheManager = new i.CacheManager(t);
    }

    _createClass(_class7, [{
      key: "getItem",
      value: function getItem() {
        var _this13 = this;

        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = t.concat(JSON.stringify(e));
        return new Promise(function (o, i) {
          _this13.cacheManager.getCacheData(r).then(function (r) {
            "object" != typeof r || Object.keys(r).length < 1 ? _this13.endpoint.executeRequest(t, e, n).then(function (n) {
              _this13.cacheManager.setCacheData(t.concat(JSON.stringify(e)), n), o(n);
            }).catch(function (t) {
              return i(t);
            }) : o(r);
          }).catch(function (t) {
            return i(t);
          });
        });
      }
    }]);

    return _class7;
  }();
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r,
      o = n(15),
      i = (r = o) && r.__esModule ? r : {
    default: r
  };
  e.default = new (
  /*#__PURE__*/
  function () {
    function _class8() {
      _classCallCheck(this, _class8);

      this.logger = i.default;
    }

    _createClass(_class8, [{
      key: "validate",
      value: function validate() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        if (!(null !== t && t.length > 0)) return !1;

        for (var _e = 0; _e < t.length; _e += 1) {
          var _n3 = t[_e],
              _r2 = Object.keys(_n3)[0];
          if (!this.processType(_r2, _n3[_r2])) return !1;
        }

        return !0;
      }
    }, {
      key: "processType",
      value: function processType() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        switch (t) {
          case "string":
            if ("string" != typeof e) return this.logger.log("Parameter is not of type string", 2), !1;
            break;

          case "url":
            if (!/^(ws|wss|ftp|http|https):\/\/[^ "]+$/.test(e)) return this.logger.log("Parameter is not a url", 2), !1;
            break;

          case "object":
            if ("object" != typeof e || null == e) return this.logger.log("Parameter is not of type object", 2), !1;
            break;

          case "array":
            if ("object" != typeof e) return this.logger.log("Parameter is not of type array", 2), !1;
            break;

          default:
            return this.logger.log("Cannot find type for value entered", 2), !1;
        }

        return !0;
      }
    }]);

    return _class8;
  }())();
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = n(36);
  Object.defineProperty(e, "Endpoint", {
    enumerable: !0,
    get: function get() {
      return r.Endpoint;
    }
  });
  var o = n(16);
  Object.defineProperty(e, "HTTP", {
    enumerable: !0,
    get: function get() {
      return o.HTTP;
    }
  });
  var i = n(17);
  Object.defineProperty(e, "Socket", {
    enumerable: !0,
    get: function get() {
      return i.Socket;
    }
  });
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Endpoint = void 0;
  var r = n(16),
      o = n(17);

  e.Endpoint =
  /*#__PURE__*/
  function () {
    function _class9() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, _class9);

      this.config = {}, this.defaultOptions = {
        protocol: "http",
        host: "",
        port: "",
        basePath: "",
        timeout: 15e3,
        method: "GET",
        headers: {},
        fetchProps: {}
      }, this.setConfig(t);
    }

    _createClass(_class9, [{
      key: "get",
      value: function get() {
        return this.endpoint;
      }
    }, {
      key: "setConfig",
      value: function setConfig() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.config = Object.assign(this.defaultOptions, t), this.setEndpointType();
      }
    }, {
      key: "setEndpointType",
      value: function setEndpointType() {
        if (this.config.basePath.indexOf("socket") > -1) {
          var _t3 = this.buildURL();

          this.endpoint = new o.Socket(this.config, _t3);
        } else this.endpoint = new r.HTTP(this.config);
      }
    }, {
      key: "executeRequest",
      value: function executeRequest() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var r = this.buildURL(t, e);
        return this.endpoint.request(r, n);
      }
    }, {
      key: "buildURL",
      value: function buildURL() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var n = this.buildURLArgs(t, e),
            r = this.config.port && ":".concat(this.config.port);
        return "".concat("".concat(this.config.protocol, "://").concat(this.config.host).concat(r), this.config.basePath).concat(n);
      }
    }, {
      key: "buildURLArgs",
      value: function buildURLArgs() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var n = t;

        for (var _r3 = 0; _r3 < Object.keys(e).length; _r3 += 1) {
          var _o = Object.keys(e)[_r3];

          t.indexOf("{".concat(_o, "}")) > -1 && (n = n.replace("{".concat(_o, "}"), e[_o]));
        }

        return n;
      }
    }]);

    return _class9;
  }();
}, function (t, e, n) {
  var r = n(38),
      o = n(11),
      i = n(21),
      s = n(6)("socket.io-client");
  t.exports = e = c;
  var a = e.managers = {};

  function c(t, e) {
    "object" == typeof t && (e = t, t = void 0), e = e || {};
    var n,
        o = r(t),
        c = o.source,
        u = o.id,
        l = o.path,
        f = a[u] && l in a[u].nsps;
    return e.forceNew || e["force new connection"] || !1 === e.multiplex || f ? (s("ignoring socket cache for %s", c), n = i(c, e)) : (a[u] || (s("new io instance for %s", c), a[u] = i(c, e)), n = a[u]), o.query && !e.query && (e.query = o.query), n.socket(o.path, e);
  }

  e.protocol = o.protocol, e.connect = c, e.Manager = n(21), e.Socket = n(27);
}, function (t, e, n) {
  var r = n(18),
      o = n(6)("socket.io-client:url");

  t.exports = function (t, e) {
    var n = t;
    e = e || "undefined" != typeof location && location, null == t && (t = e.protocol + "//" + e.host);
    "string" == typeof t && ("/" === t.charAt(0) && (t = "/" === t.charAt(1) ? e.protocol + t : e.host + t), /^(https?|wss?):\/\//.test(t) || (o("protocol-less url %s", t), t = void 0 !== e ? e.protocol + "//" + t : "https://" + t), o("parse %s", t), n = r(t));
    n.port || (/^(http|ws)$/.test(n.protocol) ? n.port = "80" : /^(http|ws)s$/.test(n.protocol) && (n.port = "443"));
    n.path = n.path || "/";
    var i = -1 !== n.host.indexOf(":") ? "[" + n.host + "]" : n.host;
    return n.id = n.protocol + "://" + i + ":" + n.port, n.href = n.protocol + "://" + i + (e && e.port === n.port ? "" : ":" + n.port), n;
  };
}, function (t, e, n) {
  function r(t) {
    var n;

    function r() {
      if (r.enabled) {
        var t = r,
            o = +new Date(),
            i = o - (n || o);
        t.diff = i, t.prev = n, t.curr = o, n = o;

        for (var s = new Array(arguments.length), a = 0; a < s.length; a++) {
          s[a] = arguments[a];
        }

        s[0] = e.coerce(s[0]), "string" != typeof s[0] && s.unshift("%O");
        var c = 0;
        s[0] = s[0].replace(/%([a-zA-Z%])/g, function (n, r) {
          if ("%%" === n) return n;
          c++;
          var o = e.formatters[r];

          if ("function" == typeof o) {
            var i = s[c];
            n = o.call(t, i), s.splice(c, 1), c--;
          }

          return n;
        }), e.formatArgs.call(t, s), (r.log || e.log || console.log.bind(console)).apply(t, s);
      }
    }

    return r.namespace = t, r.enabled = e.enabled(t), r.useColors = e.useColors(), r.color = function (t) {
      var n,
          r = 0;

      for (n in t) {
        r = (r << 5) - r + t.charCodeAt(n), r |= 0;
      }

      return e.colors[Math.abs(r) % e.colors.length];
    }(t), r.destroy = o, "function" == typeof e.init && e.init(r), e.instances.push(r), r;
  }

  function o() {
    var t = e.instances.indexOf(this);
    return -1 !== t && (e.instances.splice(t, 1), !0);
  }

  (e = t.exports = r.debug = r.default = r).coerce = function (t) {
    return t instanceof Error ? t.stack || t.message : t;
  }, e.disable = function () {
    e.enable("");
  }, e.enable = function (t) {
    var n;
    e.save(t), e.names = [], e.skips = [];
    var r = ("string" == typeof t ? t : "").split(/[\s,]+/),
        o = r.length;

    for (n = 0; n < o; n++) {
      r[n] && ("-" === (t = r[n].replace(/\*/g, ".*?"))[0] ? e.skips.push(new RegExp("^" + t.substr(1) + "$")) : e.names.push(new RegExp("^" + t + "$")));
    }

    for (n = 0; n < e.instances.length; n++) {
      var i = e.instances[n];
      i.enabled = e.enabled(i.namespace);
    }
  }, e.enabled = function (t) {
    if ("*" === t[t.length - 1]) return !0;
    var n, r;

    for (n = 0, r = e.skips.length; n < r; n++) {
      if (e.skips[n].test(t)) return !1;
    }

    for (n = 0, r = e.names.length; n < r; n++) {
      if (e.names[n].test(t)) return !0;
    }

    return !1;
  }, e.humanize = n(40), e.instances = [], e.names = [], e.skips = [], e.formatters = {};
}, function (t, e) {
  var n = 1e3,
      r = 60 * n,
      o = 60 * r,
      i = 24 * o,
      s = 365.25 * i;

  function a(t, e, n) {
    if (!(t < e)) return t < 1.5 * e ? Math.floor(t / e) + " " + n : Math.ceil(t / e) + " " + n + "s";
  }

  t.exports = function (t, e) {
    e = e || {};
    var c,
        u = typeof t;
    if ("string" === u && t.length > 0) return function (t) {
      if ((t = String(t)).length > 100) return;
      var e = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(t);
      if (!e) return;
      var a = parseFloat(e[1]);

      switch ((e[2] || "ms").toLowerCase()) {
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
          return a * s;

        case "days":
        case "day":
        case "d":
          return a * i;

        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
          return a * o;

        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
          return a * r;

        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
          return a * n;

        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
          return a;

        default:
          return;
      }
    }(t);
    if ("number" === u && !1 === isNaN(t)) return e.long ? a(c = t, i, "day") || a(c, o, "hour") || a(c, r, "minute") || a(c, n, "second") || c + " ms" : function (t) {
      if (t >= i) return Math.round(t / i) + "d";
      if (t >= o) return Math.round(t / o) + "h";
      if (t >= r) return Math.round(t / r) + "m";
      if (t >= n) return Math.round(t / n) + "s";
      return t + "ms";
    }(t);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(t));
  };
}, function (t, e, n) {
  (function (r) {
    function o() {
      var t;

      try {
        t = e.storage.debug;
      } catch (t) {}

      return !t && void 0 !== r && "env" in r && (t = r.env.DEBUG), t;
    }

    (e = t.exports = n(42)).log = function () {
      return "object" == typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
    }, e.formatArgs = function (t) {
      var n = this.useColors;
      if (t[0] = (n ? "%c" : "") + this.namespace + (n ? " %c" : " ") + t[0] + (n ? "%c " : " ") + "+" + e.humanize(this.diff), !n) return;
      var r = "color: " + this.color;
      t.splice(1, 0, r, "color: inherit");
      var o = 0,
          i = 0;
      t[0].replace(/%[a-zA-Z%]/g, function (t) {
        "%%" !== t && (o++, "%c" === t && (i = o));
      }), t.splice(i, 0, r);
    }, e.save = function (t) {
      try {
        null == t ? e.storage.removeItem("debug") : e.storage.debug = t;
      } catch (t) {}
    }, e.load = o, e.useColors = function () {
      if ("undefined" != typeof window && window.process && "renderer" === window.process.type) return !0;
      if ("undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return !1;
      return "undefined" != typeof document && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || "undefined" != typeof window && window.console && (window.console.firebug || window.console.exception && window.console.table) || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || "undefined" != typeof navigator && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }, e.storage = "undefined" != typeof chrome && void 0 !== chrome.storage ? chrome.storage.local : function () {
      try {
        return window.localStorage;
      } catch (t) {}
    }(), e.colors = ["#0000CC", "#0000FF", "#0033CC", "#0033FF", "#0066CC", "#0066FF", "#0099CC", "#0099FF", "#00CC00", "#00CC33", "#00CC66", "#00CC99", "#00CCCC", "#00CCFF", "#3300CC", "#3300FF", "#3333CC", "#3333FF", "#3366CC", "#3366FF", "#3399CC", "#3399FF", "#33CC00", "#33CC33", "#33CC66", "#33CC99", "#33CCCC", "#33CCFF", "#6600CC", "#6600FF", "#6633CC", "#6633FF", "#66CC00", "#66CC33", "#9900CC", "#9900FF", "#9933CC", "#9933FF", "#99CC00", "#99CC33", "#CC0000", "#CC0033", "#CC0066", "#CC0099", "#CC00CC", "#CC00FF", "#CC3300", "#CC3333", "#CC3366", "#CC3399", "#CC33CC", "#CC33FF", "#CC6600", "#CC6633", "#CC9900", "#CC9933", "#CCCC00", "#CCCC33", "#FF0000", "#FF0033", "#FF0066", "#FF0099", "#FF00CC", "#FF00FF", "#FF3300", "#FF3333", "#FF3366", "#FF3399", "#FF33CC", "#FF33FF", "#FF6600", "#FF6633", "#FF9900", "#FF9933", "#FFCC00", "#FFCC33"], e.formatters.j = function (t) {
      try {
        return JSON.stringify(t);
      } catch (t) {
        return "[UnexpectedJSONParseError]: " + t.message;
      }
    }, e.enable(o());
  }).call(this, n(3));
}, function (t, e, n) {
  function r(t) {
    var n;

    function r() {
      if (r.enabled) {
        var t = r,
            o = +new Date(),
            i = o - (n || o);
        t.diff = i, t.prev = n, t.curr = o, n = o;

        for (var s = new Array(arguments.length), a = 0; a < s.length; a++) {
          s[a] = arguments[a];
        }

        s[0] = e.coerce(s[0]), "string" != typeof s[0] && s.unshift("%O");
        var c = 0;
        s[0] = s[0].replace(/%([a-zA-Z%])/g, function (n, r) {
          if ("%%" === n) return n;
          c++;
          var o = e.formatters[r];

          if ("function" == typeof o) {
            var i = s[c];
            n = o.call(t, i), s.splice(c, 1), c--;
          }

          return n;
        }), e.formatArgs.call(t, s), (r.log || e.log || console.log.bind(console)).apply(t, s);
      }
    }

    return r.namespace = t, r.enabled = e.enabled(t), r.useColors = e.useColors(), r.color = function (t) {
      var n,
          r = 0;

      for (n in t) {
        r = (r << 5) - r + t.charCodeAt(n), r |= 0;
      }

      return e.colors[Math.abs(r) % e.colors.length];
    }(t), r.destroy = o, "function" == typeof e.init && e.init(r), e.instances.push(r), r;
  }

  function o() {
    var t = e.instances.indexOf(this);
    return -1 !== t && (e.instances.splice(t, 1), !0);
  }

  (e = t.exports = r.debug = r.default = r).coerce = function (t) {
    return t instanceof Error ? t.stack || t.message : t;
  }, e.disable = function () {
    e.enable("");
  }, e.enable = function (t) {
    var n;
    e.save(t), e.names = [], e.skips = [];
    var r = ("string" == typeof t ? t : "").split(/[\s,]+/),
        o = r.length;

    for (n = 0; n < o; n++) {
      r[n] && ("-" === (t = r[n].replace(/\*/g, ".*?"))[0] ? e.skips.push(new RegExp("^" + t.substr(1) + "$")) : e.names.push(new RegExp("^" + t + "$")));
    }

    for (n = 0; n < e.instances.length; n++) {
      var i = e.instances[n];
      i.enabled = e.enabled(i.namespace);
    }
  }, e.enabled = function (t) {
    if ("*" === t[t.length - 1]) return !0;
    var n, r;

    for (n = 0, r = e.skips.length; n < r; n++) {
      if (e.skips[n].test(t)) return !1;
    }

    for (n = 0, r = e.names.length; n < r; n++) {
      if (e.names[n].test(t)) return !0;
    }

    return !1;
  }, e.humanize = n(43), e.instances = [], e.names = [], e.skips = [], e.formatters = {};
}, function (t, e) {
  var n = 1e3,
      r = 60 * n,
      o = 60 * r,
      i = 24 * o,
      s = 365.25 * i;

  function a(t, e, n) {
    if (!(t < e)) return t < 1.5 * e ? Math.floor(t / e) + " " + n : Math.ceil(t / e) + " " + n + "s";
  }

  t.exports = function (t, e) {
    e = e || {};
    var c,
        u = typeof t;
    if ("string" === u && t.length > 0) return function (t) {
      if ((t = String(t)).length > 100) return;
      var e = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(t);
      if (!e) return;
      var a = parseFloat(e[1]);

      switch ((e[2] || "ms").toLowerCase()) {
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
          return a * s;

        case "days":
        case "day":
        case "d":
          return a * i;

        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
          return a * o;

        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
          return a * r;

        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
          return a * n;

        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
          return a;

        default:
          return;
      }
    }(t);
    if ("number" === u && !1 === isNaN(t)) return e.long ? a(c = t, i, "day") || a(c, o, "hour") || a(c, r, "minute") || a(c, n, "second") || c + " ms" : function (t) {
      if (t >= i) return Math.round(t / i) + "d";
      if (t >= o) return Math.round(t / o) + "h";
      if (t >= r) return Math.round(t / r) + "m";
      if (t >= n) return Math.round(t / n) + "s";
      return t + "ms";
    }(t);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(t));
  };
}, function (t, e, n) {
  var r = n(19),
      o = n(20),
      i = Object.prototype.toString,
      s = "function" == typeof Blob || "undefined" != typeof Blob && "[object BlobConstructor]" === i.call(Blob),
      a = "function" == typeof File || "undefined" != typeof File && "[object FileConstructor]" === i.call(File);
  e.deconstructPacket = function (t) {
    var e = [],
        n = t.data,
        i = t;
    return i.data = function t(e, n) {
      if (!e) return e;

      if (o(e)) {
        var i = {
          _placeholder: !0,
          num: n.length
        };
        return n.push(e), i;
      }

      if (r(e)) {
        for (var s = new Array(e.length), a = 0; a < e.length; a++) {
          s[a] = t(e[a], n);
        }

        return s;
      }

      if ("object" == typeof e && !(e instanceof Date)) {
        var s = {};

        for (var c in e) {
          s[c] = t(e[c], n);
        }

        return s;
      }

      return e;
    }(n, e), i.attachments = e.length, {
      packet: i,
      buffers: e
    };
  }, e.reconstructPacket = function (t, e) {
    return t.data = function t(e, n) {
      if (!e) return e;
      if (e && e._placeholder) return n[e.num];
      if (r(e)) for (var o = 0; o < e.length; o++) {
        e[o] = t(e[o], n);
      } else if ("object" == typeof e) for (var i in e) {
        e[i] = t(e[i], n);
      }
      return e;
    }(t.data, e), t.attachments = void 0, t;
  }, e.removeBlobs = function (t, e) {
    var n = 0,
        i = t;
    !function t(c, u, l) {
      if (!c) return c;

      if (s && c instanceof Blob || a && c instanceof File) {
        n++;
        var f = new FileReader();
        f.onload = function () {
          l ? l[u] = this.result : i = this.result, --n || e(i);
        }, f.readAsArrayBuffer(c);
      } else if (r(c)) for (var h = 0; h < c.length; h++) {
        t(c[h], h, c);
      } else if ("object" == typeof c && !o(c)) for (var p in c) {
        t(c[p], p, c);
      }
    }(i), n || e(i);
  };
}, function (t, e, n) {
  "use strict";

  e.byteLength = function (t) {
    var e = u(t),
        n = e[0],
        r = e[1];
    return 3 * (n + r) / 4 - r;
  }, e.toByteArray = function (t) {
    for (var e, n = u(t), r = n[0], s = n[1], a = new i(function (t, e, n) {
      return 3 * (e + n) / 4 - n;
    }(0, r, s)), c = 0, l = s > 0 ? r - 4 : r, f = 0; f < l; f += 4) {
      e = o[t.charCodeAt(f)] << 18 | o[t.charCodeAt(f + 1)] << 12 | o[t.charCodeAt(f + 2)] << 6 | o[t.charCodeAt(f + 3)], a[c++] = e >> 16 & 255, a[c++] = e >> 8 & 255, a[c++] = 255 & e;
    }

    2 === s && (e = o[t.charCodeAt(f)] << 2 | o[t.charCodeAt(f + 1)] >> 4, a[c++] = 255 & e);
    1 === s && (e = o[t.charCodeAt(f)] << 10 | o[t.charCodeAt(f + 1)] << 4 | o[t.charCodeAt(f + 2)] >> 2, a[c++] = e >> 8 & 255, a[c++] = 255 & e);
    return a;
  }, e.fromByteArray = function (t) {
    for (var e, n = t.length, o = n % 3, i = [], s = 0, a = n - o; s < a; s += 16383) {
      i.push(l(t, s, s + 16383 > a ? a : s + 16383));
    }

    1 === o ? (e = t[n - 1], i.push(r[e >> 2] + r[e << 4 & 63] + "==")) : 2 === o && (e = (t[n - 2] << 8) + t[n - 1], i.push(r[e >> 10] + r[e >> 4 & 63] + r[e << 2 & 63] + "="));
    return i.join("");
  };

  for (var r = [], o = [], i = "undefined" != typeof Uint8Array ? Uint8Array : Array, s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0, c = s.length; a < c; ++a) {
    r[a] = s[a], o[s.charCodeAt(a)] = a;
  }

  function u(t) {
    var e = t.length;
    if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    var n = t.indexOf("=");
    return -1 === n && (n = e), [n, n === e ? 0 : 4 - n % 4];
  }

  function l(t, e, n) {
    for (var o, i, s = [], a = e; a < n; a += 3) {
      o = (t[a] << 16 & 16711680) + (t[a + 1] << 8 & 65280) + (255 & t[a + 2]), s.push(r[(i = o) >> 18 & 63] + r[i >> 12 & 63] + r[i >> 6 & 63] + r[63 & i]);
    }

    return s.join("");
  }

  o["-".charCodeAt(0)] = 62, o["_".charCodeAt(0)] = 63;
}, function (t, e) {
  e.read = function (t, e, n, r, o) {
    var i,
        s,
        a = 8 * o - r - 1,
        c = (1 << a) - 1,
        u = c >> 1,
        l = -7,
        f = n ? o - 1 : 0,
        h = n ? -1 : 1,
        p = t[e + f];

    for (f += h, i = p & (1 << -l) - 1, p >>= -l, l += a; l > 0; i = 256 * i + t[e + f], f += h, l -= 8) {
      ;
    }

    for (s = i & (1 << -l) - 1, i >>= -l, l += r; l > 0; s = 256 * s + t[e + f], f += h, l -= 8) {
      ;
    }

    if (0 === i) i = 1 - u;else {
      if (i === c) return s ? NaN : 1 / 0 * (p ? -1 : 1);
      s += Math.pow(2, r), i -= u;
    }
    return (p ? -1 : 1) * s * Math.pow(2, i - r);
  }, e.write = function (t, e, n, r, o, i) {
    var s,
        a,
        c,
        u = 8 * i - o - 1,
        l = (1 << u) - 1,
        f = l >> 1,
        h = 23 === o ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
        p = r ? 0 : i - 1,
        d = r ? 1 : -1,
        y = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;

    for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (a = isNaN(e) ? 1 : 0, s = l) : (s = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -s)) < 1 && (s--, c *= 2), (e += s + f >= 1 ? h / c : h * Math.pow(2, 1 - f)) * c >= 2 && (s++, c /= 2), s + f >= l ? (a = 0, s = l) : s + f >= 1 ? (a = (e * c - 1) * Math.pow(2, o), s += f) : (a = e * Math.pow(2, f - 1) * Math.pow(2, o), s = 0)); o >= 8; t[n + p] = 255 & a, p += d, a /= 256, o -= 8) {
      ;
    }

    for (s = s << o | a, u += o; u > 0; t[n + p] = 255 & s, p += d, s /= 256, u -= 8) {
      ;
    }

    t[n + p - d] |= 128 * y;
  };
}, function (t, e) {
  var n = {}.toString;

  t.exports = Array.isArray || function (t) {
    return "[object Array]" == n.call(t);
  };
}, function (t, e, n) {
  t.exports = n(49), t.exports.parser = n(1);
}, function (t, e, n) {
  var r = n(22),
      o = n(0),
      i = n(9)("engine.io-client:socket"),
      s = n(26),
      a = n(1),
      c = n(18),
      u = n(7);

  function l(t, e) {
    if (!(this instanceof l)) return new l(t, e);
    e = e || {}, t && "object" == typeof t && (e = t, t = null), t ? (t = c(t), e.hostname = t.host, e.secure = "https" === t.protocol || "wss" === t.protocol, e.port = t.port, t.query && (e.query = t.query)) : e.host && (e.hostname = c(e.host).host), this.secure = null != e.secure ? e.secure : "undefined" != typeof location && "https:" === location.protocol, e.hostname && !e.port && (e.port = this.secure ? "443" : "80"), this.agent = e.agent || !1, this.hostname = e.hostname || ("undefined" != typeof location ? location.hostname : "localhost"), this.port = e.port || ("undefined" != typeof location && location.port ? location.port : this.secure ? 443 : 80), this.query = e.query || {}, "string" == typeof this.query && (this.query = u.decode(this.query)), this.upgrade = !1 !== e.upgrade, this.path = (e.path || "/engine.io").replace(/\/$/, "") + "/", this.forceJSONP = !!e.forceJSONP, this.jsonp = !1 !== e.jsonp, this.forceBase64 = !!e.forceBase64, this.enablesXDR = !!e.enablesXDR, this.timestampParam = e.timestampParam || "t", this.timestampRequests = e.timestampRequests, this.transports = e.transports || ["polling", "websocket"], this.transportOptions = e.transportOptions || {}, this.readyState = "", this.writeBuffer = [], this.prevBufferLen = 0, this.policyPort = e.policyPort || 843, this.rememberUpgrade = e.rememberUpgrade || !1, this.binaryType = null, this.onlyBinaryUpgrades = e.onlyBinaryUpgrades, this.perMessageDeflate = !1 !== e.perMessageDeflate && (e.perMessageDeflate || {}), !0 === this.perMessageDeflate && (this.perMessageDeflate = {}), this.perMessageDeflate && null == this.perMessageDeflate.threshold && (this.perMessageDeflate.threshold = 1024), this.pfx = e.pfx || null, this.key = e.key || null, this.passphrase = e.passphrase || null, this.cert = e.cert || null, this.ca = e.ca || null, this.ciphers = e.ciphers || null, this.rejectUnauthorized = void 0 === e.rejectUnauthorized || e.rejectUnauthorized, this.forceNode = !!e.forceNode, this.isReactNative = "undefined" != typeof navigator && "string" == typeof navigator.product && "reactnative" === navigator.product.toLowerCase(), ("undefined" == typeof self || this.isReactNative) && (e.extraHeaders && Object.keys(e.extraHeaders).length > 0 && (this.extraHeaders = e.extraHeaders), e.localAddress && (this.localAddress = e.localAddress)), this.id = null, this.upgrades = null, this.pingInterval = null, this.pingTimeout = null, this.pingIntervalTimer = null, this.pingTimeoutTimer = null, this.open();
  }

  t.exports = l, l.priorWebsocketSuccess = !1, o(l.prototype), l.protocol = a.protocol, l.Socket = l, l.Transport = n(14), l.transports = n(22), l.parser = n(1), l.prototype.createTransport = function (t) {
    i('creating transport "%s"', t);

    var e = function (t) {
      var e = {};

      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }

      return e;
    }(this.query);

    e.EIO = a.protocol, e.transport = t;
    var n = this.transportOptions[t] || {};
    return this.id && (e.sid = this.id), new r[t]({
      query: e,
      socket: this,
      agent: n.agent || this.agent,
      hostname: n.hostname || this.hostname,
      port: n.port || this.port,
      secure: n.secure || this.secure,
      path: n.path || this.path,
      forceJSONP: n.forceJSONP || this.forceJSONP,
      jsonp: n.jsonp || this.jsonp,
      forceBase64: n.forceBase64 || this.forceBase64,
      enablesXDR: n.enablesXDR || this.enablesXDR,
      timestampRequests: n.timestampRequests || this.timestampRequests,
      timestampParam: n.timestampParam || this.timestampParam,
      policyPort: n.policyPort || this.policyPort,
      pfx: n.pfx || this.pfx,
      key: n.key || this.key,
      passphrase: n.passphrase || this.passphrase,
      cert: n.cert || this.cert,
      ca: n.ca || this.ca,
      ciphers: n.ciphers || this.ciphers,
      rejectUnauthorized: n.rejectUnauthorized || this.rejectUnauthorized,
      perMessageDeflate: n.perMessageDeflate || this.perMessageDeflate,
      extraHeaders: n.extraHeaders || this.extraHeaders,
      forceNode: n.forceNode || this.forceNode,
      localAddress: n.localAddress || this.localAddress,
      requestTimeout: n.requestTimeout || this.requestTimeout,
      protocols: n.protocols || void 0,
      isReactNative: this.isReactNative
    });
  }, l.prototype.open = function () {
    var t;
    if (this.rememberUpgrade && l.priorWebsocketSuccess && -1 !== this.transports.indexOf("websocket")) t = "websocket";else {
      if (0 === this.transports.length) {
        var e = this;
        return void setTimeout(function () {
          e.emit("error", "No transports available");
        }, 0);
      }

      t = this.transports[0];
    }
    this.readyState = "opening";

    try {
      t = this.createTransport(t);
    } catch (t) {
      return this.transports.shift(), void this.open();
    }

    t.open(), this.setTransport(t);
  }, l.prototype.setTransport = function (t) {
    i("setting transport %s", t.name);
    var e = this;
    this.transport && (i("clearing existing transport %s", this.transport.name), this.transport.removeAllListeners()), this.transport = t, t.on("drain", function () {
      e.onDrain();
    }).on("packet", function (t) {
      e.onPacket(t);
    }).on("error", function (t) {
      e.onError(t);
    }).on("close", function () {
      e.onClose("transport close");
    });
  }, l.prototype.probe = function (t) {
    i('probing transport "%s"', t);
    var e = this.createTransport(t, {
      probe: 1
    }),
        n = !1,
        r = this;

    function o() {
      if (r.onlyBinaryUpgrades) {
        var o = !this.supportsBinary && r.transport.supportsBinary;
        n = n || o;
      }

      n || (i('probe transport "%s" opened', t), e.send([{
        type: "ping",
        data: "probe"
      }]), e.once("packet", function (o) {
        if (!n) if ("pong" === o.type && "probe" === o.data) {
          if (i('probe transport "%s" pong', t), r.upgrading = !0, r.emit("upgrading", e), !e) return;
          l.priorWebsocketSuccess = "websocket" === e.name, i('pausing current transport "%s"', r.transport.name), r.transport.pause(function () {
            n || "closed" !== r.readyState && (i("changing transport and sending upgrade packet"), h(), r.setTransport(e), e.send([{
              type: "upgrade"
            }]), r.emit("upgrade", e), e = null, r.upgrading = !1, r.flush());
          });
        } else {
          i('probe transport "%s" failed', t);
          var s = new Error("probe error");
          s.transport = e.name, r.emit("upgradeError", s);
        }
      }));
    }

    function s() {
      n || (n = !0, h(), e.close(), e = null);
    }

    function a(n) {
      var o = new Error("probe error: " + n);
      o.transport = e.name, s(), i('probe transport "%s" failed because of error: %s', t, n), r.emit("upgradeError", o);
    }

    function c() {
      a("transport closed");
    }

    function u() {
      a("socket closed");
    }

    function f(t) {
      e && t.name !== e.name && (i('"%s" works - aborting "%s"', t.name, e.name), s());
    }

    function h() {
      e.removeListener("open", o), e.removeListener("error", a), e.removeListener("close", c), r.removeListener("close", u), r.removeListener("upgrading", f);
    }

    l.priorWebsocketSuccess = !1, e.once("open", o), e.once("error", a), e.once("close", c), this.once("close", u), this.once("upgrading", f), e.open();
  }, l.prototype.onOpen = function () {
    if (i("socket open"), this.readyState = "open", l.priorWebsocketSuccess = "websocket" === this.transport.name, this.emit("open"), this.flush(), "open" === this.readyState && this.upgrade && this.transport.pause) {
      i("starting upgrade probes");

      for (var t = 0, e = this.upgrades.length; t < e; t++) {
        this.probe(this.upgrades[t]);
      }
    }
  }, l.prototype.onPacket = function (t) {
    if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) switch (i('socket receive: type "%s", data "%s"', t.type, t.data), this.emit("packet", t), this.emit("heartbeat"), t.type) {
      case "open":
        this.onHandshake(JSON.parse(t.data));
        break;

      case "pong":
        this.setPing(), this.emit("pong");
        break;

      case "error":
        var e = new Error("server error");
        e.code = t.data, this.onError(e);
        break;

      case "message":
        this.emit("data", t.data), this.emit("message", t.data);
    } else i('packet received with socket readyState "%s"', this.readyState);
  }, l.prototype.onHandshake = function (t) {
    this.emit("handshake", t), this.id = t.sid, this.transport.query.sid = t.sid, this.upgrades = this.filterUpgrades(t.upgrades), this.pingInterval = t.pingInterval, this.pingTimeout = t.pingTimeout, this.onOpen(), "closed" !== this.readyState && (this.setPing(), this.removeListener("heartbeat", this.onHeartbeat), this.on("heartbeat", this.onHeartbeat));
  }, l.prototype.onHeartbeat = function (t) {
    clearTimeout(this.pingTimeoutTimer);
    var e = this;
    e.pingTimeoutTimer = setTimeout(function () {
      "closed" !== e.readyState && e.onClose("ping timeout");
    }, t || e.pingInterval + e.pingTimeout);
  }, l.prototype.setPing = function () {
    var t = this;
    clearTimeout(t.pingIntervalTimer), t.pingIntervalTimer = setTimeout(function () {
      i("writing ping packet - expecting pong within %sms", t.pingTimeout), t.ping(), t.onHeartbeat(t.pingTimeout);
    }, t.pingInterval);
  }, l.prototype.ping = function () {
    var t = this;
    this.sendPacket("ping", function () {
      t.emit("ping");
    });
  }, l.prototype.onDrain = function () {
    this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, 0 === this.writeBuffer.length ? this.emit("drain") : this.flush();
  }, l.prototype.flush = function () {
    "closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length && (i("flushing %d packets in socket", this.writeBuffer.length), this.transport.send(this.writeBuffer), this.prevBufferLen = this.writeBuffer.length, this.emit("flush"));
  }, l.prototype.write = l.prototype.send = function (t, e, n) {
    return this.sendPacket("message", t, e, n), this;
  }, l.prototype.sendPacket = function (t, e, n, r) {
    if ("function" == typeof e && (r = e, e = void 0), "function" == typeof n && (r = n, n = null), "closing" !== this.readyState && "closed" !== this.readyState) {
      (n = n || {}).compress = !1 !== n.compress;
      var o = {
        type: t,
        data: e,
        options: n
      };
      this.emit("packetCreate", o), this.writeBuffer.push(o), r && this.once("flush", r), this.flush();
    }
  }, l.prototype.close = function () {
    if ("opening" === this.readyState || "open" === this.readyState) {
      this.readyState = "closing";
      var t = this;
      this.writeBuffer.length ? this.once("drain", function () {
        this.upgrading ? r() : e();
      }) : this.upgrading ? r() : e();
    }

    function e() {
      t.onClose("forced close"), i("socket closing - telling transport to close"), t.transport.close();
    }

    function n() {
      t.removeListener("upgrade", n), t.removeListener("upgradeError", n), e();
    }

    function r() {
      t.once("upgrade", n), t.once("upgradeError", n);
    }

    return this;
  }, l.prototype.onError = function (t) {
    i("socket error %j", t), l.priorWebsocketSuccess = !1, this.emit("error", t), this.onClose("transport error", t);
  }, l.prototype.onClose = function (t, e) {
    if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
      i('socket close with reason: "%s"', t);
      clearTimeout(this.pingIntervalTimer), clearTimeout(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), this.readyState = "closed", this.id = null, this.emit("close", t, e), this.writeBuffer = [], this.prevBufferLen = 0;
    }
  }, l.prototype.filterUpgrades = function (t) {
    for (var e = [], n = 0, r = t.length; n < r; n++) {
      ~s(this.transports, t[n]) && e.push(t[n]);
    }

    return e;
  };
}, function (t, e) {
  try {
    t.exports = "undefined" != typeof XMLHttpRequest && "withCredentials" in new XMLHttpRequest();
  } catch (e) {
    t.exports = !1;
  }
}, function (t, e, n) {
  var r = n(13),
      o = n(23),
      i = n(0),
      s = n(8),
      a = n(9)("engine.io-client:polling-xhr");

  function c() {}

  function u(t) {
    if (o.call(this, t), this.requestTimeout = t.requestTimeout, this.extraHeaders = t.extraHeaders, "undefined" != typeof location) {
      var e = "https:" === location.protocol,
          n = location.port;
      n || (n = e ? 443 : 80), this.xd = "undefined" != typeof location && t.hostname !== location.hostname || n !== t.port, this.xs = t.secure !== e;
    }
  }

  function l(t) {
    this.method = t.method || "GET", this.uri = t.uri, this.xd = !!t.xd, this.xs = !!t.xs, this.async = !1 !== t.async, this.data = void 0 !== t.data ? t.data : null, this.agent = t.agent, this.isBinary = t.isBinary, this.supportsBinary = t.supportsBinary, this.enablesXDR = t.enablesXDR, this.requestTimeout = t.requestTimeout, this.pfx = t.pfx, this.key = t.key, this.passphrase = t.passphrase, this.cert = t.cert, this.ca = t.ca, this.ciphers = t.ciphers, this.rejectUnauthorized = t.rejectUnauthorized, this.extraHeaders = t.extraHeaders, this.create();
  }

  if (t.exports = u, t.exports.Request = l, s(u, o), u.prototype.supportsBinary = !0, u.prototype.request = function (t) {
    return (t = t || {}).uri = this.uri(), t.xd = this.xd, t.xs = this.xs, t.agent = this.agent || !1, t.supportsBinary = this.supportsBinary, t.enablesXDR = this.enablesXDR, t.pfx = this.pfx, t.key = this.key, t.passphrase = this.passphrase, t.cert = this.cert, t.ca = this.ca, t.ciphers = this.ciphers, t.rejectUnauthorized = this.rejectUnauthorized, t.requestTimeout = this.requestTimeout, t.extraHeaders = this.extraHeaders, new l(t);
  }, u.prototype.doWrite = function (t, e) {
    var n = "string" != typeof t && void 0 !== t,
        r = this.request({
      method: "POST",
      data: t,
      isBinary: n
    }),
        o = this;
    r.on("success", e), r.on("error", function (t) {
      o.onError("xhr post error", t);
    }), this.sendXhr = r;
  }, u.prototype.doPoll = function () {
    a("xhr poll");
    var t = this.request(),
        e = this;
    t.on("data", function (t) {
      e.onData(t);
    }), t.on("error", function (t) {
      e.onError("xhr poll error", t);
    }), this.pollXhr = t;
  }, i(l.prototype), l.prototype.create = function () {
    var t = {
      agent: this.agent,
      xdomain: this.xd,
      xscheme: this.xs,
      enablesXDR: this.enablesXDR
    };
    t.pfx = this.pfx, t.key = this.key, t.passphrase = this.passphrase, t.cert = this.cert, t.ca = this.ca, t.ciphers = this.ciphers, t.rejectUnauthorized = this.rejectUnauthorized;
    var e = this.xhr = new r(t),
        n = this;

    try {
      a("xhr open %s: %s", this.method, this.uri), e.open(this.method, this.uri, this.async);

      try {
        if (this.extraHeaders) for (var o in e.setDisableHeaderCheck && e.setDisableHeaderCheck(!0), this.extraHeaders) {
          this.extraHeaders.hasOwnProperty(o) && e.setRequestHeader(o, this.extraHeaders[o]);
        }
      } catch (t) {}

      if ("POST" === this.method) try {
        this.isBinary ? e.setRequestHeader("Content-type", "application/octet-stream") : e.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
      } catch (t) {}

      try {
        e.setRequestHeader("Accept", "*/*");
      } catch (t) {}

      "withCredentials" in e && (e.withCredentials = !0), this.requestTimeout && (e.timeout = this.requestTimeout), this.hasXDR() ? (e.onload = function () {
        n.onLoad();
      }, e.onerror = function () {
        n.onError(e.responseText);
      }) : e.onreadystatechange = function () {
        if (2 === e.readyState) try {
          var t = e.getResponseHeader("Content-Type");
          n.supportsBinary && "application/octet-stream" === t && (e.responseType = "arraybuffer");
        } catch (t) {}
        4 === e.readyState && (200 === e.status || 1223 === e.status ? n.onLoad() : setTimeout(function () {
          n.onError(e.status);
        }, 0));
      }, a("xhr data %s", this.data), e.send(this.data);
    } catch (t) {
      return void setTimeout(function () {
        n.onError(t);
      }, 0);
    }

    "undefined" != typeof document && (this.index = l.requestsCount++, l.requests[this.index] = this);
  }, l.prototype.onSuccess = function () {
    this.emit("success"), this.cleanup();
  }, l.prototype.onData = function (t) {
    this.emit("data", t), this.onSuccess();
  }, l.prototype.onError = function (t) {
    this.emit("error", t), this.cleanup(!0);
  }, l.prototype.cleanup = function (t) {
    if (void 0 !== this.xhr && null !== this.xhr) {
      if (this.hasXDR() ? this.xhr.onload = this.xhr.onerror = c : this.xhr.onreadystatechange = c, t) try {
        this.xhr.abort();
      } catch (t) {}
      "undefined" != typeof document && delete l.requests[this.index], this.xhr = null;
    }
  }, l.prototype.onLoad = function () {
    var t;

    try {
      var e;

      try {
        e = this.xhr.getResponseHeader("Content-Type");
      } catch (t) {}

      t = "application/octet-stream" === e && this.xhr.response || this.xhr.responseText;
    } catch (t) {
      this.onError(t);
    }

    null != t && this.onData(t);
  }, l.prototype.hasXDR = function () {
    return "undefined" != typeof XDomainRequest && !this.xs && this.enablesXDR;
  }, l.prototype.abort = function () {
    this.cleanup();
  }, l.requestsCount = 0, l.requests = {}, "undefined" != typeof document) if ("function" == typeof attachEvent) attachEvent("onunload", h);else if ("function" == typeof addEventListener) {
    var f = "onpagehide" in self ? "pagehide" : "unload";
    addEventListener(f, h, !1);
  }

  function h() {
    for (var t in l.requests) {
      l.requests.hasOwnProperty(t) && l.requests[t].abort();
    }
  }
}, function (t, e) {
  t.exports = Object.keys || function (t) {
    var e = [],
        n = Object.prototype.hasOwnProperty;

    for (var r in t) {
      n.call(t, r) && e.push(r);
    }

    return e;
  };
}, function (t, e) {
  var n = {}.toString;

  t.exports = Array.isArray || function (t) {
    return "[object Array]" == n.call(t);
  };
}, function (t, e) {
  t.exports = function (t, e, n) {
    var r = t.byteLength;
    if (e = e || 0, n = n || r, t.slice) return t.slice(e, n);
    if (e < 0 && (e += r), n < 0 && (n += r), n > r && (n = r), e >= r || e >= n || 0 === r) return new ArrayBuffer(0);

    for (var o = new Uint8Array(t), i = new Uint8Array(n - e), s = e, a = 0; s < n; s++, a++) {
      i[a] = o[s];
    }

    return i.buffer;
  };
}, function (t, e) {
  function n() {}

  t.exports = function (t, e, r) {
    var o = !1;
    return r = r || n, i.count = t, 0 === t ? e() : i;

    function i(t, n) {
      if (i.count <= 0) throw new Error("after called too many times");
      --i.count, t ? (o = !0, e(t), e = r) : 0 !== i.count || o || e(null, n);
    }
  };
}, function (t, e) {
  /*! https://mths.be/utf8js v2.1.2 by @mathias */
  var n,
      r,
      o,
      i = String.fromCharCode;

  function s(t) {
    for (var e, n, r = [], o = 0, i = t.length; o < i;) {
      (e = t.charCodeAt(o++)) >= 55296 && e <= 56319 && o < i ? 56320 == (64512 & (n = t.charCodeAt(o++))) ? r.push(((1023 & e) << 10) + (1023 & n) + 65536) : (r.push(e), o--) : r.push(e);
    }

    return r;
  }

  function a(t, e) {
    if (t >= 55296 && t <= 57343) {
      if (e) throw Error("Lone surrogate U+" + t.toString(16).toUpperCase() + " is not a scalar value");
      return !1;
    }

    return !0;
  }

  function c(t, e) {
    return i(t >> e & 63 | 128);
  }

  function u(t, e) {
    if (0 == (4294967168 & t)) return i(t);
    var n = "";
    return 0 == (4294965248 & t) ? n = i(t >> 6 & 31 | 192) : 0 == (4294901760 & t) ? (a(t, e) || (t = 65533), n = i(t >> 12 & 15 | 224), n += c(t, 6)) : 0 == (4292870144 & t) && (n = i(t >> 18 & 7 | 240), n += c(t, 12), n += c(t, 6)), n += i(63 & t | 128);
  }

  function l() {
    if (o >= r) throw Error("Invalid byte index");
    var t = 255 & n[o];
    if (o++, 128 == (192 & t)) return 63 & t;
    throw Error("Invalid continuation byte");
  }

  function f(t) {
    var e, i;
    if (o > r) throw Error("Invalid byte index");
    if (o == r) return !1;
    if (e = 255 & n[o], o++, 0 == (128 & e)) return e;

    if (192 == (224 & e)) {
      if ((i = (31 & e) << 6 | l()) >= 128) return i;
      throw Error("Invalid continuation byte");
    }

    if (224 == (240 & e)) {
      if ((i = (15 & e) << 12 | l() << 6 | l()) >= 2048) return a(i, t) ? i : 65533;
      throw Error("Invalid continuation byte");
    }

    if (240 == (248 & e) && (i = (7 & e) << 18 | l() << 12 | l() << 6 | l()) >= 65536 && i <= 1114111) return i;
    throw Error("Invalid UTF-8 detected");
  }

  t.exports = {
    version: "2.1.2",
    encode: function encode(t, e) {
      for (var n = !1 !== (e = e || {}).strict, r = s(t), o = r.length, i = -1, a = ""; ++i < o;) {
        a += u(r[i], n);
      }

      return a;
    },
    decode: function decode(t, e) {
      var a = !1 !== (e = e || {}).strict;
      n = s(t), r = n.length, o = 0;

      for (var c, u = []; !1 !== (c = f(a));) {
        u.push(c);
      }

      return function (t) {
        for (var e, n = t.length, r = -1, o = ""; ++r < n;) {
          (e = t[r]) > 65535 && (o += i((e -= 65536) >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), o += i(e);
        }

        return o;
      }(u);
    }
  };
}, function (t, e) {
  !function () {
    "use strict";

    for (var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", n = new Uint8Array(256), r = 0; r < t.length; r++) {
      n[t.charCodeAt(r)] = r;
    }

    e.encode = function (e) {
      var n,
          r = new Uint8Array(e),
          o = r.length,
          i = "";

      for (n = 0; n < o; n += 3) {
        i += t[r[n] >> 2], i += t[(3 & r[n]) << 4 | r[n + 1] >> 4], i += t[(15 & r[n + 1]) << 2 | r[n + 2] >> 6], i += t[63 & r[n + 2]];
      }

      return o % 3 == 2 ? i = i.substring(0, i.length - 1) + "=" : o % 3 == 1 && (i = i.substring(0, i.length - 2) + "=="), i;
    }, e.decode = function (t) {
      var e,
          r,
          o,
          i,
          s,
          a = .75 * t.length,
          c = t.length,
          u = 0;
      "=" === t[t.length - 1] && (a--, "=" === t[t.length - 2] && a--);
      var l = new ArrayBuffer(a),
          f = new Uint8Array(l);

      for (e = 0; e < c; e += 4) {
        r = n[t.charCodeAt(e)], o = n[t.charCodeAt(e + 1)], i = n[t.charCodeAt(e + 2)], s = n[t.charCodeAt(e + 3)], f[u++] = r << 2 | o >> 4, f[u++] = (15 & o) << 4 | i >> 2, f[u++] = (3 & i) << 6 | 63 & s;
      }

      return l;
    };
  }();
}, function (t, e) {
  var n = void 0 !== n ? n : "undefined" != typeof WebKitBlobBuilder ? WebKitBlobBuilder : "undefined" != typeof MSBlobBuilder ? MSBlobBuilder : "undefined" != typeof MozBlobBuilder && MozBlobBuilder,
      r = function () {
    try {
      return 2 === new Blob(["hi"]).size;
    } catch (t) {
      return !1;
    }
  }(),
      o = r && function () {
    try {
      return 2 === new Blob([new Uint8Array([1, 2])]).size;
    } catch (t) {
      return !1;
    }
  }(),
      i = n && n.prototype.append && n.prototype.getBlob;

  function s(t) {
    return t.map(function (t) {
      if (t.buffer instanceof ArrayBuffer) {
        var e = t.buffer;

        if (t.byteLength !== e.byteLength) {
          var n = new Uint8Array(t.byteLength);
          n.set(new Uint8Array(e, t.byteOffset, t.byteLength)), e = n.buffer;
        }

        return e;
      }

      return t;
    });
  }

  function a(t, e) {
    e = e || {};
    var r = new n();
    return s(t).forEach(function (t) {
      r.append(t);
    }), e.type ? r.getBlob(e.type) : r.getBlob();
  }

  function c(t, e) {
    return new Blob(s(t), e || {});
  }

  "undefined" != typeof Blob && (a.prototype = Blob.prototype, c.prototype = Blob.prototype), t.exports = r ? o ? Blob : c : i ? a : void 0;
}, function (t, e, n) {
  function r(t) {
    var n;

    function r() {
      if (r.enabled) {
        var t = r,
            o = +new Date(),
            i = o - (n || o);
        t.diff = i, t.prev = n, t.curr = o, n = o;

        for (var s = new Array(arguments.length), a = 0; a < s.length; a++) {
          s[a] = arguments[a];
        }

        s[0] = e.coerce(s[0]), "string" != typeof s[0] && s.unshift("%O");
        var c = 0;
        s[0] = s[0].replace(/%([a-zA-Z%])/g, function (n, r) {
          if ("%%" === n) return n;
          c++;
          var o = e.formatters[r];

          if ("function" == typeof o) {
            var i = s[c];
            n = o.call(t, i), s.splice(c, 1), c--;
          }

          return n;
        }), e.formatArgs.call(t, s), (r.log || e.log || console.log.bind(console)).apply(t, s);
      }
    }

    return r.namespace = t, r.enabled = e.enabled(t), r.useColors = e.useColors(), r.color = function (t) {
      var n,
          r = 0;

      for (n in t) {
        r = (r << 5) - r + t.charCodeAt(n), r |= 0;
      }

      return e.colors[Math.abs(r) % e.colors.length];
    }(t), r.destroy = o, "function" == typeof e.init && e.init(r), e.instances.push(r), r;
  }

  function o() {
    var t = e.instances.indexOf(this);
    return -1 !== t && (e.instances.splice(t, 1), !0);
  }

  (e = t.exports = r.debug = r.default = r).coerce = function (t) {
    return t instanceof Error ? t.stack || t.message : t;
  }, e.disable = function () {
    e.enable("");
  }, e.enable = function (t) {
    var n;
    e.save(t), e.names = [], e.skips = [];
    var r = ("string" == typeof t ? t : "").split(/[\s,]+/),
        o = r.length;

    for (n = 0; n < o; n++) {
      r[n] && ("-" === (t = r[n].replace(/\*/g, ".*?"))[0] ? e.skips.push(new RegExp("^" + t.substr(1) + "$")) : e.names.push(new RegExp("^" + t + "$")));
    }

    for (n = 0; n < e.instances.length; n++) {
      var i = e.instances[n];
      i.enabled = e.enabled(i.namespace);
    }
  }, e.enabled = function (t) {
    if ("*" === t[t.length - 1]) return !0;
    var n, r;

    for (n = 0, r = e.skips.length; n < r; n++) {
      if (e.skips[n].test(t)) return !1;
    }

    for (n = 0, r = e.names.length; n < r; n++) {
      if (e.names[n].test(t)) return !0;
    }

    return !1;
  }, e.humanize = n(60), e.instances = [], e.names = [], e.skips = [], e.formatters = {};
}, function (t, e) {
  var n = 1e3,
      r = 60 * n,
      o = 60 * r,
      i = 24 * o,
      s = 365.25 * i;

  function a(t, e, n) {
    if (!(t < e)) return t < 1.5 * e ? Math.floor(t / e) + " " + n : Math.ceil(t / e) + " " + n + "s";
  }

  t.exports = function (t, e) {
    e = e || {};
    var c,
        u = typeof t;
    if ("string" === u && t.length > 0) return function (t) {
      if ((t = String(t)).length > 100) return;
      var e = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(t);
      if (!e) return;
      var a = parseFloat(e[1]);

      switch ((e[2] || "ms").toLowerCase()) {
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
          return a * s;

        case "days":
        case "day":
        case "d":
          return a * i;

        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
          return a * o;

        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
          return a * r;

        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
          return a * n;

        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
          return a;

        default:
          return;
      }
    }(t);
    if ("number" === u && !1 === isNaN(t)) return e.long ? a(c = t, i, "day") || a(c, o, "hour") || a(c, r, "minute") || a(c, n, "second") || c + " ms" : function (t) {
      if (t >= i) return Math.round(t / i) + "d";
      if (t >= o) return Math.round(t / o) + "h";
      if (t >= r) return Math.round(t / r) + "m";
      if (t >= n) return Math.round(t / n) + "s";
      return t + "ms";
    }(t);
    throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(t));
  };
}, function (t, e, n) {
  (function (e) {
    var r = n(23),
        o = n(8);
    t.exports = l;
    var i,
        s = /\n/g,
        a = /\\n/g;

    function c() {}

    function u() {
      return "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== e ? e : {};
    }

    function l(t) {
      if (r.call(this, t), this.query = this.query || {}, !i) {
        var e = u();
        i = e.___eio = e.___eio || [];
      }

      this.index = i.length;
      var n = this;
      i.push(function (t) {
        n.onData(t);
      }), this.query.j = this.index, "function" == typeof addEventListener && addEventListener("beforeunload", function () {
        n.script && (n.script.onerror = c);
      }, !1);
    }

    o(l, r), l.prototype.supportsBinary = !1, l.prototype.doClose = function () {
      this.script && (this.script.parentNode.removeChild(this.script), this.script = null), this.form && (this.form.parentNode.removeChild(this.form), this.form = null, this.iframe = null), r.prototype.doClose.call(this);
    }, l.prototype.doPoll = function () {
      var t = this,
          e = document.createElement("script");
      this.script && (this.script.parentNode.removeChild(this.script), this.script = null), e.async = !0, e.src = this.uri(), e.onerror = function (e) {
        t.onError("jsonp poll error", e);
      };
      var n = document.getElementsByTagName("script")[0];
      n ? n.parentNode.insertBefore(e, n) : (document.head || document.body).appendChild(e), this.script = e, "undefined" != typeof navigator && /gecko/i.test(navigator.userAgent) && setTimeout(function () {
        var t = document.createElement("iframe");
        document.body.appendChild(t), document.body.removeChild(t);
      }, 100);
    }, l.prototype.doWrite = function (t, e) {
      var n = this;

      if (!this.form) {
        var r,
            o = document.createElement("form"),
            i = document.createElement("textarea"),
            c = this.iframeId = "eio_iframe_" + this.index;
        o.className = "socketio", o.style.position = "absolute", o.style.top = "-1000px", o.style.left = "-1000px", o.target = c, o.method = "POST", o.setAttribute("accept-charset", "utf-8"), i.name = "d", o.appendChild(i), document.body.appendChild(o), this.form = o, this.area = i;
      }

      function u() {
        l(), e();
      }

      function l() {
        if (n.iframe) try {
          n.form.removeChild(n.iframe);
        } catch (t) {
          n.onError("jsonp polling iframe removal error", t);
        }

        try {
          var t = '<iframe src="javascript:0" name="' + n.iframeId + '">';
          r = document.createElement(t);
        } catch (t) {
          (r = document.createElement("iframe")).name = n.iframeId, r.src = "javascript:0";
        }

        r.id = n.iframeId, n.form.appendChild(r), n.iframe = r;
      }

      this.form.action = this.uri(), l(), t = t.replace(a, "\\\n"), this.area.value = t.replace(s, "\\n");

      try {
        this.form.submit();
      } catch (t) {}

      this.iframe.attachEvent ? this.iframe.onreadystatechange = function () {
        "complete" === n.iframe.readyState && u();
      } : this.iframe.onload = u;
    };
  }).call(this, n(4));
}, function (t, e, n) {
  (function (e) {
    var r,
        o,
        i = n(14),
        s = n(1),
        a = n(7),
        c = n(8),
        u = n(25),
        l = n(9)("engine.io-client:websocket");
    if ("undefined" == typeof self) try {
      o = n(63);
    } catch (t) {} else r = self.WebSocket || self.MozWebSocket;
    var f = r || o;

    function h(t) {
      t && t.forceBase64 && (this.supportsBinary = !1), this.perMessageDeflate = t.perMessageDeflate, this.usingBrowserWebSocket = r && !t.forceNode, this.protocols = t.protocols, this.usingBrowserWebSocket || (f = o), i.call(this, t);
    }

    t.exports = h, c(h, i), h.prototype.name = "websocket", h.prototype.supportsBinary = !0, h.prototype.doOpen = function () {
      if (this.check()) {
        var t = this.uri(),
            e = this.protocols,
            n = {
          agent: this.agent,
          perMessageDeflate: this.perMessageDeflate
        };
        n.pfx = this.pfx, n.key = this.key, n.passphrase = this.passphrase, n.cert = this.cert, n.ca = this.ca, n.ciphers = this.ciphers, n.rejectUnauthorized = this.rejectUnauthorized, this.extraHeaders && (n.headers = this.extraHeaders), this.localAddress && (n.localAddress = this.localAddress);

        try {
          this.ws = this.usingBrowserWebSocket && !this.isReactNative ? e ? new f(t, e) : new f(t) : new f(t, e, n);
        } catch (t) {
          return this.emit("error", t);
        }

        void 0 === this.ws.binaryType && (this.supportsBinary = !1), this.ws.supports && this.ws.supports.binary ? (this.supportsBinary = !0, this.ws.binaryType = "nodebuffer") : this.ws.binaryType = "arraybuffer", this.addEventListeners();
      }
    }, h.prototype.addEventListeners = function () {
      var t = this;
      this.ws.onopen = function () {
        t.onOpen();
      }, this.ws.onclose = function () {
        t.onClose();
      }, this.ws.onmessage = function (e) {
        t.onData(e.data);
      }, this.ws.onerror = function (e) {
        t.onError("websocket error", e);
      };
    }, h.prototype.write = function (t) {
      var n = this;
      this.writable = !1;

      for (var r = t.length, o = 0, i = r; o < i; o++) {
        !function (t) {
          s.encodePacket(t, n.supportsBinary, function (o) {
            if (!n.usingBrowserWebSocket) {
              var i = {};
              if (t.options && (i.compress = t.options.compress), n.perMessageDeflate) ("string" == typeof o ? e.byteLength(o) : o.length) < n.perMessageDeflate.threshold && (i.compress = !1);
            }

            try {
              n.usingBrowserWebSocket ? n.ws.send(o) : n.ws.send(o, i);
            } catch (t) {
              l("websocket closed before onclose event");
            }

            --r || a();
          });
        }(t[o]);
      }

      function a() {
        n.emit("flush"), setTimeout(function () {
          n.writable = !0, n.emit("drain");
        }, 0);
      }
    }, h.prototype.onClose = function () {
      i.prototype.onClose.call(this);
    }, h.prototype.doClose = function () {
      void 0 !== this.ws && this.ws.close();
    }, h.prototype.uri = function () {
      var t = this.query || {},
          e = this.secure ? "wss" : "ws",
          n = "";
      return this.port && ("wss" === e && 443 !== Number(this.port) || "ws" === e && 80 !== Number(this.port)) && (n = ":" + this.port), this.timestampRequests && (t[this.timestampParam] = u()), this.supportsBinary || (t.b64 = 1), (t = a.encode(t)).length && (t = "?" + t), e + "://" + (-1 !== this.hostname.indexOf(":") ? "[" + this.hostname + "]" : this.hostname) + n + this.path + t;
    }, h.prototype.check = function () {
      return !(!f || "__initialize" in f && this.name === h.prototype.name);
    };
  }).call(this, n(12).Buffer);
}, function (t, e) {}, function (t, e) {
  t.exports = function (t, e) {
    for (var n = [], r = (e = e || 0) || 0; r < t.length; r++) {
      n[r - e] = t[r];
    }

    return n;
  };
}, function (t, e) {
  function n(t) {
    t = t || {}, this.ms = t.min || 100, this.max = t.max || 1e4, this.factor = t.factor || 2, this.jitter = t.jitter > 0 && t.jitter <= 1 ? t.jitter : 0, this.attempts = 0;
  }

  t.exports = n, n.prototype.duration = function () {
    var t = this.ms * Math.pow(this.factor, this.attempts++);

    if (this.jitter) {
      var e = Math.random(),
          n = Math.floor(e * this.jitter * t);
      t = 0 == (1 & Math.floor(10 * e)) ? t - n : t + n;
    }

    return 0 | Math.min(t, this.max);
  }, n.prototype.reset = function () {
    this.attempts = 0;
  }, n.prototype.setMin = function (t) {
    this.ms = t;
  }, n.prototype.setMax = function (t) {
    this.max = t;
  }, n.prototype.setJitter = function (t) {
    this.jitter = t;
  };
}, function (t, e, n) {
  var r = n(67),
      o = n(71);
  t.exports = {
    LocalStorage: r,
    MemoryStorage: o
  };
}, function (t, e, n) {
  var r = n(31),
      o = !0;
  t.exports = new (
  /*#__PURE__*/
  function (_r4) {
    "use strict";

    _inherits(_class10, _r4);

    function _class10() {
      _classCallCheck(this, _class10);

      return _possibleConstructorReturn(this, _getPrototypeOf(_class10).call(this, o));
    }

    return _class10;
  }(r))();
}, function (t, e, n) {
  (function (e, n, r) {
    var o;
    o = function o() {
      var t, o, i;
      return function t(e, n, r) {
        function o(s, a) {
          if (!n[s]) {
            if (!e[s]) {
              var c = "function" == typeof _dereq_ && _dereq_;
              if (!a && c) return c(s, !0);
              if (i) return i(s, !0);
              var u = new Error("Cannot find module '" + s + "'");
              throw u.code = "MODULE_NOT_FOUND", u;
            }

            var l = n[s] = {
              exports: {}
            };
            e[s][0].call(l.exports, function (t) {
              var n = e[s][1][t];
              return o(n || t);
            }, l, l.exports, t, e, n, r);
          }

          return n[s].exports;
        }

        for (var i = "function" == typeof _dereq_ && _dereq_, s = 0; s < r.length; s++) {
          o(r[s]);
        }

        return o;
      }({
        1: [function (t, e, n) {
          "use strict";

          e.exports = function (t) {
            var e = t._SomePromiseArray;

            function n(t) {
              var n = new e(t),
                  r = n.promise();
              return n.setHowMany(1), n.setUnwrap(), n.init(), r;
            }

            t.any = function (t) {
              return n(t);
            }, t.prototype.any = function () {
              return n(this);
            };
          };
        }, {}],
        2: [function (t, n, r) {
          "use strict";

          var o;

          try {
            throw new Error();
          } catch (t) {
            o = t;
          }

          var i = t("./schedule"),
              s = t("./queue"),
              a = t("./util");

          function c() {
            this._customScheduler = !1, this._isTickUsed = !1, this._lateQueue = new s(16), this._normalQueue = new s(16), this._haveDrainedQueues = !1, this._trampolineEnabled = !0;
            var t = this;
            this.drainQueues = function () {
              t._drainQueues();
            }, this._schedule = i;
          }

          function u(t, e, n) {
            this._lateQueue.push(t, e, n), this._queueTick();
          }

          function l(t, e, n) {
            this._normalQueue.push(t, e, n), this._queueTick();
          }

          function f(t) {
            this._normalQueue._pushOne(t), this._queueTick();
          }

          function h(t) {
            for (; t.length() > 0;) {
              p(t);
            }
          }

          function p(t) {
            var e = t.shift();
            if ("function" != typeof e) e._settlePromises();else {
              var n = t.shift(),
                  r = t.shift();
              e.call(n, r);
            }
          }

          c.prototype.setScheduler = function (t) {
            var e = this._schedule;
            return this._schedule = t, this._customScheduler = !0, e;
          }, c.prototype.hasCustomScheduler = function () {
            return this._customScheduler;
          }, c.prototype.enableTrampoline = function () {
            this._trampolineEnabled = !0;
          }, c.prototype.disableTrampolineIfNecessary = function () {
            a.hasDevTools && (this._trampolineEnabled = !1);
          }, c.prototype.haveItemsQueued = function () {
            return this._isTickUsed || this._haveDrainedQueues;
          }, c.prototype.fatalError = function (t, n) {
            n ? (e.stderr.write("Fatal " + (t instanceof Error ? t.stack : t) + "\n"), e.exit(2)) : this.throwLater(t);
          }, c.prototype.throwLater = function (t, e) {
            if (1 === arguments.length && (e = t, t = function t() {
              throw e;
            }), "undefined" != typeof setTimeout) setTimeout(function () {
              t(e);
            }, 0);else try {
              this._schedule(function () {
                t(e);
              });
            } catch (t) {
              throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
            }
          }, a.hasDevTools ? (c.prototype.invokeLater = function (t, e, n) {
            this._trampolineEnabled ? u.call(this, t, e, n) : this._schedule(function () {
              setTimeout(function () {
                t.call(e, n);
              }, 100);
            });
          }, c.prototype.invoke = function (t, e, n) {
            this._trampolineEnabled ? l.call(this, t, e, n) : this._schedule(function () {
              t.call(e, n);
            });
          }, c.prototype.settlePromises = function (t) {
            this._trampolineEnabled ? f.call(this, t) : this._schedule(function () {
              t._settlePromises();
            });
          }) : (c.prototype.invokeLater = u, c.prototype.invoke = l, c.prototype.settlePromises = f), c.prototype._drainQueues = function () {
            h(this._normalQueue), this._reset(), this._haveDrainedQueues = !0, h(this._lateQueue);
          }, c.prototype._queueTick = function () {
            this._isTickUsed || (this._isTickUsed = !0, this._schedule(this.drainQueues));
          }, c.prototype._reset = function () {
            this._isTickUsed = !1;
          }, n.exports = c, n.exports.firstLineError = o;
        }, {
          "./queue": 26,
          "./schedule": 29,
          "./util": 36
        }],
        3: [function (t, e, n) {
          "use strict";

          e.exports = function (t, e, n, r) {
            var o = !1,
                i = function i(t, e) {
              this._reject(e);
            },
                s = function s(t, e) {
              e.promiseRejectionQueued = !0, e.bindingPromise._then(i, i, null, this, t);
            },
                a = function a(t, e) {
              0 == (50397184 & this._bitField) && this._resolveCallback(e.target);
            },
                c = function c(t, e) {
              e.promiseRejectionQueued || this._reject(t);
            };

            t.prototype.bind = function (i) {
              o || (o = !0, t.prototype._propagateFrom = r.propagateFromFunction(), t.prototype._boundValue = r.boundValueFunction());
              var u = n(i),
                  l = new t(e);

              l._propagateFrom(this, 1);

              var f = this._target();

              if (l._setBoundTo(u), u instanceof t) {
                var h = {
                  promiseRejectionQueued: !1,
                  promise: l,
                  target: f,
                  bindingPromise: u
                };
                f._then(e, s, void 0, l, h), u._then(a, c, void 0, l, h), l._setOnCancel(u);
              } else l._resolveCallback(f);

              return l;
            }, t.prototype._setBoundTo = function (t) {
              void 0 !== t ? (this._bitField = 2097152 | this._bitField, this._boundTo = t) : this._bitField = -2097153 & this._bitField;
            }, t.prototype._isBound = function () {
              return 2097152 == (2097152 & this._bitField);
            }, t.bind = function (e, n) {
              return t.resolve(n).bind(e);
            };
          };
        }, {}],
        4: [function (t, e, n) {
          "use strict";

          var r;
          "undefined" != typeof Promise && (r = Promise);
          var o = t("./promise")();
          o.noConflict = function () {
            try {
              Promise === o && (Promise = r);
            } catch (t) {}

            return o;
          }, e.exports = o;
        }, {
          "./promise": 22
        }],
        5: [function (t, e, n) {
          "use strict";

          var r = Object.create;

          if (r) {
            var o = r(null),
                i = r(null);
            o[" size"] = i[" size"] = 0;
          }

          e.exports = function (e) {
            var n = t("./util"),
                r = n.canEvaluate;
            n.isIdentifier;

            function o(t) {
              return function (t, r) {
                var o;

                if (null != t && (o = t[r]), "function" != typeof o) {
                  var i = "Object " + n.classString(t) + " has no method '" + n.toString(r) + "'";
                  throw new e.TypeError(i);
                }

                return o;
              }(t, this.pop()).apply(t, this);
            }

            function i(t) {
              return t[this];
            }

            function s(t) {
              var e = +this;
              return e < 0 && (e = Math.max(0, e + t.length)), t[e];
            }

            e.prototype.call = function (t) {
              var e = [].slice.call(arguments, 1);
              return e.push(t), this._then(o, void 0, void 0, e, void 0);
            }, e.prototype.get = function (t) {
              var e;
              if ("number" == typeof t) e = s;else if (r) {
                var n = (void 0)(t);
                e = null !== n ? n : i;
              } else e = i;
              return this._then(e, void 0, void 0, t, void 0);
            };
          };
        }, {
          "./util": 36
        }],
        6: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o) {
            var i = t("./util"),
                s = i.tryCatch,
                a = i.errorObj,
                c = e._async;
            e.prototype.break = e.prototype.cancel = function () {
              if (!o.cancellation()) return this._warn("cancellation is disabled");

              for (var t = this, e = t; t._isCancellable();) {
                if (!t._cancelBy(e)) {
                  e._isFollowing() ? e._followee().cancel() : e._cancelBranched();
                  break;
                }

                var n = t._cancellationParent;

                if (null == n || !n._isCancellable()) {
                  t._isFollowing() ? t._followee().cancel() : t._cancelBranched();
                  break;
                }

                t._isFollowing() && t._followee().cancel(), t._setWillBeCancelled(), e = t, t = n;
              }
            }, e.prototype._branchHasCancelled = function () {
              this._branchesRemainingToCancel--;
            }, e.prototype._enoughBranchesHaveCancelled = function () {
              return void 0 === this._branchesRemainingToCancel || this._branchesRemainingToCancel <= 0;
            }, e.prototype._cancelBy = function (t) {
              return t === this ? (this._branchesRemainingToCancel = 0, this._invokeOnCancel(), !0) : (this._branchHasCancelled(), !!this._enoughBranchesHaveCancelled() && (this._invokeOnCancel(), !0));
            }, e.prototype._cancelBranched = function () {
              this._enoughBranchesHaveCancelled() && this._cancel();
            }, e.prototype._cancel = function () {
              this._isCancellable() && (this._setCancelled(), c.invoke(this._cancelPromises, this, void 0));
            }, e.prototype._cancelPromises = function () {
              this._length() > 0 && this._settlePromises();
            }, e.prototype._unsetOnCancel = function () {
              this._onCancelField = void 0;
            }, e.prototype._isCancellable = function () {
              return this.isPending() && !this._isCancelled();
            }, e.prototype.isCancellable = function () {
              return this.isPending() && !this.isCancelled();
            }, e.prototype._doInvokeOnCancel = function (t, e) {
              if (i.isArray(t)) for (var n = 0; n < t.length; ++n) {
                this._doInvokeOnCancel(t[n], e);
              } else if (void 0 !== t) if ("function" == typeof t) {
                if (!e) {
                  var r = s(t).call(this._boundValue());
                  r === a && (this._attachExtraTrace(r.e), c.throwLater(r.e));
                }
              } else t._resultCancelled(this);
            }, e.prototype._invokeOnCancel = function () {
              var t = this._onCancel();

              this._unsetOnCancel(), c.invoke(this._doInvokeOnCancel, this, t);
            }, e.prototype._invokeInternalOnCancel = function () {
              this._isCancellable() && (this._doInvokeOnCancel(this._onCancel(), !0), this._unsetOnCancel());
            }, e.prototype._resultCancelled = function () {
              this.cancel();
            };
          };
        }, {
          "./util": 36
        }],
        7: [function (t, e, n) {
          "use strict";

          e.exports = function (e) {
            var n = t("./util"),
                r = t("./es5").keys,
                o = n.tryCatch,
                i = n.errorObj;
            return function (t, s, a) {
              return function (c) {
                var u = a._boundValue();

                t: for (var l = 0; l < t.length; ++l) {
                  var f = t[l];

                  if (f === Error || null != f && f.prototype instanceof Error) {
                    if (c instanceof f) return o(s).call(u, c);
                  } else if ("function" == typeof f) {
                    var h = o(f).call(u, c);
                    if (h === i) return h;
                    if (h) return o(s).call(u, c);
                  } else if (n.isObject(c)) {
                    for (var p = r(f), d = 0; d < p.length; ++d) {
                      var y = p[d];
                      if (f[y] != c[y]) continue t;
                    }

                    return o(s).call(u, c);
                  }
                }

                return e;
              };
            };
          };
        }, {
          "./es5": 13,
          "./util": 36
        }],
        8: [function (t, e, n) {
          "use strict";

          e.exports = function (t) {
            var e = !1,
                n = [];

            function r() {
              this._trace = new r.CapturedTrace(o());
            }

            function o() {
              var t = n.length - 1;
              if (t >= 0) return n[t];
            }

            return t.prototype._promiseCreated = function () {}, t.prototype._pushContext = function () {}, t.prototype._popContext = function () {
              return null;
            }, t._peekContext = t.prototype._peekContext = function () {}, r.prototype._pushContext = function () {
              void 0 !== this._trace && (this._trace._promiseCreated = null, n.push(this._trace));
            }, r.prototype._popContext = function () {
              if (void 0 !== this._trace) {
                var t = n.pop(),
                    e = t._promiseCreated;
                return t._promiseCreated = null, e;
              }

              return null;
            }, r.CapturedTrace = null, r.create = function () {
              if (e) return new r();
            }, r.deactivateLongStackTraces = function () {}, r.activateLongStackTraces = function () {
              var n = t.prototype._pushContext,
                  i = t.prototype._popContext,
                  s = t._peekContext,
                  a = t.prototype._peekContext,
                  c = t.prototype._promiseCreated;
              r.deactivateLongStackTraces = function () {
                t.prototype._pushContext = n, t.prototype._popContext = i, t._peekContext = s, t.prototype._peekContext = a, t.prototype._promiseCreated = c, e = !1;
              }, e = !0, t.prototype._pushContext = r.prototype._pushContext, t.prototype._popContext = r.prototype._popContext, t._peekContext = t.prototype._peekContext = o, t.prototype._promiseCreated = function () {
                var t = this._peekContext();

                t && null == t._promiseCreated && (t._promiseCreated = this);
              };
            }, r;
          };
        }, {}],
        9: [function (t, n, r) {
          "use strict";

          n.exports = function (n, r) {
            var o,
                i,
                s,
                a = n._getDomain,
                c = n._async,
                u = t("./errors").Warning,
                l = t("./util"),
                f = t("./es5"),
                h = l.canAttachTrace,
                p = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/,
                d = /\((?:timers\.js):\d+:\d+\)/,
                y = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/,
                g = null,
                v = null,
                m = !1,
                _ = !(0 == l.env("BLUEBIRD_DEBUG")),
                b = !(0 == l.env("BLUEBIRD_WARNINGS") || !_ && !l.env("BLUEBIRD_WARNINGS")),
                w = !(0 == l.env("BLUEBIRD_LONG_STACK_TRACES") || !_ && !l.env("BLUEBIRD_LONG_STACK_TRACES")),
                C = 0 != l.env("BLUEBIRD_W_FORGOTTEN_RETURN") && (b || !!l.env("BLUEBIRD_W_FORGOTTEN_RETURN"));

            n.prototype.suppressUnhandledRejections = function () {
              var t = this._target();

              t._bitField = -1048577 & t._bitField | 524288;
            }, n.prototype._ensurePossibleRejectionHandled = function () {
              if (0 == (524288 & this._bitField)) {
                this._setRejectionIsUnhandled();

                var t = this;
                setTimeout(function () {
                  t._notifyUnhandledRejection();
                }, 1);
              }
            }, n.prototype._notifyUnhandledRejectionIsHandled = function () {
              Y("rejectionHandled", o, void 0, this);
            }, n.prototype._setReturnedNonUndefined = function () {
              this._bitField = 268435456 | this._bitField;
            }, n.prototype._returnedNonUndefined = function () {
              return 0 != (268435456 & this._bitField);
            }, n.prototype._notifyUnhandledRejection = function () {
              if (this._isRejectionUnhandled()) {
                var t = this._settledValue();

                this._setUnhandledRejectionIsNotified(), Y("unhandledRejection", i, t, this);
              }
            }, n.prototype._setUnhandledRejectionIsNotified = function () {
              this._bitField = 262144 | this._bitField;
            }, n.prototype._unsetUnhandledRejectionIsNotified = function () {
              this._bitField = -262145 & this._bitField;
            }, n.prototype._isUnhandledRejectionNotified = function () {
              return (262144 & this._bitField) > 0;
            }, n.prototype._setRejectionIsUnhandled = function () {
              this._bitField = 1048576 | this._bitField;
            }, n.prototype._unsetRejectionIsUnhandled = function () {
              this._bitField = -1048577 & this._bitField, this._isUnhandledRejectionNotified() && (this._unsetUnhandledRejectionIsNotified(), this._notifyUnhandledRejectionIsHandled());
            }, n.prototype._isRejectionUnhandled = function () {
              return (1048576 & this._bitField) > 0;
            }, n.prototype._warn = function (t, e, n) {
              return q(t, e, n || this);
            }, n.onPossiblyUnhandledRejection = function (t) {
              var e = a();
              i = "function" == typeof t ? null === e ? t : l.domainBind(e, t) : void 0;
            }, n.onUnhandledRejectionHandled = function (t) {
              var e = a();
              o = "function" == typeof t ? null === e ? t : l.domainBind(e, t) : void 0;
            };

            var k = function k() {};

            n.longStackTraces = function () {
              if (c.haveItemsQueued() && !Z.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");

              if (!Z.longStackTraces && X()) {
                var t = n.prototype._captureStackTrace,
                    e = n.prototype._attachExtraTrace,
                    o = n.prototype._dereferenceTrace;
                Z.longStackTraces = !0, k = function k() {
                  if (c.haveItemsQueued() && !Z.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
                  n.prototype._captureStackTrace = t, n.prototype._attachExtraTrace = e, n.prototype._dereferenceTrace = o, r.deactivateLongStackTraces(), c.enableTrampoline(), Z.longStackTraces = !1;
                }, n.prototype._captureStackTrace = U, n.prototype._attachExtraTrace = N, n.prototype._dereferenceTrace = L, r.activateLongStackTraces(), c.disableTrampolineIfNecessary();
              }
            }, n.hasLongStackTraces = function () {
              return Z.longStackTraces && X();
            };

            var E = function () {
              try {
                if ("function" == typeof CustomEvent) {
                  var t = new CustomEvent("CustomEvent");
                  return l.global.dispatchEvent(t), function (t, e) {
                    var n = {
                      detail: e,
                      cancelable: !0
                    };
                    f.defineProperty(n, "promise", {
                      value: e.promise
                    }), f.defineProperty(n, "reason", {
                      value: e.reason
                    });
                    var r = new CustomEvent(t.toLowerCase(), n);
                    return !l.global.dispatchEvent(r);
                  };
                }

                if ("function" == typeof Event) {
                  t = new Event("CustomEvent");
                  return l.global.dispatchEvent(t), function (t, e) {
                    var n = new Event(t.toLowerCase(), {
                      cancelable: !0
                    });
                    return n.detail = e, f.defineProperty(n, "promise", {
                      value: e.promise
                    }), f.defineProperty(n, "reason", {
                      value: e.reason
                    }), !l.global.dispatchEvent(n);
                  };
                }

                return (t = document.createEvent("CustomEvent")).initCustomEvent("testingtheevent", !1, !0, {}), l.global.dispatchEvent(t), function (t, e) {
                  var n = document.createEvent("CustomEvent");
                  return n.initCustomEvent(t.toLowerCase(), !1, !0, e), !l.global.dispatchEvent(n);
                };
              } catch (t) {}

              return function () {
                return !1;
              };
            }(),
                F = l.isNode ? function () {
              return e.emit.apply(e, arguments);
            } : l.global ? function (t) {
              var e = "on" + t.toLowerCase(),
                  n = l.global[e];
              return !!n && (n.apply(l.global, [].slice.call(arguments, 1)), !0);
            } : function () {
              return !1;
            };

            function A(t, e) {
              return {
                promise: e
              };
            }

            var T = {
              promiseCreated: A,
              promiseFulfilled: A,
              promiseRejected: A,
              promiseResolved: A,
              promiseCancelled: A,
              promiseChained: function promiseChained(t, e, n) {
                return {
                  promise: e,
                  child: n
                };
              },
              warning: function warning(t, e) {
                return {
                  warning: e
                };
              },
              unhandledRejection: function unhandledRejection(t, e, n) {
                return {
                  reason: e,
                  promise: n
                };
              },
              rejectionHandled: A
            },
                j = function j(t) {
              var e = !1;

              try {
                e = F.apply(null, arguments);
              } catch (t) {
                c.throwLater(t), e = !0;
              }

              var n = !1;

              try {
                n = E(t, T[t].apply(null, arguments));
              } catch (t) {
                c.throwLater(t), n = !0;
              }

              return n || e;
            };

            function P() {
              return !1;
            }

            function x(t, e, n) {
              var r = this;

              try {
                t(e, n, function (t) {
                  if ("function" != typeof t) throw new TypeError("onCancel must be a function, got: " + l.toString(t));

                  r._attachCancellationCallback(t);
                });
              } catch (t) {
                return t;
              }
            }

            function O(t) {
              if (!this._isCancellable()) return this;

              var e = this._onCancel();

              void 0 !== e ? l.isArray(e) ? e.push(t) : this._setOnCancel([e, t]) : this._setOnCancel(t);
            }

            function S() {
              return this._onCancelField;
            }

            function R(t) {
              this._onCancelField = t;
            }

            function B() {
              this._cancellationParent = void 0, this._onCancelField = void 0;
            }

            function I(t, e) {
              if (0 != (1 & e)) {
                this._cancellationParent = t;
                var n = t._branchesRemainingToCancel;
                void 0 === n && (n = 0), t._branchesRemainingToCancel = n + 1;
              }

              0 != (2 & e) && t._isBound() && this._setBoundTo(t._boundTo);
            }

            n.config = function (t) {
              if ("longStackTraces" in (t = Object(t)) && (t.longStackTraces ? n.longStackTraces() : !t.longStackTraces && n.hasLongStackTraces() && k()), "warnings" in t) {
                var e = t.warnings;
                Z.warnings = !!e, C = Z.warnings, l.isObject(e) && "wForgottenReturn" in e && (C = !!e.wForgottenReturn);
              }

              if ("cancellation" in t && t.cancellation && !Z.cancellation) {
                if (c.haveItemsQueued()) throw new Error("cannot enable cancellation after promises are in use");
                n.prototype._clearCancellationData = B, n.prototype._propagateFrom = I, n.prototype._onCancel = S, n.prototype._setOnCancel = R, n.prototype._attachCancellationCallback = O, n.prototype._execute = x, D = I, Z.cancellation = !0;
              }

              return "monitoring" in t && (t.monitoring && !Z.monitoring ? (Z.monitoring = !0, n.prototype._fireEvent = j) : !t.monitoring && Z.monitoring && (Z.monitoring = !1, n.prototype._fireEvent = P)), n;
            }, n.prototype._fireEvent = P, n.prototype._execute = function (t, e, n) {
              try {
                t(e, n);
              } catch (t) {
                return t;
              }
            }, n.prototype._onCancel = function () {}, n.prototype._setOnCancel = function (t) {}, n.prototype._attachCancellationCallback = function (t) {}, n.prototype._captureStackTrace = function () {}, n.prototype._attachExtraTrace = function () {}, n.prototype._dereferenceTrace = function () {}, n.prototype._clearCancellationData = function () {}, n.prototype._propagateFrom = function (t, e) {};

            var D = function D(t, e) {
              0 != (2 & e) && t._isBound() && this._setBoundTo(t._boundTo);
            };

            function M() {
              var t = this._boundTo;
              return void 0 !== t && t instanceof n ? t.isFulfilled() ? t.value() : void 0 : t;
            }

            function U() {
              this._trace = new G(this._peekContext());
            }

            function N(t, e) {
              if (h(t)) {
                var n = this._trace;
                if (void 0 !== n && e && (n = n._parent), void 0 !== n) n.attachExtraTrace(t);else if (!t.__stackCleaned__) {
                  var r = V(t);
                  l.notEnumerableProp(t, "stack", r.message + "\n" + r.stack.join("\n")), l.notEnumerableProp(t, "__stackCleaned__", !0);
                }
              }
            }

            function L() {
              this._trace = void 0;
            }

            function q(t, e, r) {
              if (Z.warnings) {
                var o,
                    i = new u(t);
                if (e) r._attachExtraTrace(i);else if (Z.longStackTraces && (o = n._peekContext())) o.attachExtraTrace(i);else {
                  var s = V(i);
                  i.stack = s.message + "\n" + s.stack.join("\n");
                }
                j("warning", i) || z(i, "", !0);
              }
            }

            function H(t) {
              for (var e = [], n = 0; n < t.length; ++n) {
                var r = t[n],
                    o = "    (No stack trace)" === r || g.test(r),
                    i = o && W(r);
                o && !i && (m && " " !== r.charAt(0) && (r = "    " + r), e.push(r));
              }

              return e;
            }

            function V(t) {
              var e = t.stack,
                  n = t.toString();
              return e = "string" == typeof e && e.length > 0 ? function (t) {
                for (var e = t.stack.replace(/\s+$/g, "").split("\n"), n = 0; n < e.length; ++n) {
                  var r = e[n];
                  if ("    (No stack trace)" === r || g.test(r)) break;
                }

                return n > 0 && "SyntaxError" != t.name && (e = e.slice(n)), e;
              }(t) : ["    (No stack trace)"], {
                message: n,
                stack: "SyntaxError" == t.name ? e : H(e)
              };
            }

            function z(t, e, n) {
              if ("undefined" != typeof console) {
                var r;

                if (l.isObject(t)) {
                  var o = t.stack;
                  r = e + v(o, t);
                } else r = e + String(t);

                "function" == typeof s ? s(r, n) : "function" != typeof console.log && "object" != typeof console.log || console.log(r);
              }
            }

            function Y(t, e, n, r) {
              var o = !1;

              try {
                "function" == typeof e && (o = !0, "rejectionHandled" === t ? e(r) : e(n, r));
              } catch (t) {
                c.throwLater(t);
              }

              "unhandledRejection" === t ? j(t, n, r) || o || z(n, "Unhandled rejection ") : j(t, r);
            }

            function $(t) {
              var e;
              if ("function" == typeof t) e = "[function " + (t.name || "anonymous") + "]";else {
                e = t && "function" == typeof t.toString ? t.toString() : l.toString(t);
                if (/\[object [a-zA-Z0-9$_]+\]/.test(e)) try {
                  e = JSON.stringify(t);
                } catch (t) {}
                0 === e.length && (e = "(empty array)");
              }
              return "(<" + function (t) {
                if (t.length < 41) return t;
                return t.substr(0, 38) + "...";
              }(e) + ">, no stack trace)";
            }

            function X() {
              return "function" == typeof Q;
            }

            var W = function W() {
              return !1;
            },
                J = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;

            function K(t) {
              var e = t.match(J);
              if (e) return {
                fileName: e[1],
                line: parseInt(e[2], 10)
              };
            }

            function G(t) {
              this._parent = t, this._promisesCreated = 0;
              var e = this._length = 1 + (void 0 === t ? 0 : t._length);
              Q(this, G), e > 32 && this.uncycle();
            }

            l.inherits(G, Error), r.CapturedTrace = G, G.prototype.uncycle = function () {
              var t = this._length;

              if (!(t < 2)) {
                for (var e = [], n = {}, r = 0, o = this; void 0 !== o; ++r) {
                  e.push(o), o = o._parent;
                }

                for (r = (t = this._length = r) - 1; r >= 0; --r) {
                  var i = e[r].stack;
                  void 0 === n[i] && (n[i] = r);
                }

                for (r = 0; r < t; ++r) {
                  var s = n[e[r].stack];

                  if (void 0 !== s && s !== r) {
                    s > 0 && (e[s - 1]._parent = void 0, e[s - 1]._length = 1), e[r]._parent = void 0, e[r]._length = 1;
                    var a = r > 0 ? e[r - 1] : this;
                    s < t - 1 ? (a._parent = e[s + 1], a._parent.uncycle(), a._length = a._parent._length + 1) : (a._parent = void 0, a._length = 1);

                    for (var c = a._length + 1, u = r - 2; u >= 0; --u) {
                      e[u]._length = c, c++;
                    }

                    return;
                  }
                }
              }
            }, G.prototype.attachExtraTrace = function (t) {
              if (!t.__stackCleaned__) {
                this.uncycle();

                for (var e = V(t), n = e.message, r = [e.stack], o = this; void 0 !== o;) {
                  r.push(H(o.stack.split("\n"))), o = o._parent;
                }

                !function (t) {
                  for (var e = t[0], n = 1; n < t.length; ++n) {
                    for (var r = t[n], o = e.length - 1, i = e[o], s = -1, a = r.length - 1; a >= 0; --a) {
                      if (r[a] === i) {
                        s = a;
                        break;
                      }
                    }

                    for (a = s; a >= 0; --a) {
                      var c = r[a];
                      if (e[o] !== c) break;
                      e.pop(), o--;
                    }

                    e = r;
                  }
                }(r), function (t) {
                  for (var e = 0; e < t.length; ++e) {
                    (0 === t[e].length || e + 1 < t.length && t[e][0] === t[e + 1][0]) && (t.splice(e, 1), e--);
                  }
                }(r), l.notEnumerableProp(t, "stack", function (t, e) {
                  for (var n = 0; n < e.length - 1; ++n) {
                    e[n].push("From previous event:"), e[n] = e[n].join("\n");
                  }

                  return n < e.length && (e[n] = e[n].join("\n")), t + "\n" + e.join("\n");
                }(n, r)), l.notEnumerableProp(t, "__stackCleaned__", !0);
              }
            };

            var Q = function () {
              var t = /^\s*at\s*/,
                  e = function e(t, _e2) {
                return "string" == typeof t ? t : void 0 !== _e2.name && void 0 !== _e2.message ? _e2.toString() : $(_e2);
              };

              if ("number" == typeof Error.stackTraceLimit && "function" == typeof Error.captureStackTrace) {
                Error.stackTraceLimit += 6, g = t, v = e;
                var n = Error.captureStackTrace;
                return W = function W(t) {
                  return p.test(t);
                }, function (t, e) {
                  Error.stackTraceLimit += 6, n(t, e), Error.stackTraceLimit -= 6;
                };
              }

              var r,
                  o = new Error();
              if ("string" == typeof o.stack && o.stack.split("\n")[0].indexOf("stackDetection@") >= 0) return g = /@/, v = e, m = !0, function (t) {
                t.stack = new Error().stack;
              };

              try {
                throw new Error();
              } catch (t) {
                r = "stack" in t;
              }

              return "stack" in o || !r || "number" != typeof Error.stackTraceLimit ? (v = function v(t, e) {
                return "string" == typeof t ? t : "object" != typeof e && "function" != typeof e || void 0 === e.name || void 0 === e.message ? $(e) : e.toString();
              }, null) : (g = t, v = e, function (t) {
                Error.stackTraceLimit += 6;

                try {
                  throw new Error();
                } catch (e) {
                  t.stack = e.stack;
                }

                Error.stackTraceLimit -= 6;
              });
            }();

            "undefined" != typeof console && void 0 !== console.warn && (s = function s(t) {
              console.warn(t);
            }, l.isNode && e.stderr.isTTY ? s = function s(t, e) {
              var n = e ? "[33m" : "[31m";
              console.warn(n + t + "[0m\n");
            } : l.isNode || "string" != typeof new Error().stack || (s = function s(t, e) {
              console.warn("%c" + t, e ? "color: darkorange" : "color: red");
            }));
            var Z = {
              warnings: b,
              longStackTraces: !1,
              cancellation: !1,
              monitoring: !1
            };
            return w && n.longStackTraces(), {
              longStackTraces: function longStackTraces() {
                return Z.longStackTraces;
              },
              warnings: function warnings() {
                return Z.warnings;
              },
              cancellation: function cancellation() {
                return Z.cancellation;
              },
              monitoring: function monitoring() {
                return Z.monitoring;
              },
              propagateFromFunction: function propagateFromFunction() {
                return D;
              },
              boundValueFunction: function boundValueFunction() {
                return M;
              },
              checkForgottenReturns: function checkForgottenReturns(t, e, n, r, o) {
                if (void 0 === t && null !== e && C) {
                  if (void 0 !== o && o._returnedNonUndefined()) return;
                  if (0 == (65535 & r._bitField)) return;
                  n && (n += " ");
                  var i = "",
                      s = "";

                  if (e._trace) {
                    for (var a = e._trace.stack.split("\n"), c = H(a), u = c.length - 1; u >= 0; --u) {
                      var l = c[u];

                      if (!d.test(l)) {
                        var f = l.match(y);
                        f && (i = "at " + f[1] + ":" + f[2] + ":" + f[3] + " ");
                        break;
                      }
                    }

                    if (c.length > 0) {
                      var h = c[0];

                      for (u = 0; u < a.length; ++u) {
                        if (a[u] === h) {
                          u > 0 && (s = "\n" + a[u - 1]);
                          break;
                        }
                      }
                    }
                  }

                  var p = "a promise was created in a " + n + "handler " + i + "but was not returned from it, see http://goo.gl/rRqMUw" + s;

                  r._warn(p, !0, e);
                }
              },
              setBounds: function setBounds(t, e) {
                if (X()) {
                  for (var n, r, o = t.stack.split("\n"), i = e.stack.split("\n"), s = -1, a = -1, c = 0; c < o.length; ++c) {
                    if (u = K(o[c])) {
                      n = u.fileName, s = u.line;
                      break;
                    }
                  }

                  for (c = 0; c < i.length; ++c) {
                    var u;

                    if (u = K(i[c])) {
                      r = u.fileName, a = u.line;
                      break;
                    }
                  }

                  s < 0 || a < 0 || !n || !r || n !== r || s >= a || (W = function W(t) {
                    if (p.test(t)) return !0;
                    var e = K(t);
                    return !!(e && e.fileName === n && s <= e.line && e.line <= a);
                  });
                }
              },
              warn: q,
              deprecated: function deprecated(t, e) {
                var n = t + " is deprecated and will be removed in a future version.";
                return e && (n += " Use " + e + " instead."), q(n);
              },
              CapturedTrace: G,
              fireDomEvent: E,
              fireGlobalEvent: F
            };
          };
        }, {
          "./errors": 12,
          "./es5": 13,
          "./util": 36
        }],
        10: [function (t, e, n) {
          "use strict";

          e.exports = function (t) {
            function e() {
              return this.value;
            }

            function n() {
              throw this.reason;
            }

            t.prototype.return = t.prototype.thenReturn = function (n) {
              return n instanceof t && n.suppressUnhandledRejections(), this._then(e, void 0, void 0, {
                value: n
              }, void 0);
            }, t.prototype.throw = t.prototype.thenThrow = function (t) {
              return this._then(n, void 0, void 0, {
                reason: t
              }, void 0);
            }, t.prototype.catchThrow = function (t) {
              if (arguments.length <= 1) return this._then(void 0, n, void 0, {
                reason: t
              }, void 0);
              var e = arguments[1];
              return this.caught(t, function () {
                throw e;
              });
            }, t.prototype.catchReturn = function (n) {
              if (arguments.length <= 1) return n instanceof t && n.suppressUnhandledRejections(), this._then(void 0, e, void 0, {
                value: n
              }, void 0);
              var r = arguments[1];
              r instanceof t && r.suppressUnhandledRejections();
              return this.caught(n, function () {
                return r;
              });
            };
          };
        }, {}],
        11: [function (t, e, n) {
          "use strict";

          e.exports = function (t, e) {
            var n = t.reduce,
                r = t.all;

            function o() {
              return r(this);
            }

            t.prototype.each = function (t) {
              return n(this, t, e, 0)._then(o, void 0, void 0, this, void 0);
            }, t.prototype.mapSeries = function (t) {
              return n(this, t, e, e);
            }, t.each = function (t, r) {
              return n(t, r, e, 0)._then(o, void 0, void 0, t, void 0);
            }, t.mapSeries = function (t, r) {
              return n(t, r, e, e);
            };
          };
        }, {}],
        12: [function (t, e, n) {
          "use strict";

          var r,
              o,
              i = t("./es5"),
              s = i.freeze,
              a = t("./util"),
              c = a.inherits,
              u = a.notEnumerableProp;

          function l(t, e) {
            function n(r) {
              if (!(this instanceof n)) return new n(r);
              u(this, "message", "string" == typeof r ? r : e), u(this, "name", t), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : Error.call(this);
            }

            return c(n, Error), n;
          }

          var f = l("Warning", "warning"),
              h = l("CancellationError", "cancellation error"),
              p = l("TimeoutError", "timeout error"),
              d = l("AggregateError", "aggregate error");

          try {
            r = TypeError, o = RangeError;
          } catch (t) {
            r = l("TypeError", "type error"), o = l("RangeError", "range error");
          }

          for (var y = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" "), g = 0; g < y.length; ++g) {
            "function" == typeof Array.prototype[y[g]] && (d.prototype[y[g]] = Array.prototype[y[g]]);
          }

          i.defineProperty(d.prototype, "length", {
            value: 0,
            configurable: !1,
            writable: !0,
            enumerable: !0
          }), d.prototype.isOperational = !0;
          var v = 0;

          function m(t) {
            if (!(this instanceof m)) return new m(t);
            u(this, "name", "OperationalError"), u(this, "message", t), this.cause = t, this.isOperational = !0, t instanceof Error ? (u(this, "message", t.message), u(this, "stack", t.stack)) : Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
          }

          d.prototype.toString = function () {
            var t = Array(4 * v + 1).join(" "),
                e = "\n" + t + "AggregateError of:\n";
            v++, t = Array(4 * v + 1).join(" ");

            for (var n = 0; n < this.length; ++n) {
              for (var r = this[n] === this ? "[Circular AggregateError]" : this[n] + "", o = r.split("\n"), i = 0; i < o.length; ++i) {
                o[i] = t + o[i];
              }

              e += (r = o.join("\n")) + "\n";
            }

            return v--, e;
          }, c(m, Error);
          var _ = Error.__BluebirdErrorTypes__;
          _ || (_ = s({
            CancellationError: h,
            TimeoutError: p,
            OperationalError: m,
            RejectionError: m,
            AggregateError: d
          }), i.defineProperty(Error, "__BluebirdErrorTypes__", {
            value: _,
            writable: !1,
            enumerable: !1,
            configurable: !1
          })), e.exports = {
            Error: Error,
            TypeError: r,
            RangeError: o,
            CancellationError: _.CancellationError,
            OperationalError: _.OperationalError,
            TimeoutError: _.TimeoutError,
            AggregateError: _.AggregateError,
            Warning: f
          };
        }, {
          "./es5": 13,
          "./util": 36
        }],
        13: [function (t, e, n) {
          var r = function () {
            "use strict";

            return void 0 === this;
          }();

          if (r) e.exports = {
            freeze: Object.freeze,
            defineProperty: Object.defineProperty,
            getDescriptor: Object.getOwnPropertyDescriptor,
            keys: Object.keys,
            names: Object.getOwnPropertyNames,
            getPrototypeOf: Object.getPrototypeOf,
            isArray: Array.isArray,
            isES5: r,
            propertyIsWritable: function propertyIsWritable(t, e) {
              var n = Object.getOwnPropertyDescriptor(t, e);
              return !(n && !n.writable && !n.set);
            }
          };else {
            var o = {}.hasOwnProperty,
                i = {}.toString,
                s = {}.constructor.prototype,
                a = function a(t) {
              var e = [];

              for (var n in t) {
                o.call(t, n) && e.push(n);
              }

              return e;
            };

            e.exports = {
              isArray: function isArray(t) {
                try {
                  return "[object Array]" === i.call(t);
                } catch (t) {
                  return !1;
                }
              },
              keys: a,
              names: a,
              defineProperty: function defineProperty(t, e, n) {
                return t[e] = n.value, t;
              },
              getDescriptor: function getDescriptor(t, e) {
                return {
                  value: t[e]
                };
              },
              freeze: function freeze(t) {
                return t;
              },
              getPrototypeOf: function getPrototypeOf(t) {
                try {
                  return Object(t).constructor.prototype;
                } catch (t) {
                  return s;
                }
              },
              isES5: r,
              propertyIsWritable: function propertyIsWritable() {
                return !0;
              }
            };
          }
        }, {}],
        14: [function (t, e, n) {
          "use strict";

          e.exports = function (t, e) {
            var n = t.map;
            t.prototype.filter = function (t, r) {
              return n(this, t, r, e);
            }, t.filter = function (t, r, o) {
              return n(t, r, o, e);
            };
          };
        }, {}],
        15: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r) {
            var o = t("./util"),
                i = e.CancellationError,
                s = o.errorObj,
                a = t("./catch_filter")(r);

            function c(t, e, n) {
              this.promise = t, this.type = e, this.handler = n, this.called = !1, this.cancelPromise = null;
            }

            function u(t) {
              this.finallyHandler = t;
            }

            function l(t, e) {
              return null != t.cancelPromise && (arguments.length > 1 ? t.cancelPromise._reject(e) : t.cancelPromise._cancel(), t.cancelPromise = null, !0);
            }

            function f() {
              return p.call(this, this.promise._target()._settledValue());
            }

            function h(t) {
              if (!l(this, t)) return s.e = t, s;
            }

            function p(t) {
              var o = this.promise,
                  a = this.handler;

              if (!this.called) {
                this.called = !0;
                var c = this.isFinallyHandler() ? a.call(o._boundValue()) : a.call(o._boundValue(), t);
                if (c === r) return c;

                if (void 0 !== c) {
                  o._setReturnedNonUndefined();

                  var p = n(c, o);

                  if (p instanceof e) {
                    if (null != this.cancelPromise) {
                      if (p._isCancelled()) {
                        var d = new i("late cancellation observer");
                        return o._attachExtraTrace(d), s.e = d, s;
                      }

                      p.isPending() && p._attachCancellationCallback(new u(this));
                    }

                    return p._then(f, h, void 0, this, void 0);
                  }
                }
              }

              return o.isRejected() ? (l(this), s.e = t, s) : (l(this), t);
            }

            return c.prototype.isFinallyHandler = function () {
              return 0 === this.type;
            }, u.prototype._resultCancelled = function () {
              l(this.finallyHandler);
            }, e.prototype._passThrough = function (t, e, n, r) {
              return "function" != typeof t ? this.then() : this._then(n, r, void 0, new c(this, e, t), void 0);
            }, e.prototype.lastly = e.prototype.finally = function (t) {
              return this._passThrough(t, 0, p, p);
            }, e.prototype.tap = function (t) {
              return this._passThrough(t, 1, p);
            }, e.prototype.tapCatch = function (t) {
              var n = arguments.length;
              if (1 === n) return this._passThrough(t, 1, void 0, p);
              var r,
                  i = new Array(n - 1),
                  s = 0;

              for (r = 0; r < n - 1; ++r) {
                var c = arguments[r];
                if (!o.isObject(c)) return e.reject(new TypeError("tapCatch statement predicate: expecting an object but got " + o.classString(c)));
                i[s++] = c;
              }

              i.length = s;
              var u = arguments[r];
              return this._passThrough(a(i, u, this), 1, void 0, p);
            }, c;
          };
        }, {
          "./catch_filter": 7,
          "./util": 36
        }],
        16: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o, i, s) {
            var a = t("./errors").TypeError,
                c = t("./util"),
                u = c.errorObj,
                l = c.tryCatch,
                f = [];

            function h(t, n, o, i) {
              if (s.cancellation()) {
                var a = new e(r),
                    c = this._finallyPromise = new e(r);
                this._promise = a.lastly(function () {
                  return c;
                }), a._captureStackTrace(), a._setOnCancel(this);
              } else {
                (this._promise = new e(r))._captureStackTrace();
              }

              this._stack = i, this._generatorFunction = t, this._receiver = n, this._generator = void 0, this._yieldHandlers = "function" == typeof o ? [o].concat(f) : f, this._yieldedPromise = null, this._cancellationPhase = !1;
            }

            c.inherits(h, i), h.prototype._isResolved = function () {
              return null === this._promise;
            }, h.prototype._cleanup = function () {
              this._promise = this._generator = null, s.cancellation() && null !== this._finallyPromise && (this._finallyPromise._fulfill(), this._finallyPromise = null);
            }, h.prototype._promiseCancelled = function () {
              if (!this._isResolved()) {
                var t;
                if (void 0 !== this._generator.return) this._promise._pushContext(), t = l(this._generator.return).call(this._generator, void 0), this._promise._popContext();else {
                  var n = new e.CancellationError("generator .return() sentinel");
                  e.coroutine.returnSentinel = n, this._promise._attachExtraTrace(n), this._promise._pushContext(), t = l(this._generator.throw).call(this._generator, n), this._promise._popContext();
                }
                this._cancellationPhase = !0, this._yieldedPromise = null, this._continue(t);
              }
            }, h.prototype._promiseFulfilled = function (t) {
              this._yieldedPromise = null, this._promise._pushContext();
              var e = l(this._generator.next).call(this._generator, t);
              this._promise._popContext(), this._continue(e);
            }, h.prototype._promiseRejected = function (t) {
              this._yieldedPromise = null, this._promise._attachExtraTrace(t), this._promise._pushContext();
              var e = l(this._generator.throw).call(this._generator, t);
              this._promise._popContext(), this._continue(e);
            }, h.prototype._resultCancelled = function () {
              if (this._yieldedPromise instanceof e) {
                var t = this._yieldedPromise;
                this._yieldedPromise = null, t.cancel();
              }
            }, h.prototype.promise = function () {
              return this._promise;
            }, h.prototype._run = function () {
              this._generator = this._generatorFunction.call(this._receiver), this._receiver = this._generatorFunction = void 0, this._promiseFulfilled(void 0);
            }, h.prototype._continue = function (t) {
              var n = this._promise;
              if (t === u) return this._cleanup(), this._cancellationPhase ? n.cancel() : n._rejectCallback(t.e, !1);
              var r = t.value;
              if (!0 === t.done) return this._cleanup(), this._cancellationPhase ? n.cancel() : n._resolveCallback(r);
              var i = o(r, this._promise);

              if (i instanceof e || null !== (i = function (t, n, r) {
                for (var i = 0; i < n.length; ++i) {
                  r._pushContext();

                  var s = l(n[i])(t);

                  if (r._popContext(), s === u) {
                    r._pushContext();

                    var a = e.reject(u.e);
                    return r._popContext(), a;
                  }

                  var c = o(s, r);
                  if (c instanceof e) return c;
                }

                return null;
              }(i, this._yieldHandlers, this._promise))) {
                var s = (i = i._target())._bitField;

                0 == (50397184 & s) ? (this._yieldedPromise = i, i._proxy(this, null)) : 0 != (33554432 & s) ? e._async.invoke(this._promiseFulfilled, this, i._value()) : 0 != (16777216 & s) ? e._async.invoke(this._promiseRejected, this, i._reason()) : this._promiseCancelled();
              } else this._promiseRejected(new a("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s", String(r)) + "From coroutine:\n" + this._stack.split("\n").slice(1, -7).join("\n")));
            }, e.coroutine = function (t, e) {
              if ("function" != typeof t) throw new a("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
              var n = Object(e).yieldHandler,
                  r = h,
                  o = new Error().stack;
              return function () {
                var e = t.apply(this, arguments),
                    i = new r(void 0, void 0, n, o),
                    s = i.promise();
                return i._generator = e, i._promiseFulfilled(void 0), s;
              };
            }, e.coroutine.addYieldHandler = function (t) {
              if ("function" != typeof t) throw new a("expecting a function but got " + c.classString(t));
              f.push(t);
            }, e.spawn = function (t) {
              if (s.deprecated("Promise.spawn()", "Promise.coroutine()"), "function" != typeof t) return n("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
              var r = new h(t, this),
                  o = r.promise();
              return r._run(e.spawn), o;
            };
          };
        }, {
          "./errors": 12,
          "./util": 36
        }],
        17: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o, i, s) {
            var a = t("./util");
            a.canEvaluate, a.tryCatch, a.errorObj;

            e.join = function () {
              var t,
                  e = arguments.length - 1;
              e > 0 && "function" == typeof arguments[e] && (t = arguments[e]);
              var r = [].slice.call(arguments);
              t && r.pop();
              var o = new n(r).promise();
              return void 0 !== t ? o.spread(t) : o;
            };
          };
        }, {
          "./util": 36
        }],
        18: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o, i, s) {
            var a = e._getDomain,
                c = t("./util"),
                u = c.tryCatch,
                l = c.errorObj,
                f = e._async;

            function h(t, e, n, r) {
              this.constructor$(t), this._promise._captureStackTrace();
              var o = a();
              this._callback = null === o ? e : c.domainBind(o, e), this._preservedValues = r === i ? new Array(this.length()) : null, this._limit = n, this._inFlight = 0, this._queue = [], f.invoke(this._asyncInit, this, void 0);
            }

            function p(t, n, o, i) {
              if ("function" != typeof n) return r("expecting a function but got " + c.classString(n));
              var s = 0;

              if (void 0 !== o) {
                if ("object" != typeof o || null === o) return e.reject(new TypeError("options argument must be an object but it is " + c.classString(o)));
                if ("number" != typeof o.concurrency) return e.reject(new TypeError("'concurrency' must be a number but it is " + c.classString(o.concurrency)));
                s = o.concurrency;
              }

              return new h(t, n, s = "number" == typeof s && isFinite(s) && s >= 1 ? s : 0, i).promise();
            }

            c.inherits(h, n), h.prototype._asyncInit = function () {
              this._init$(void 0, -2);
            }, h.prototype._init = function () {}, h.prototype._promiseFulfilled = function (t, n) {
              var r = this._values,
                  i = this.length(),
                  a = this._preservedValues,
                  c = this._limit;

              if (n < 0) {
                if (r[n = -1 * n - 1] = t, c >= 1 && (this._inFlight--, this._drainQueue(), this._isResolved())) return !0;
              } else {
                if (c >= 1 && this._inFlight >= c) return r[n] = t, this._queue.push(n), !1;
                null !== a && (a[n] = t);

                var f = this._promise,
                    h = this._callback,
                    p = f._boundValue();

                f._pushContext();

                var d = u(h).call(p, t, n, i),
                    y = f._popContext();

                if (s.checkForgottenReturns(d, y, null !== a ? "Promise.filter" : "Promise.map", f), d === l) return this._reject(d.e), !0;
                var g = o(d, this._promise);

                if (g instanceof e) {
                  var v = (g = g._target())._bitField;

                  if (0 == (50397184 & v)) return c >= 1 && this._inFlight++, r[n] = g, g._proxy(this, -1 * (n + 1)), !1;
                  if (0 == (33554432 & v)) return 0 != (16777216 & v) ? (this._reject(g._reason()), !0) : (this._cancel(), !0);
                  d = g._value();
                }

                r[n] = d;
              }

              return ++this._totalResolved >= i && (null !== a ? this._filter(r, a) : this._resolve(r), !0);
            }, h.prototype._drainQueue = function () {
              for (var t = this._queue, e = this._limit, n = this._values; t.length > 0 && this._inFlight < e;) {
                if (this._isResolved()) return;
                var r = t.pop();

                this._promiseFulfilled(n[r], r);
              }
            }, h.prototype._filter = function (t, e) {
              for (var n = e.length, r = new Array(n), o = 0, i = 0; i < n; ++i) {
                t[i] && (r[o++] = e[i]);
              }

              r.length = o, this._resolve(r);
            }, h.prototype.preservedValues = function () {
              return this._preservedValues;
            }, e.prototype.map = function (t, e) {
              return p(this, t, e, null);
            }, e.map = function (t, e, n, r) {
              return p(t, e, n, r);
            };
          };
        }, {
          "./util": 36
        }],
        19: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o, i) {
            var s = t("./util"),
                a = s.tryCatch;
            e.method = function (t) {
              if ("function" != typeof t) throw new e.TypeError("expecting a function but got " + s.classString(t));
              return function () {
                var r = new e(n);
                r._captureStackTrace(), r._pushContext();

                var o = a(t).apply(this, arguments),
                    s = r._popContext();

                return i.checkForgottenReturns(o, s, "Promise.method", r), r._resolveFromSyncValue(o), r;
              };
            }, e.attempt = e.try = function (t) {
              if ("function" != typeof t) return o("expecting a function but got " + s.classString(t));
              var r,
                  c = new e(n);

              if (c._captureStackTrace(), c._pushContext(), arguments.length > 1) {
                i.deprecated("calling Promise.try with more than 1 argument");
                var u = arguments[1],
                    l = arguments[2];
                r = s.isArray(u) ? a(t).apply(l, u) : a(t).call(l, u);
              } else r = a(t)();

              var f = c._popContext();

              return i.checkForgottenReturns(r, f, "Promise.try", c), c._resolveFromSyncValue(r), c;
            }, e.prototype._resolveFromSyncValue = function (t) {
              t === s.errorObj ? this._rejectCallback(t.e, !1) : this._resolveCallback(t, !0);
            };
          };
        }, {
          "./util": 36
        }],
        20: [function (t, e, n) {
          "use strict";

          var r = t("./util"),
              o = r.maybeWrapAsError,
              i = t("./errors").OperationalError,
              s = t("./es5");
          var a = /^(?:name|message|stack|cause)$/;

          function c(t) {
            var e;

            if (function (t) {
              return t instanceof Error && s.getPrototypeOf(t) === Error.prototype;
            }(t)) {
              (e = new i(t)).name = t.name, e.message = t.message, e.stack = t.stack;

              for (var n = s.keys(t), o = 0; o < n.length; ++o) {
                var c = n[o];
                a.test(c) || (e[c] = t[c]);
              }

              return e;
            }

            return r.markAsOriginatingFromRejection(t), t;
          }

          e.exports = function (t, e) {
            return function (n, r) {
              if (null !== t) {
                if (n) {
                  var i = c(o(n));
                  t._attachExtraTrace(i), t._reject(i);
                } else if (e) {
                  var s = [].slice.call(arguments, 1);

                  t._fulfill(s);
                } else t._fulfill(r);

                t = null;
              }
            };
          };
        }, {
          "./errors": 12,
          "./es5": 13,
          "./util": 36
        }],
        21: [function (t, e, n) {
          "use strict";

          e.exports = function (e) {
            var n = t("./util"),
                r = e._async,
                o = n.tryCatch,
                i = n.errorObj;

            function s(t, e) {
              if (!n.isArray(t)) return a.call(this, t, e);
              var s = o(e).apply(this._boundValue(), [null].concat(t));
              s === i && r.throwLater(s.e);
            }

            function a(t, e) {
              var n = this._boundValue(),
                  s = void 0 === t ? o(e).call(n, null) : o(e).call(n, null, t);

              s === i && r.throwLater(s.e);
            }

            function c(t, e) {
              if (!t) {
                var n = new Error(t + "");
                n.cause = t, t = n;
              }

              var s = o(e).call(this._boundValue(), t);
              s === i && r.throwLater(s.e);
            }

            e.prototype.asCallback = e.prototype.nodeify = function (t, e) {
              if ("function" == typeof t) {
                var n = a;
                void 0 !== e && Object(e).spread && (n = s), this._then(n, c, void 0, this, t);
              }

              return this;
            };
          };
        }, {
          "./util": 36
        }],
        22: [function (t, n, r) {
          "use strict";

          n.exports = function () {
            var r = function r() {
              return new d("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n");
            },
                o = function o() {
              return new P.PromiseInspection(this._target());
            },
                i = function i(t) {
              return P.reject(new d(t));
            };

            function s() {}

            var a,
                c = {},
                u = t("./util");
            a = u.isNode ? function () {
              var t = e.domain;
              return void 0 === t && (t = null), t;
            } : function () {
              return null;
            }, u.notEnumerableProp(P, "_getDomain", a);
            var l = t("./es5"),
                f = t("./async"),
                h = new f();
            l.defineProperty(P, "_async", {
              value: h
            });
            var p = t("./errors"),
                d = P.TypeError = p.TypeError;
            P.RangeError = p.RangeError;
            var y = P.CancellationError = p.CancellationError;
            P.TimeoutError = p.TimeoutError, P.OperationalError = p.OperationalError, P.RejectionError = p.OperationalError, P.AggregateError = p.AggregateError;

            var g = function g() {},
                v = {},
                m = {},
                _ = t("./thenables")(P, g),
                b = t("./promise_array")(P, g, _, i, s),
                w = t("./context")(P),
                C = w.create,
                k = t("./debuggability")(P, w),
                E = (k.CapturedTrace, t("./finally")(P, _, m)),
                F = t("./catch_filter")(m),
                A = t("./nodeback"),
                T = u.errorObj,
                j = u.tryCatch;

            function P(t) {
              t !== g && function (t, e) {
                if (null == t || t.constructor !== P) throw new d("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");
                if ("function" != typeof e) throw new d("expecting a function but got " + u.classString(e));
              }(this, t), this._bitField = 0, this._fulfillmentHandler0 = void 0, this._rejectionHandler0 = void 0, this._promise0 = void 0, this._receiver0 = void 0, this._resolveFromExecutor(t), this._promiseCreated(), this._fireEvent("promiseCreated", this);
            }

            function x(t) {
              this.promise._resolveCallback(t);
            }

            function O(t) {
              this.promise._rejectCallback(t, !1);
            }

            function S(t) {
              var e = new P(g);
              e._fulfillmentHandler0 = t, e._rejectionHandler0 = t, e._promise0 = t, e._receiver0 = t;
            }

            return P.prototype.toString = function () {
              return "[object Promise]";
            }, P.prototype.caught = P.prototype.catch = function (t) {
              var e = arguments.length;

              if (e > 1) {
                var n,
                    r = new Array(e - 1),
                    o = 0;

                for (n = 0; n < e - 1; ++n) {
                  var s = arguments[n];
                  if (!u.isObject(s)) return i("Catch statement predicate: expecting an object but got " + u.classString(s));
                  r[o++] = s;
                }

                return r.length = o, t = arguments[n], this.then(void 0, F(r, t, this));
              }

              return this.then(void 0, t);
            }, P.prototype.reflect = function () {
              return this._then(o, o, void 0, this, void 0);
            }, P.prototype.then = function (t, e) {
              if (k.warnings() && arguments.length > 0 && "function" != typeof t && "function" != typeof e) {
                var n = ".then() only accepts functions but was passed: " + u.classString(t);
                arguments.length > 1 && (n += ", " + u.classString(e)), this._warn(n);
              }

              return this._then(t, e, void 0, void 0, void 0);
            }, P.prototype.done = function (t, e) {
              this._then(t, e, void 0, void 0, void 0)._setIsFinal();
            }, P.prototype.spread = function (t) {
              return "function" != typeof t ? i("expecting a function but got " + u.classString(t)) : this.all()._then(t, void 0, void 0, v, void 0);
            }, P.prototype.toJSON = function () {
              var t = {
                isFulfilled: !1,
                isRejected: !1,
                fulfillmentValue: void 0,
                rejectionReason: void 0
              };
              return this.isFulfilled() ? (t.fulfillmentValue = this.value(), t.isFulfilled = !0) : this.isRejected() && (t.rejectionReason = this.reason(), t.isRejected = !0), t;
            }, P.prototype.all = function () {
              return arguments.length > 0 && this._warn(".all() was passed arguments but it does not take any"), new b(this).promise();
            }, P.prototype.error = function (t) {
              return this.caught(u.originatesFromRejection, t);
            }, P.getNewLibraryCopy = n.exports, P.is = function (t) {
              return t instanceof P;
            }, P.fromNode = P.fromCallback = function (t) {
              var e = new P(g);

              e._captureStackTrace();

              var n = arguments.length > 1 && !!Object(arguments[1]).multiArgs,
                  r = j(t)(A(e, n));
              return r === T && e._rejectCallback(r.e, !0), e._isFateSealed() || e._setAsyncGuaranteed(), e;
            }, P.all = function (t) {
              return new b(t).promise();
            }, P.cast = function (t) {
              var e = _(t);

              return e instanceof P || ((e = new P(g))._captureStackTrace(), e._setFulfilled(), e._rejectionHandler0 = t), e;
            }, P.resolve = P.fulfilled = P.cast, P.reject = P.rejected = function (t) {
              var e = new P(g);
              return e._captureStackTrace(), e._rejectCallback(t, !0), e;
            }, P.setScheduler = function (t) {
              if ("function" != typeof t) throw new d("expecting a function but got " + u.classString(t));
              return h.setScheduler(t);
            }, P.prototype._then = function (t, e, n, r, o) {
              var i = void 0 !== o,
                  s = i ? o : new P(g),
                  c = this._target(),
                  l = c._bitField;

              i || (s._propagateFrom(this, 3), s._captureStackTrace(), void 0 === r && 0 != (2097152 & this._bitField) && (r = 0 != (50397184 & l) ? this._boundValue() : c === this ? void 0 : this._boundTo), this._fireEvent("promiseChained", this, s));
              var f = a();

              if (0 != (50397184 & l)) {
                var p,
                    d,
                    v = c._settlePromiseCtx;
                0 != (33554432 & l) ? (d = c._rejectionHandler0, p = t) : 0 != (16777216 & l) ? (d = c._fulfillmentHandler0, p = e, c._unsetRejectionIsUnhandled()) : (v = c._settlePromiseLateCancellationObserver, d = new y("late cancellation observer"), c._attachExtraTrace(d), p = e), h.invoke(v, c, {
                  handler: null === f ? p : "function" == typeof p && u.domainBind(f, p),
                  promise: s,
                  receiver: r,
                  value: d
                });
              } else c._addCallbacks(t, e, s, r, f);

              return s;
            }, P.prototype._length = function () {
              return 65535 & this._bitField;
            }, P.prototype._isFateSealed = function () {
              return 0 != (117506048 & this._bitField);
            }, P.prototype._isFollowing = function () {
              return 67108864 == (67108864 & this._bitField);
            }, P.prototype._setLength = function (t) {
              this._bitField = -65536 & this._bitField | 65535 & t;
            }, P.prototype._setFulfilled = function () {
              this._bitField = 33554432 | this._bitField, this._fireEvent("promiseFulfilled", this);
            }, P.prototype._setRejected = function () {
              this._bitField = 16777216 | this._bitField, this._fireEvent("promiseRejected", this);
            }, P.prototype._setFollowing = function () {
              this._bitField = 67108864 | this._bitField, this._fireEvent("promiseResolved", this);
            }, P.prototype._setIsFinal = function () {
              this._bitField = 4194304 | this._bitField;
            }, P.prototype._isFinal = function () {
              return (4194304 & this._bitField) > 0;
            }, P.prototype._unsetCancelled = function () {
              this._bitField = -65537 & this._bitField;
            }, P.prototype._setCancelled = function () {
              this._bitField = 65536 | this._bitField, this._fireEvent("promiseCancelled", this);
            }, P.prototype._setWillBeCancelled = function () {
              this._bitField = 8388608 | this._bitField;
            }, P.prototype._setAsyncGuaranteed = function () {
              h.hasCustomScheduler() || (this._bitField = 134217728 | this._bitField);
            }, P.prototype._receiverAt = function (t) {
              var e = 0 === t ? this._receiver0 : this[4 * t - 4 + 3];
              if (e !== c) return void 0 === e && this._isBound() ? this._boundValue() : e;
            }, P.prototype._promiseAt = function (t) {
              return this[4 * t - 4 + 2];
            }, P.prototype._fulfillmentHandlerAt = function (t) {
              return this[4 * t - 4 + 0];
            }, P.prototype._rejectionHandlerAt = function (t) {
              return this[4 * t - 4 + 1];
            }, P.prototype._boundValue = function () {}, P.prototype._migrateCallback0 = function (t) {
              t._bitField;

              var e = t._fulfillmentHandler0,
                  n = t._rejectionHandler0,
                  r = t._promise0,
                  o = t._receiverAt(0);

              void 0 === o && (o = c), this._addCallbacks(e, n, r, o, null);
            }, P.prototype._migrateCallbackAt = function (t, e) {
              var n = t._fulfillmentHandlerAt(e),
                  r = t._rejectionHandlerAt(e),
                  o = t._promiseAt(e),
                  i = t._receiverAt(e);

              void 0 === i && (i = c), this._addCallbacks(n, r, o, i, null);
            }, P.prototype._addCallbacks = function (t, e, n, r, o) {
              var i = this._length();

              if (i >= 65531 && (i = 0, this._setLength(0)), 0 === i) this._promise0 = n, this._receiver0 = r, "function" == typeof t && (this._fulfillmentHandler0 = null === o ? t : u.domainBind(o, t)), "function" == typeof e && (this._rejectionHandler0 = null === o ? e : u.domainBind(o, e));else {
                var s = 4 * i - 4;
                this[s + 2] = n, this[s + 3] = r, "function" == typeof t && (this[s + 0] = null === o ? t : u.domainBind(o, t)), "function" == typeof e && (this[s + 1] = null === o ? e : u.domainBind(o, e));
              }
              return this._setLength(i + 1), i;
            }, P.prototype._proxy = function (t, e) {
              this._addCallbacks(void 0, void 0, e, t, null);
            }, P.prototype._resolveCallback = function (t, e) {
              if (0 == (117506048 & this._bitField)) {
                if (t === this) return this._rejectCallback(r(), !1);

                var n = _(t, this);

                if (!(n instanceof P)) return this._fulfill(t);
                e && this._propagateFrom(n, 2);

                var o = n._target();

                if (o !== this) {
                  var i = o._bitField;

                  if (0 == (50397184 & i)) {
                    var s = this._length();

                    s > 0 && o._migrateCallback0(this);

                    for (var a = 1; a < s; ++a) {
                      o._migrateCallbackAt(this, a);
                    }

                    this._setFollowing(), this._setLength(0), this._setFollowee(o);
                  } else if (0 != (33554432 & i)) this._fulfill(o._value());else if (0 != (16777216 & i)) this._reject(o._reason());else {
                    var c = new y("late cancellation observer");
                    o._attachExtraTrace(c), this._reject(c);
                  }
                } else this._reject(r());
              }
            }, P.prototype._rejectCallback = function (t, e, n) {
              var r = u.ensureErrorObject(t),
                  o = r === t;

              if (!o && !n && k.warnings()) {
                var i = "a promise was rejected with a non-error: " + u.classString(t);

                this._warn(i, !0);
              }

              this._attachExtraTrace(r, !!e && o), this._reject(t);
            }, P.prototype._resolveFromExecutor = function (t) {
              if (t !== g) {
                var e = this;
                this._captureStackTrace(), this._pushContext();

                var n = !0,
                    r = this._execute(t, function (t) {
                  e._resolveCallback(t);
                }, function (t) {
                  e._rejectCallback(t, n);
                });

                n = !1, this._popContext(), void 0 !== r && e._rejectCallback(r, !0);
              }
            }, P.prototype._settlePromiseFromHandler = function (t, e, n, r) {
              var o = r._bitField;

              if (0 == (65536 & o)) {
                var i;
                r._pushContext(), e === v ? n && "number" == typeof n.length ? i = j(t).apply(this._boundValue(), n) : (i = T).e = new d("cannot .spread() a non-array: " + u.classString(n)) : i = j(t).call(e, n);

                var s = r._popContext();

                0 == (65536 & (o = r._bitField)) && (i === m ? r._reject(n) : i === T ? r._rejectCallback(i.e, !1) : (k.checkForgottenReturns(i, s, "", r, this), r._resolveCallback(i)));
              }
            }, P.prototype._target = function () {
              for (var t = this; t._isFollowing();) {
                t = t._followee();
              }

              return t;
            }, P.prototype._followee = function () {
              return this._rejectionHandler0;
            }, P.prototype._setFollowee = function (t) {
              this._rejectionHandler0 = t;
            }, P.prototype._settlePromise = function (t, e, n, r) {
              var i = t instanceof P,
                  a = this._bitField,
                  c = 0 != (134217728 & a);
              0 != (65536 & a) ? (i && t._invokeInternalOnCancel(), n instanceof E && n.isFinallyHandler() ? (n.cancelPromise = t, j(e).call(n, r) === T && t._reject(T.e)) : e === o ? t._fulfill(o.call(n)) : n instanceof s ? n._promiseCancelled(t) : i || t instanceof b ? t._cancel() : n.cancel()) : "function" == typeof e ? i ? (c && t._setAsyncGuaranteed(), this._settlePromiseFromHandler(e, n, r, t)) : e.call(n, r, t) : n instanceof s ? n._isResolved() || (0 != (33554432 & a) ? n._promiseFulfilled(r, t) : n._promiseRejected(r, t)) : i && (c && t._setAsyncGuaranteed(), 0 != (33554432 & a) ? t._fulfill(r) : t._reject(r));
            }, P.prototype._settlePromiseLateCancellationObserver = function (t) {
              var e = t.handler,
                  n = t.promise,
                  r = t.receiver,
                  o = t.value;
              "function" == typeof e ? n instanceof P ? this._settlePromiseFromHandler(e, r, o, n) : e.call(r, o, n) : n instanceof P && n._reject(o);
            }, P.prototype._settlePromiseCtx = function (t) {
              this._settlePromise(t.promise, t.handler, t.receiver, t.value);
            }, P.prototype._settlePromise0 = function (t, e, n) {
              var r = this._promise0,
                  o = this._receiverAt(0);

              this._promise0 = void 0, this._receiver0 = void 0, this._settlePromise(r, t, o, e);
            }, P.prototype._clearCallbackDataAtIndex = function (t) {
              var e = 4 * t - 4;
              this[e + 2] = this[e + 3] = this[e + 0] = this[e + 1] = void 0;
            }, P.prototype._fulfill = function (t) {
              var e = this._bitField;

              if (!((117506048 & e) >>> 16)) {
                if (t === this) {
                  var n = r();
                  return this._attachExtraTrace(n), this._reject(n);
                }

                this._setFulfilled(), this._rejectionHandler0 = t, (65535 & e) > 0 && (0 != (134217728 & e) ? this._settlePromises() : h.settlePromises(this), this._dereferenceTrace());
              }
            }, P.prototype._reject = function (t) {
              var e = this._bitField;

              if (!((117506048 & e) >>> 16)) {
                if (this._setRejected(), this._fulfillmentHandler0 = t, this._isFinal()) return h.fatalError(t, u.isNode);
                (65535 & e) > 0 ? h.settlePromises(this) : this._ensurePossibleRejectionHandled();
              }
            }, P.prototype._fulfillPromises = function (t, e) {
              for (var n = 1; n < t; n++) {
                var r = this._fulfillmentHandlerAt(n),
                    o = this._promiseAt(n),
                    i = this._receiverAt(n);

                this._clearCallbackDataAtIndex(n), this._settlePromise(o, r, i, e);
              }
            }, P.prototype._rejectPromises = function (t, e) {
              for (var n = 1; n < t; n++) {
                var r = this._rejectionHandlerAt(n),
                    o = this._promiseAt(n),
                    i = this._receiverAt(n);

                this._clearCallbackDataAtIndex(n), this._settlePromise(o, r, i, e);
              }
            }, P.prototype._settlePromises = function () {
              var t = this._bitField,
                  e = 65535 & t;

              if (e > 0) {
                if (0 != (16842752 & t)) {
                  var n = this._fulfillmentHandler0;
                  this._settlePromise0(this._rejectionHandler0, n, t), this._rejectPromises(e, n);
                } else {
                  var r = this._rejectionHandler0;
                  this._settlePromise0(this._fulfillmentHandler0, r, t), this._fulfillPromises(e, r);
                }

                this._setLength(0);
              }

              this._clearCancellationData();
            }, P.prototype._settledValue = function () {
              var t = this._bitField;
              return 0 != (33554432 & t) ? this._rejectionHandler0 : 0 != (16777216 & t) ? this._fulfillmentHandler0 : void 0;
            }, P.defer = P.pending = function () {
              return k.deprecated("Promise.defer", "new Promise"), {
                promise: new P(g),
                resolve: x,
                reject: O
              };
            }, u.notEnumerableProp(P, "_makeSelfResolutionError", r), t("./method")(P, g, _, i, k), t("./bind")(P, g, _, k), t("./cancel")(P, b, i, k), t("./direct_resolve")(P), t("./synchronous_inspection")(P), t("./join")(P, b, _, g, h, a), P.Promise = P, P.version = "3.5.3", t("./map.js")(P, b, i, _, g, k), t("./call_get.js")(P), t("./using.js")(P, i, _, C, g, k), t("./timers.js")(P, g, k), t("./generators.js")(P, i, g, _, s, k), t("./nodeify.js")(P), t("./promisify.js")(P, g), t("./props.js")(P, b, _, i), t("./race.js")(P, g, _, i), t("./reduce.js")(P, b, i, _, g, k), t("./settle.js")(P, b, k), t("./some.js")(P, b, i), t("./filter.js")(P, g), t("./each.js")(P, g), t("./any.js")(P), u.toFastProperties(P), u.toFastProperties(P.prototype), S({
              a: 1
            }), S({
              b: 2
            }), S({
              c: 3
            }), S(1), S(function () {}), S(void 0), S(!1), S(new P(g)), k.setBounds(f.firstLineError, u.lastLineError), P;
          };
        }, {
          "./any.js": 1,
          "./async": 2,
          "./bind": 3,
          "./call_get.js": 5,
          "./cancel": 6,
          "./catch_filter": 7,
          "./context": 8,
          "./debuggability": 9,
          "./direct_resolve": 10,
          "./each.js": 11,
          "./errors": 12,
          "./es5": 13,
          "./filter.js": 14,
          "./finally": 15,
          "./generators.js": 16,
          "./join": 17,
          "./map.js": 18,
          "./method": 19,
          "./nodeback": 20,
          "./nodeify.js": 21,
          "./promise_array": 23,
          "./promisify.js": 24,
          "./props.js": 25,
          "./race.js": 27,
          "./reduce.js": 28,
          "./settle.js": 30,
          "./some.js": 31,
          "./synchronous_inspection": 32,
          "./thenables": 33,
          "./timers.js": 34,
          "./using.js": 35,
          "./util": 36
        }],
        23: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o, i) {
            var s = t("./util");
            s.isArray;

            function a(t) {
              var r = this._promise = new e(n);
              t instanceof e && r._propagateFrom(t, 3), r._setOnCancel(this), this._values = t, this._length = 0, this._totalResolved = 0, this._init(void 0, -2);
            }

            return s.inherits(a, i), a.prototype.length = function () {
              return this._length;
            }, a.prototype.promise = function () {
              return this._promise;
            }, a.prototype._init = function t(n, i) {
              var a = r(this._values, this._promise);

              if (a instanceof e) {
                var c = (a = a._target())._bitField;

                if (this._values = a, 0 == (50397184 & c)) return this._promise._setAsyncGuaranteed(), a._then(t, this._reject, void 0, this, i);
                if (0 == (33554432 & c)) return 0 != (16777216 & c) ? this._reject(a._reason()) : this._cancel();
                a = a._value();
              }

              if (null !== (a = s.asArray(a))) 0 !== a.length ? this._iterate(a) : -5 === i ? this._resolveEmptyArray() : this._resolve(function (t) {
                switch (t) {
                  case -2:
                    return [];

                  case -3:
                    return {};

                  case -6:
                    return new Map();
                }
              }(i));else {
                var u = o("expecting an array or an iterable object but got " + s.classString(a)).reason();

                this._promise._rejectCallback(u, !1);
              }
            }, a.prototype._iterate = function (t) {
              var n = this.getActualLength(t.length);
              this._length = n, this._values = this.shouldCopyValues() ? new Array(n) : this._values;

              for (var o = this._promise, i = !1, s = null, a = 0; a < n; ++a) {
                var c = r(t[a], o);
                s = c instanceof e ? (c = c._target())._bitField : null, i ? null !== s && c.suppressUnhandledRejections() : null !== s ? 0 == (50397184 & s) ? (c._proxy(this, a), this._values[a] = c) : i = 0 != (33554432 & s) ? this._promiseFulfilled(c._value(), a) : 0 != (16777216 & s) ? this._promiseRejected(c._reason(), a) : this._promiseCancelled(a) : i = this._promiseFulfilled(c, a);
              }

              i || o._setAsyncGuaranteed();
            }, a.prototype._isResolved = function () {
              return null === this._values;
            }, a.prototype._resolve = function (t) {
              this._values = null, this._promise._fulfill(t);
            }, a.prototype._cancel = function () {
              !this._isResolved() && this._promise._isCancellable() && (this._values = null, this._promise._cancel());
            }, a.prototype._reject = function (t) {
              this._values = null, this._promise._rejectCallback(t, !1);
            }, a.prototype._promiseFulfilled = function (t, e) {
              return this._values[e] = t, ++this._totalResolved >= this._length && (this._resolve(this._values), !0);
            }, a.prototype._promiseCancelled = function () {
              return this._cancel(), !0;
            }, a.prototype._promiseRejected = function (t) {
              return this._totalResolved++, this._reject(t), !0;
            }, a.prototype._resultCancelled = function () {
              if (!this._isResolved()) {
                var t = this._values;
                if (this._cancel(), t instanceof e) t.cancel();else for (var n = 0; n < t.length; ++n) {
                  t[n] instanceof e && t[n].cancel();
                }
              }
            }, a.prototype.shouldCopyValues = function () {
              return !0;
            }, a.prototype.getActualLength = function (t) {
              return t;
            }, a;
          };
        }, {
          "./util": 36
        }],
        24: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n) {
            var r = {},
                o = t("./util"),
                i = t("./nodeback"),
                s = o.withAppended,
                a = o.maybeWrapAsError,
                c = o.canEvaluate,
                u = t("./errors").TypeError,
                l = {
              __isPromisified__: !0
            },
                f = new RegExp("^(?:" + ["arity", "length", "name", "arguments", "caller", "callee", "prototype", "__isPromisified__"].join("|") + ")$"),
                h = function h(t) {
              return o.isIdentifier(t) && "_" !== t.charAt(0) && "constructor" !== t;
            };

            function p(t) {
              return !f.test(t);
            }

            function d(t) {
              try {
                return !0 === t.__isPromisified__;
              } catch (t) {
                return !1;
              }
            }

            function y(t, e, n) {
              var r = o.getDataPropertyOrDefault(t, e + n, l);
              return !!r && d(r);
            }

            function g(t, e, n, r) {
              for (var i = o.inheritedDataKeys(t), s = [], a = 0; a < i.length; ++a) {
                var c = i[a],
                    l = t[c],
                    f = r === h || h(c, l, t);
                "function" != typeof l || d(l) || y(t, c, e) || !r(c, l, t, f) || s.push(c, l);
              }

              return function (t, e, n) {
                for (var r = 0; r < t.length; r += 2) {
                  var o = t[r];
                  if (n.test(o)) for (var i = o.replace(n, ""), s = 0; s < t.length; s += 2) {
                    if (t[s] === i) throw new u("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s", e));
                  }
                }
              }(s, e, n), s;
            }

            var v = function v(t) {
              return t.replace(/([$])/, "\\$");
            };

            var m = c ? void 0 : function (t, c, u, l, f, h) {
              var p = function () {
                return this;
              }(),
                  d = t;

              function y() {
                var o = c;
                c === r && (o = this);
                var u = new e(n);

                u._captureStackTrace();

                var l = "string" == typeof d && this !== p ? this[d] : t,
                    f = i(u, h);

                try {
                  l.apply(o, s(arguments, f));
                } catch (t) {
                  u._rejectCallback(a(t), !0, !0);
                }

                return u._isFateSealed() || u._setAsyncGuaranteed(), u;
              }

              return "string" == typeof d && (t = l), o.notEnumerableProp(y, "__isPromisified__", !0), y;
            };

            function _(t, e, n, i, s) {
              for (var a = new RegExp(v(e) + "$"), c = g(t, e, a, n), u = 0, l = c.length; u < l; u += 2) {
                var f = c[u],
                    h = c[u + 1],
                    p = f + e;
                if (i === m) t[p] = m(f, r, f, h, e, s);else {
                  var d = i(h, function () {
                    return m(f, r, f, h, e, s);
                  });
                  o.notEnumerableProp(d, "__isPromisified__", !0), t[p] = d;
                }
              }

              return o.toFastProperties(t), t;
            }

            e.promisify = function (t, e) {
              if ("function" != typeof t) throw new u("expecting a function but got " + o.classString(t));
              if (d(t)) return t;

              var n = function (t, e, n) {
                return m(t, e, void 0, t, null, n);
              }(t, void 0 === (e = Object(e)).context ? r : e.context, !!e.multiArgs);

              return o.copyDescriptors(t, n, p), n;
            }, e.promisifyAll = function (t, e) {
              if ("function" != typeof t && "object" != typeof t) throw new u("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");
              var n = !!(e = Object(e)).multiArgs,
                  r = e.suffix;
              "string" != typeof r && (r = "Async");
              var i = e.filter;
              "function" != typeof i && (i = h);
              var s = e.promisifier;
              if ("function" != typeof s && (s = m), !o.isIdentifier(r)) throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");

              for (var a = o.inheritedDataKeys(t), c = 0; c < a.length; ++c) {
                var l = t[a[c]];
                "constructor" !== a[c] && o.isClass(l) && (_(l.prototype, r, i, s, n), _(l, r, i, s, n));
              }

              return _(t, r, i, s, n);
            };
          };
        }, {
          "./errors": 12,
          "./nodeback": 20,
          "./util": 36
        }],
        25: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o) {
            var i,
                s = t("./util"),
                a = s.isObject,
                c = t("./es5");
            "function" == typeof Map && (i = Map);

            var u = function () {
              var t = 0,
                  e = 0;

              function n(n, r) {
                this[t] = n, this[t + e] = r, t++;
              }

              return function (r) {
                e = r.size, t = 0;
                var o = new Array(2 * r.size);
                return r.forEach(n, o), o;
              };
            }();

            function l(t) {
              var e,
                  n = !1;
              if (void 0 !== i && t instanceof i) e = u(t), n = !0;else {
                var r = c.keys(t),
                    o = r.length;
                e = new Array(2 * o);

                for (var s = 0; s < o; ++s) {
                  var a = r[s];
                  e[s] = t[a], e[s + o] = a;
                }
              }
              this.constructor$(e), this._isMap = n, this._init$(void 0, n ? -6 : -3);
            }

            function f(t) {
              var n,
                  i = r(t);
              return a(i) ? (n = i instanceof e ? i._then(e.props, void 0, void 0, void 0, void 0) : new l(i).promise(), i instanceof e && n._propagateFrom(i, 2), n) : o("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n");
            }

            s.inherits(l, n), l.prototype._init = function () {}, l.prototype._promiseFulfilled = function (t, e) {
              if (this._values[e] = t, ++this._totalResolved >= this._length) {
                var n;
                if (this._isMap) n = function (t) {
                  for (var e = new i(), n = t.length / 2 | 0, r = 0; r < n; ++r) {
                    var o = t[n + r],
                        s = t[r];
                    e.set(o, s);
                  }

                  return e;
                }(this._values);else {
                  n = {};

                  for (var r = this.length(), o = 0, s = this.length(); o < s; ++o) {
                    n[this._values[o + r]] = this._values[o];
                  }
                }
                return this._resolve(n), !0;
              }

              return !1;
            }, l.prototype.shouldCopyValues = function () {
              return !1;
            }, l.prototype.getActualLength = function (t) {
              return t >> 1;
            }, e.prototype.props = function () {
              return f(this);
            }, e.props = function (t) {
              return f(t);
            };
          };
        }, {
          "./es5": 13,
          "./util": 36
        }],
        26: [function (t, e, n) {
          "use strict";

          function r(t) {
            this._capacity = t, this._length = 0, this._front = 0;
          }

          r.prototype._willBeOverCapacity = function (t) {
            return this._capacity < t;
          }, r.prototype._pushOne = function (t) {
            var e = this.length();
            this._checkCapacity(e + 1), this[this._front + e & this._capacity - 1] = t, this._length = e + 1;
          }, r.prototype.push = function (t, e, n) {
            var r = this.length() + 3;
            if (this._willBeOverCapacity(r)) return this._pushOne(t), this._pushOne(e), void this._pushOne(n);
            var o = this._front + r - 3;

            this._checkCapacity(r);

            var i = this._capacity - 1;
            this[o + 0 & i] = t, this[o + 1 & i] = e, this[o + 2 & i] = n, this._length = r;
          }, r.prototype.shift = function () {
            var t = this._front,
                e = this[t];
            return this[t] = void 0, this._front = t + 1 & this._capacity - 1, this._length--, e;
          }, r.prototype.length = function () {
            return this._length;
          }, r.prototype._checkCapacity = function (t) {
            this._capacity < t && this._resizeTo(this._capacity << 1);
          }, r.prototype._resizeTo = function (t) {
            var e = this._capacity;
            this._capacity = t, function (t, e, n, r, o) {
              for (var i = 0; i < o; ++i) {
                n[i + r] = t[i + e], t[i + e] = void 0;
              }
            }(this, 0, this, e, this._front + this._length & e - 1);
          }, e.exports = r;
        }, {}],
        27: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o) {
            var i = t("./util"),
                s = function s(t) {
              return t.then(function (e) {
                return a(e, t);
              });
            };

            function a(t, a) {
              var c = r(t);
              if (c instanceof e) return s(c);
              if (null === (t = i.asArray(t))) return o("expecting an array or an iterable object but got " + i.classString(t));
              var u = new e(n);
              void 0 !== a && u._propagateFrom(a, 3);

              for (var l = u._fulfill, f = u._reject, h = 0, p = t.length; h < p; ++h) {
                var d = t[h];
                (void 0 !== d || h in t) && e.cast(d)._then(l, f, void 0, u, null);
              }

              return u;
            }

            e.race = function (t) {
              return a(t, void 0);
            }, e.prototype.race = function () {
              return a(this, void 0);
            };
          };
        }, {
          "./util": 36
        }],
        28: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o, i, s) {
            var a = e._getDomain,
                c = t("./util"),
                u = c.tryCatch;

            function l(t, n, r, o) {
              this.constructor$(t);
              var s = a();
              this._fn = null === s ? n : c.domainBind(s, n), void 0 !== r && (r = e.resolve(r))._attachCancellationCallback(this), this._initialValue = r, this._currentCancellable = null, this._eachValues = o === i ? Array(this._length) : 0 === o ? null : void 0, this._promise._captureStackTrace(), this._init$(void 0, -5);
            }

            function f(t, e) {
              this.isFulfilled() ? e._resolve(t) : e._reject(t);
            }

            function h(t, e, n, o) {
              return "function" != typeof e ? r("expecting a function but got " + c.classString(e)) : new l(t, e, n, o).promise();
            }

            function p(t) {
              this.accum = t, this.array._gotAccum(t);
              var n = o(this.value, this.array._promise);
              return n instanceof e ? (this.array._currentCancellable = n, n._then(d, void 0, void 0, this, void 0)) : d.call(this, n);
            }

            function d(t) {
              var n,
                  r = this.array,
                  o = r._promise,
                  i = u(r._fn);
              o._pushContext(), (n = void 0 !== r._eachValues ? i.call(o._boundValue(), t, this.index, this.length) : i.call(o._boundValue(), this.accum, t, this.index, this.length)) instanceof e && (r._currentCancellable = n);

              var a = o._popContext();

              return s.checkForgottenReturns(n, a, void 0 !== r._eachValues ? "Promise.each" : "Promise.reduce", o), n;
            }

            c.inherits(l, n), l.prototype._gotAccum = function (t) {
              void 0 !== this._eachValues && null !== this._eachValues && t !== i && this._eachValues.push(t);
            }, l.prototype._eachComplete = function (t) {
              return null !== this._eachValues && this._eachValues.push(t), this._eachValues;
            }, l.prototype._init = function () {}, l.prototype._resolveEmptyArray = function () {
              this._resolve(void 0 !== this._eachValues ? this._eachValues : this._initialValue);
            }, l.prototype.shouldCopyValues = function () {
              return !1;
            }, l.prototype._resolve = function (t) {
              this._promise._resolveCallback(t), this._values = null;
            }, l.prototype._resultCancelled = function (t) {
              if (t === this._initialValue) return this._cancel();
              this._isResolved() || (this._resultCancelled$(), this._currentCancellable instanceof e && this._currentCancellable.cancel(), this._initialValue instanceof e && this._initialValue.cancel());
            }, l.prototype._iterate = function (t) {
              var n, r;
              this._values = t;
              var o = t.length;
              if (void 0 !== this._initialValue ? (n = this._initialValue, r = 0) : (n = e.resolve(t[0]), r = 1), this._currentCancellable = n, !n.isRejected()) for (; r < o; ++r) {
                var i = {
                  accum: null,
                  value: t[r],
                  index: r,
                  length: o,
                  array: this
                };
                n = n._then(p, void 0, void 0, i, void 0);
              }
              void 0 !== this._eachValues && (n = n._then(this._eachComplete, void 0, void 0, this, void 0)), n._then(f, f, void 0, n, this);
            }, e.prototype.reduce = function (t, e) {
              return h(this, t, e, null);
            }, e.reduce = function (t, e, n, r) {
              return h(t, e, n, r);
            };
          };
        }, {
          "./util": 36
        }],
        29: [function (t, o, i) {
          "use strict";

          var s,
              a = t("./util"),
              c = a.getNativePromise();

          if (a.isNode && "undefined" == typeof MutationObserver) {
            var u = n.setImmediate,
                l = e.nextTick;
            s = a.isRecentNode ? function (t) {
              u.call(n, t);
            } : function (t) {
              l.call(e, t);
            };
          } else if ("function" == typeof c && "function" == typeof c.resolve) {
            var f = c.resolve();

            s = function s(t) {
              f.then(t);
            };
          } else s = "undefined" == typeof MutationObserver || "undefined" != typeof window && window.navigator && (window.navigator.standalone || window.cordova) ? void 0 !== r ? function (t) {
            r(t);
          } : "undefined" != typeof setTimeout ? function (t) {
            setTimeout(t, 0);
          } : function () {
            throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
          } : function () {
            var t = document.createElement("div"),
                e = {
              attributes: !0
            },
                n = !1,
                r = document.createElement("div");
            new MutationObserver(function () {
              t.classList.toggle("foo"), n = !1;
            }).observe(r, e);
            return function (o) {
              var i = new MutationObserver(function () {
                i.disconnect(), o();
              });
              i.observe(t, e), n || (n = !0, r.classList.toggle("foo"));
            };
          }();

          o.exports = s;
        }, {
          "./util": 36
        }],
        30: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r) {
            var o = e.PromiseInspection;

            function i(t) {
              this.constructor$(t);
            }

            t("./util").inherits(i, n), i.prototype._promiseResolved = function (t, e) {
              return this._values[t] = e, ++this._totalResolved >= this._length && (this._resolve(this._values), !0);
            }, i.prototype._promiseFulfilled = function (t, e) {
              var n = new o();
              return n._bitField = 33554432, n._settledValueField = t, this._promiseResolved(e, n);
            }, i.prototype._promiseRejected = function (t, e) {
              var n = new o();
              return n._bitField = 16777216, n._settledValueField = t, this._promiseResolved(e, n);
            }, e.settle = function (t) {
              return r.deprecated(".settle()", ".reflect()"), new i(t).promise();
            }, e.prototype.settle = function () {
              return e.settle(this);
            };
          };
        }, {
          "./util": 36
        }],
        31: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r) {
            var o = t("./util"),
                i = t("./errors").RangeError,
                s = t("./errors").AggregateError,
                a = o.isArray,
                c = {};

            function u(t) {
              this.constructor$(t), this._howMany = 0, this._unwrap = !1, this._initialized = !1;
            }

            function l(t, e) {
              if ((0 | e) !== e || e < 0) return r("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");
              var n = new u(t),
                  o = n.promise();
              return n.setHowMany(e), n.init(), o;
            }

            o.inherits(u, n), u.prototype._init = function () {
              if (this._initialized) if (0 !== this._howMany) {
                this._init$(void 0, -5);

                var t = a(this._values);
                !this._isResolved() && t && this._howMany > this._canPossiblyFulfill() && this._reject(this._getRangeError(this.length()));
              } else this._resolve([]);
            }, u.prototype.init = function () {
              this._initialized = !0, this._init();
            }, u.prototype.setUnwrap = function () {
              this._unwrap = !0;
            }, u.prototype.howMany = function () {
              return this._howMany;
            }, u.prototype.setHowMany = function (t) {
              this._howMany = t;
            }, u.prototype._promiseFulfilled = function (t) {
              return this._addFulfilled(t), this._fulfilled() === this.howMany() && (this._values.length = this.howMany(), 1 === this.howMany() && this._unwrap ? this._resolve(this._values[0]) : this._resolve(this._values), !0);
            }, u.prototype._promiseRejected = function (t) {
              return this._addRejected(t), this._checkOutcome();
            }, u.prototype._promiseCancelled = function () {
              return this._values instanceof e || null == this._values ? this._cancel() : (this._addRejected(c), this._checkOutcome());
            }, u.prototype._checkOutcome = function () {
              if (this.howMany() > this._canPossiblyFulfill()) {
                for (var t = new s(), e = this.length(); e < this._values.length; ++e) {
                  this._values[e] !== c && t.push(this._values[e]);
                }

                return t.length > 0 ? this._reject(t) : this._cancel(), !0;
              }

              return !1;
            }, u.prototype._fulfilled = function () {
              return this._totalResolved;
            }, u.prototype._rejected = function () {
              return this._values.length - this.length();
            }, u.prototype._addRejected = function (t) {
              this._values.push(t);
            }, u.prototype._addFulfilled = function (t) {
              this._values[this._totalResolved++] = t;
            }, u.prototype._canPossiblyFulfill = function () {
              return this.length() - this._rejected();
            }, u.prototype._getRangeError = function (t) {
              var e = "Input array must contain at least " + this._howMany + " items but contains only " + t + " items";
              return new i(e);
            }, u.prototype._resolveEmptyArray = function () {
              this._reject(this._getRangeError(0));
            }, e.some = function (t, e) {
              return l(t, e);
            }, e.prototype.some = function (t) {
              return l(this, t);
            }, e._SomePromiseArray = u;
          };
        }, {
          "./errors": 12,
          "./util": 36
        }],
        32: [function (t, e, n) {
          "use strict";

          e.exports = function (t) {
            function e(t) {
              void 0 !== t ? (t = t._target(), this._bitField = t._bitField, this._settledValueField = t._isFateSealed() ? t._settledValue() : void 0) : (this._bitField = 0, this._settledValueField = void 0);
            }

            e.prototype._settledValue = function () {
              return this._settledValueField;
            };

            var n = e.prototype.value = function () {
              if (!this.isFulfilled()) throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");
              return this._settledValue();
            },
                r = e.prototype.error = e.prototype.reason = function () {
              if (!this.isRejected()) throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");
              return this._settledValue();
            },
                o = e.prototype.isFulfilled = function () {
              return 0 != (33554432 & this._bitField);
            },
                i = e.prototype.isRejected = function () {
              return 0 != (16777216 & this._bitField);
            },
                s = e.prototype.isPending = function () {
              return 0 == (50397184 & this._bitField);
            },
                a = e.prototype.isResolved = function () {
              return 0 != (50331648 & this._bitField);
            };

            e.prototype.isCancelled = function () {
              return 0 != (8454144 & this._bitField);
            }, t.prototype.__isCancelled = function () {
              return 65536 == (65536 & this._bitField);
            }, t.prototype._isCancelled = function () {
              return this._target().__isCancelled();
            }, t.prototype.isCancelled = function () {
              return 0 != (8454144 & this._target()._bitField);
            }, t.prototype.isPending = function () {
              return s.call(this._target());
            }, t.prototype.isRejected = function () {
              return i.call(this._target());
            }, t.prototype.isFulfilled = function () {
              return o.call(this._target());
            }, t.prototype.isResolved = function () {
              return a.call(this._target());
            }, t.prototype.value = function () {
              return n.call(this._target());
            }, t.prototype.reason = function () {
              var t = this._target();

              return t._unsetRejectionIsUnhandled(), r.call(t);
            }, t.prototype._value = function () {
              return this._settledValue();
            }, t.prototype._reason = function () {
              return this._unsetRejectionIsUnhandled(), this._settledValue();
            }, t.PromiseInspection = e;
          };
        }, {}],
        33: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n) {
            var r = t("./util"),
                o = r.errorObj,
                i = r.isObject;
            var s = {}.hasOwnProperty;
            return function (t, a) {
              if (i(t)) {
                if (t instanceof e) return t;

                var c = function (t) {
                  try {
                    return function (t) {
                      return t.then;
                    }(t);
                  } catch (t) {
                    return o.e = t, o;
                  }
                }(t);

                if (c === o) {
                  a && a._pushContext();
                  var u = e.reject(c.e);
                  return a && a._popContext(), u;
                }

                if ("function" == typeof c) return function (t) {
                  try {
                    return s.call(t, "_promise0");
                  } catch (t) {
                    return !1;
                  }
                }(t) ? (u = new e(n), t._then(u._fulfill, u._reject, void 0, u, null), u) : function (t, i, s) {
                  var a = new e(n),
                      c = a;
                  s && s._pushContext(), a._captureStackTrace(), s && s._popContext();
                  var u = !0,
                      l = r.tryCatch(i).call(t, function (t) {
                    a && (a._resolveCallback(t), a = null);
                  }, function (t) {
                    a && (a._rejectCallback(t, u, !0), a = null);
                  });
                  return u = !1, a && l === o && (a._rejectCallback(l.e, !0, !0), a = null), c;
                }(t, c, a);
              }

              return t;
            };
          };
        }, {
          "./util": 36
        }],
        34: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r) {
            var o = t("./util"),
                i = e.TimeoutError;

            function s(t) {
              this.handle = t;
            }

            s.prototype._resultCancelled = function () {
              clearTimeout(this.handle);
            };

            var a = function a(t) {
              return c(+this).thenReturn(t);
            },
                c = e.delay = function (t, o) {
              var i, c;
              return void 0 !== o ? (i = e.resolve(o)._then(a, null, null, t, void 0), r.cancellation() && o instanceof e && i._setOnCancel(o)) : (i = new e(n), c = setTimeout(function () {
                i._fulfill();
              }, +t), r.cancellation() && i._setOnCancel(new s(c)), i._captureStackTrace()), i._setAsyncGuaranteed(), i;
            };

            e.prototype.delay = function (t) {
              return c(t, this);
            };

            function u(t) {
              return clearTimeout(this.handle), t;
            }

            function l(t) {
              throw clearTimeout(this.handle), t;
            }

            e.prototype.timeout = function (t, e) {
              var n, a;
              t = +t;
              var c = new s(setTimeout(function () {
                n.isPending() && function (t, e, n) {
                  var r;
                  r = "string" != typeof e ? e instanceof Error ? e : new i("operation timed out") : new i(e), o.markAsOriginatingFromRejection(r), t._attachExtraTrace(r), t._reject(r), null != n && n.cancel();
                }(n, e, a);
              }, t));
              return r.cancellation() ? (a = this.then(), (n = a._then(u, l, void 0, c, void 0))._setOnCancel(c)) : n = this._then(u, l, void 0, c, void 0), n;
            };
          };
        }, {
          "./util": 36
        }],
        35: [function (t, e, n) {
          "use strict";

          e.exports = function (e, n, r, o, i, s) {
            var a = t("./util"),
                c = t("./errors").TypeError,
                u = t("./util").inherits,
                l = a.errorObj,
                f = a.tryCatch,
                h = {};

            function p(t) {
              setTimeout(function () {
                throw t;
              }, 0);
            }

            function d(t, n) {
              var o = 0,
                  s = t.length,
                  a = new e(i);
              return function i() {
                if (o >= s) return a._fulfill();

                var c = function (t) {
                  var e = r(t);
                  return e !== t && "function" == typeof t._isDisposable && "function" == typeof t._getDisposer && t._isDisposable() && e._setDisposable(t._getDisposer()), e;
                }(t[o++]);

                if (c instanceof e && c._isDisposable()) {
                  try {
                    c = r(c._getDisposer().tryDispose(n), t.promise);
                  } catch (t) {
                    return p(t);
                  }

                  if (c instanceof e) return c._then(i, p, null, null, null);
                }

                i();
              }(), a;
            }

            function y(t, e, n) {
              this._data = t, this._promise = e, this._context = n;
            }

            function g(t, e, n) {
              this.constructor$(t, e, n);
            }

            function v(t) {
              return y.isDisposer(t) ? (this.resources[this.index]._setDisposable(t), t.promise()) : t;
            }

            function m(t) {
              this.length = t, this.promise = null, this[t - 1] = null;
            }

            y.prototype.data = function () {
              return this._data;
            }, y.prototype.promise = function () {
              return this._promise;
            }, y.prototype.resource = function () {
              return this.promise().isFulfilled() ? this.promise().value() : h;
            }, y.prototype.tryDispose = function (t) {
              var e = this.resource(),
                  n = this._context;
              void 0 !== n && n._pushContext();
              var r = e !== h ? this.doDispose(e, t) : null;
              return void 0 !== n && n._popContext(), this._promise._unsetDisposable(), this._data = null, r;
            }, y.isDisposer = function (t) {
              return null != t && "function" == typeof t.resource && "function" == typeof t.tryDispose;
            }, u(g, y), g.prototype.doDispose = function (t, e) {
              return this.data().call(t, t, e);
            }, m.prototype._resultCancelled = function () {
              for (var t = this.length, n = 0; n < t; ++n) {
                var r = this[n];
                r instanceof e && r.cancel();
              }
            }, e.using = function () {
              var t = arguments.length;
              if (t < 2) return n("you must pass at least 2 arguments to Promise.using");
              var o,
                  i = arguments[t - 1];
              if ("function" != typeof i) return n("expecting a function but got " + a.classString(i));
              var c = !0;
              2 === t && Array.isArray(arguments[0]) ? (t = (o = arguments[0]).length, c = !1) : (o = arguments, t--);

              for (var u = new m(t), h = 0; h < t; ++h) {
                var p = o[h];

                if (y.isDisposer(p)) {
                  var g = p;

                  (p = p.promise())._setDisposable(g);
                } else {
                  var _ = r(p);

                  _ instanceof e && (p = _._then(v, null, null, {
                    resources: u,
                    index: h
                  }, void 0));
                }

                u[h] = p;
              }

              var b = new Array(u.length);

              for (h = 0; h < b.length; ++h) {
                b[h] = e.resolve(u[h]).reflect();
              }

              var w = e.all(b).then(function (t) {
                for (var e = 0; e < t.length; ++e) {
                  var n = t[e];
                  if (n.isRejected()) return l.e = n.error(), l;
                  if (!n.isFulfilled()) return void w.cancel();
                  t[e] = n.value();
                }

                C._pushContext(), i = f(i);

                var r = c ? i.apply(void 0, t) : i(t),
                    o = C._popContext();

                return s.checkForgottenReturns(r, o, "Promise.using", C), r;
              }),
                  C = w.lastly(function () {
                var t = new e.PromiseInspection(w);
                return d(u, t);
              });
              return u.promise = C, C._setOnCancel(u), C;
            }, e.prototype._setDisposable = function (t) {
              this._bitField = 131072 | this._bitField, this._disposer = t;
            }, e.prototype._isDisposable = function () {
              return (131072 & this._bitField) > 0;
            }, e.prototype._getDisposer = function () {
              return this._disposer;
            }, e.prototype._unsetDisposable = function () {
              this._bitField = -131073 & this._bitField, this._disposer = void 0;
            }, e.prototype.disposer = function (t) {
              if ("function" == typeof t) return new g(t, this, o());
              throw new c();
            };
          };
        }, {
          "./errors": 12,
          "./util": 36
        }],
        36: [function (t, r, o) {
          "use strict";

          var i = t("./es5"),
              s = "undefined" == typeof navigator,
              a = {
            e: {}
          },
              c,
              u = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n ? n : void 0 !== this ? this : null;

          function l() {
            try {
              var t = c;
              return c = null, t.apply(this, arguments);
            } catch (t) {
              return a.e = t, a;
            }
          }

          function f(t) {
            return c = t, l;
          }

          var h = function h(t, e) {
            var n = {}.hasOwnProperty;

            function r() {
              for (var r in this.constructor = t, this.constructor$ = e, e.prototype) {
                n.call(e.prototype, r) && "$" !== r.charAt(r.length - 1) && (this[r + "$"] = e.prototype[r]);
              }
            }

            return r.prototype = e.prototype, t.prototype = new r(), t.prototype;
          };

          function p(t) {
            return null == t || !0 === t || !1 === t || "string" == typeof t || "number" == typeof t;
          }

          function d(t) {
            return "function" == typeof t || "object" == typeof t && null !== t;
          }

          function y(t) {
            return p(t) ? new Error(T(t)) : t;
          }

          function g(t, e) {
            var n,
                r = t.length,
                o = new Array(r + 1);

            for (n = 0; n < r; ++n) {
              o[n] = t[n];
            }

            return o[n] = e, o;
          }

          function v(t, e, n) {
            if (!i.isES5) return {}.hasOwnProperty.call(t, e) ? t[e] : void 0;
            var r = Object.getOwnPropertyDescriptor(t, e);
            return null != r ? null == r.get && null == r.set ? r.value : n : void 0;
          }

          function m(t, e, n) {
            if (p(t)) return t;
            var r = {
              value: n,
              configurable: !0,
              enumerable: !1,
              writable: !0
            };
            return i.defineProperty(t, e, r), t;
          }

          function _(t) {
            throw t;
          }

          var b = function () {
            var t = [Array.prototype, Object.prototype, Function.prototype],
                e = function e(_e3) {
              for (var n = 0; n < t.length; ++n) {
                if (t[n] === _e3) return !0;
              }

              return !1;
            };

            if (i.isES5) {
              var n = Object.getOwnPropertyNames;
              return function (t) {
                for (var r = [], o = Object.create(null); null != t && !e(t);) {
                  var s;

                  try {
                    s = n(t);
                  } catch (t) {
                    return r;
                  }

                  for (var a = 0; a < s.length; ++a) {
                    var c = s[a];

                    if (!o[c]) {
                      o[c] = !0;
                      var u = Object.getOwnPropertyDescriptor(t, c);
                      null != u && null == u.get && null == u.set && r.push(c);
                    }
                  }

                  t = i.getPrototypeOf(t);
                }

                return r;
              };
            }

            var r = {}.hasOwnProperty;
            return function (n) {
              if (e(n)) return [];
              var o = [];

              t: for (var i in n) {
                if (r.call(n, i)) o.push(i);else {
                  for (var s = 0; s < t.length; ++s) {
                    if (r.call(t[s], i)) continue t;
                  }

                  o.push(i);
                }
              }

              return o;
            };
          }(),
              w = /this\s*\.\s*\S+\s*=/;

          function C(t) {
            try {
              if ("function" == typeof t) {
                var e = i.names(t.prototype),
                    n = i.isES5 && e.length > 1,
                    r = e.length > 0 && !(1 === e.length && "constructor" === e[0]),
                    o = w.test(t + "") && i.names(t).length > 0;
                if (n || r || o) return !0;
              }

              return !1;
            } catch (t) {
              return !1;
            }
          }

          function k(t) {
            function e() {}

            e.prototype = t;
            var n = new e();

            function r() {
              return typeof n.foo;
            }

            return r(), r(), t;
          }

          var E = /^[a-z$_][a-z$_0-9]*$/i;

          function F(t) {
            return E.test(t);
          }

          function A(t, e, n) {
            for (var r = new Array(t), o = 0; o < t; ++o) {
              r[o] = e + o + n;
            }

            return r;
          }

          function T(t) {
            try {
              return t + "";
            } catch (t) {
              return "[no string representation]";
            }
          }

          function j(t) {
            return t instanceof Error || null !== t && "object" == typeof t && "string" == typeof t.message && "string" == typeof t.name;
          }

          function P(t) {
            try {
              m(t, "isOperational", !0);
            } catch (t) {}
          }

          function x(t) {
            return null != t && (t instanceof Error.__BluebirdErrorTypes__.OperationalError || !0 === t.isOperational);
          }

          function O(t) {
            return j(t) && i.propertyIsWritable(t, "stack");
          }

          var S = "stack" in new Error() ? function (t) {
            return O(t) ? t : new Error(T(t));
          } : function (t) {
            if (O(t)) return t;

            try {
              throw new Error(T(t));
            } catch (t) {
              return t;
            }
          };

          function R(t) {
            return {}.toString.call(t);
          }

          function B(t, e, n) {
            for (var r = i.names(t), o = 0; o < r.length; ++o) {
              var s = r[o];
              if (n(s)) try {
                i.defineProperty(e, s, i.getDescriptor(t, s));
              } catch (t) {}
            }
          }

          var I = function I(t) {
            return i.isArray(t) ? t : null;
          };

          if ("undefined" != typeof Symbol && Symbol.iterator) {
            var D = "function" == typeof Array.from ? function (t) {
              return Array.from(t);
            } : function (t) {
              for (var e, n = [], r = t[Symbol.iterator](); !(e = r.next()).done;) {
                n.push(e.value);
              }

              return n;
            };

            I = function I(t) {
              return i.isArray(t) ? t : null != t && "function" == typeof t[Symbol.iterator] ? D(t) : null;
            };
          }

          var M = void 0 !== e && "[object process]" === R(e).toLowerCase(),
              U = void 0 !== e && void 0 !== e.env;

          function N(t) {
            return U ? e.env[t] : void 0;
          }

          function L() {
            if ("function" == typeof Promise) try {
              var t = new Promise(function () {});
              if ("[object Promise]" === {}.toString.call(t)) return Promise;
            } catch (t) {}
          }

          function q(t, e) {
            return t.bind(e);
          }

          var H = {
            isClass: C,
            isIdentifier: F,
            inheritedDataKeys: b,
            getDataPropertyOrDefault: v,
            thrower: _,
            isArray: i.isArray,
            asArray: I,
            notEnumerableProp: m,
            isPrimitive: p,
            isObject: d,
            isError: j,
            canEvaluate: s,
            errorObj: a,
            tryCatch: f,
            inherits: h,
            withAppended: g,
            maybeWrapAsError: y,
            toFastProperties: k,
            filledRange: A,
            toString: T,
            canAttachTrace: O,
            ensureErrorObject: S,
            originatesFromRejection: x,
            markAsOriginatingFromRejection: P,
            classString: R,
            copyDescriptors: B,
            hasDevTools: "undefined" != typeof chrome && chrome && "function" == typeof chrome.loadTimes,
            isNode: M,
            hasEnvVariables: U,
            env: N,
            global: u,
            getNativePromise: L,
            domainBind: q
          },
              V;
          H.isRecentNode = H.isNode && (V = e.versions.node.split(".").map(Number), 0 === V[0] && V[1] > 10 || V[0] > 0), H.isNode && H.toFastProperties(e);

          try {
            throw new Error();
          } catch (t) {
            H.lastLineError = t;
          }

          r.exports = H;
        }, {
          "./es5": 13
        }]
      }, {}, [4])(4);
    }, t.exports = o(), "undefined" != typeof window && null !== window ? window.P = window.Promise : "undefined" != typeof self && null !== self && (self.P = self.Promise);
  }).call(this, n(3), n(4), n(69).setImmediate);
}, function (t, e, n) {
  (function (t) {
    var r = void 0 !== t && t || "undefined" != typeof self && self || window,
        o = Function.prototype.apply;

    function i(t, e) {
      this._id = t, this._clearFn = e;
    }

    e.setTimeout = function () {
      return new i(o.call(setTimeout, r, arguments), clearTimeout);
    }, e.setInterval = function () {
      return new i(o.call(setInterval, r, arguments), clearInterval);
    }, e.clearTimeout = e.clearInterval = function (t) {
      t && t.close();
    }, i.prototype.unref = i.prototype.ref = function () {}, i.prototype.close = function () {
      this._clearFn.call(r, this._id);
    }, e.enroll = function (t, e) {
      clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
    }, e.unenroll = function (t) {
      clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
    }, e._unrefActive = e.active = function (t) {
      clearTimeout(t._idleTimeoutId);
      var e = t._idleTimeout;
      e >= 0 && (t._idleTimeoutId = setTimeout(function () {
        t._onTimeout && t._onTimeout();
      }, e));
    }, n(70), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
  }).call(this, n(4));
}, function (t, e, n) {
  (function (t, e) {
    !function (t, n) {
      "use strict";

      if (!t.setImmediate) {
        var r,
            o,
            i,
            s,
            a,
            c = 1,
            u = {},
            l = !1,
            f = t.document,
            h = Object.getPrototypeOf && Object.getPrototypeOf(t);
        h = h && h.setTimeout ? h : t, "[object process]" === {}.toString.call(t.process) ? r = function r(t) {
          e.nextTick(function () {
            d(t);
          });
        } : !function () {
          if (t.postMessage && !t.importScripts) {
            var e = !0,
                n = t.onmessage;
            return t.onmessage = function () {
              e = !1;
            }, t.postMessage("", "*"), t.onmessage = n, e;
          }
        }() ? t.MessageChannel ? ((i = new MessageChannel()).port1.onmessage = function (t) {
          d(t.data);
        }, r = function r(t) {
          i.port2.postMessage(t);
        }) : f && "onreadystatechange" in f.createElement("script") ? (o = f.documentElement, r = function r(t) {
          var e = f.createElement("script");
          e.onreadystatechange = function () {
            d(t), e.onreadystatechange = null, o.removeChild(e), e = null;
          }, o.appendChild(e);
        }) : r = function r(t) {
          setTimeout(d, 0, t);
        } : (s = "setImmediate$" + Math.random() + "$", a = function a(e) {
          e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(s) && d(+e.data.slice(s.length));
        }, t.addEventListener ? t.addEventListener("message", a, !1) : t.attachEvent("onmessage", a), r = function r(e) {
          t.postMessage(s + e, "*");
        }), h.setImmediate = function (t) {
          "function" != typeof t && (t = new Function("" + t));

          for (var e = new Array(arguments.length - 1), n = 0; n < e.length; n++) {
            e[n] = arguments[n + 1];
          }

          var o = {
            callback: t,
            args: e
          };
          return u[c] = o, r(c), c++;
        }, h.clearImmediate = p;
      }

      function p(t) {
        delete u[t];
      }

      function d(t) {
        if (l) setTimeout(d, 0, t);else {
          var e = u[t];

          if (e) {
            l = !0;

            try {
              !function (t) {
                var e = t.callback,
                    r = t.args;

                switch (r.length) {
                  case 0:
                    e();
                    break;

                  case 1:
                    e(r[0]);
                    break;

                  case 2:
                    e(r[0], r[1]);
                    break;

                  case 3:
                    e(r[0], r[1], r[2]);
                    break;

                  default:
                    e.apply(n, r);
                }
              }(e);
            } finally {
              p(t), l = !1;
            }
          }
        }
      }
    }("undefined" == typeof self ? void 0 === t ? this : t : self);
  }).call(this, n(4), n(3));
}, function (t, e, n) {
  var r = n(31),
      o = !1;
  t.exports = new (
  /*#__PURE__*/
  function (_r5) {
    "use strict";

    _inherits(_class11, _r5);

    function _class11() {
      _classCallCheck(this, _class11);

      return _possibleConstructorReturn(this, _getPrototypeOf(_class11).call(this, o));
    }

    return _class11;
  }(r))();
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = n(73);
  Object.keys(r).forEach(function (t) {
    "default" !== t && "__esModule" !== t && Object.defineProperty(e, t, {
      enumerable: !0,
      get: function get() {
        return r[t];
      }
    });
  });
  var o = n(78);
  Object.keys(o).forEach(function (t) {
    "default" !== t && "__esModule" !== t && Object.defineProperty(e, t, {
      enumerable: !0,
      get: function get() {
        return o[t];
      }
    });
  });
  var i = n(84);
  Object.keys(i).forEach(function (t) {
    "default" !== t && "__esModule" !== t && Object.defineProperty(e, t, {
      enumerable: !0,
      get: function get() {
        return i[t];
      }
    });
  });
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.CMS = void 0;
  var r = n(74);

  e.CMS =
  /*#__PURE__*/
  function () {
    function _class12() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, _class12);

      if (this.cms = {
        Prismic: r.Prismic
      }, this.cms[t]) return new this.cms[t](e);
    }

    return _class12;
  }();
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Prismic = void 0;
  var r = c(n(75)),
      o = n(5),
      i = n(30),
      s = n(77),
      a = c(n(2));

  function c(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for (var n in t) {
      if (Object.prototype.hasOwnProperty.call(t, n)) {
        var r = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(t, n) : {};
        r.get || r.set ? Object.defineProperty(e, n, r) : e[n] = t[n];
      }
    }
    return e.default = t, e;
  }

  e.Prismic =
  /*#__PURE__*/
  function () {
    function _class13() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, _class13);

      return a.validator.validate([{
        object: t
      }]) ? "endpoint" in t ? (this.config = t, this.endpointRepo = new o.Repository(this.config.endpoint), this.cacheManager = new i.CacheManager(this.config.endpoint), void (this.componentHelpers = new s.ComponentHelpers())) : a.logger.error("No endpoint defined in prismic") : a.logger.log("Cannot validate Prismic config");
    }

    _createClass(_class13, [{
      key: "request",
      value: function request() {
        var _this14 = this;

        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "page";
        var o = this.endpointRepo.endpoint.buildURL("", e),
            i = t.concat(JSON.stringify(e));
        return this.cacheManager.getCacheData(i).then(function (e) {
          return new Promise(function (s, a) {
            return Object.keys(e).length > 0 && s(e), _this14.config.endpoint.host.indexOf("cdn.prismic.io") > -1 ? r.api(o, {
              accessToken: _this14.config.accessToken
            }).then(function (r) {
              r.getByUID(n, t).then(function (t) {
                var n = {
                  data: t
                };
                Object.keys(e).length > 0 ? new Date(t.last_publication_date) > new Date(e.data.last_publication_date) && _this14.cacheManager.setCacheData(i, n) : _this14.cacheManager.setCacheData(i, n), s(n);
              }).catch(function (t) {
                return a(t);
              });
            }).catch(function (t) {
              return a(t);
            }) : (s(e), _this14.endpointRepo.getItem(t));
          });
        }).catch(function (t) {
          return new Error(t);
        });
      }
    }, {
      key: "buildPage",
      value: function buildPage() {
        var _this15 = this;

        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 ? arguments[1] : undefined;
        var n = arguments.length > 2 ? arguments[2] : undefined;
        var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        return new Promise(function (o, i) {
          var s = [],
              c = {},
              u = [];

          var _loop = function _loop(_t4) {
            var n = Object.keys(e)[_t4];

            e[n].forEach(function (t) {
              var e = _this15.getPageContent(t, r, n);

              s.push(e), u.push(t);
            });
          };

          for (var _t4 = 0; _t4 < Object.keys(e).length; _t4 += 1) {
            _loop(_t4);
          }

          Promise.all(s).then(function (e) {
            for (var _r6 = 0; _r6 < e.length; _r6 += 1) {
              var _o2 = e[_r6],
                  _i2 = ["footer", "navigation", "navigation-top"];
              if (_o2.data) {
                if ("page" === _o2.data.type) {
                  var _e4 = {
                    session: t,
                    page: _o2.data.data
                  };
                  c[_o2.data.uid] = _this15.componentHelpers.getBuiltPage(_e4, n);
                } else if (_i2.indexOf(_o2.data.type) > -1) {
                  var _e5 = {
                    session: t,
                    page: {
                      body: [{
                        slice_type: u[_r6].replace(/site-(.)*-/g, ""),
                        data: _o2.data.data
                      }]
                    }
                  };
                  c[u[_r6]] = _this15.componentHelpers.getBuiltPage(_e5, n);
                } else c[_o2.data.uid] = _o2.data.data;
              } else c[u[_r6]] = {}, a.logger.error("Prismic did not return a valid page");
            }

            o(c);
          }).catch(function (t) {
            return i(t);
          });
        });
      }
    }, {
      key: "getPageContent",
      value: function getPageContent() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "page";
        return this.request(t, e, n);
      }
    }]);

    return _class13;
  }();
}, function (t, e, n) {
  var r;
  "undefined" != typeof self && self, t.exports = (r = n(76), function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) {
        n.d(r, o, function (e) {
          return t[e];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "", n(n.s = 20);
  }([function (t, e, n) {
    "use strict";

    e.a = function (t) {
      var e = this.constructor;
      return this.then(function (n) {
        return e.resolve(t()).then(function () {
          return n;
        });
      }, function (n) {
        return e.resolve(t()).then(function () {
          return e.reject(n);
        });
      });
    };
  }, function (t, e) {
    var n;

    n = function () {
      return this;
    }();

    try {
      n = n || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" == typeof window && (n = window);
    }

    t.exports = n;
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;
    var r = n(5),
        o = n(4),
        i = n(6),
        s = n(12);
    e.PREVIEW_COOKIE = "io.prismic.preview", e.EXPERIMENT_COOKIE = "io.prismic.experiment";

    var a = function () {
      function t(t, e, n) {
        this.data = t, this.masterRef = t.refs.filter(function (t) {
          return t.isMasterRef;
        })[0], this.experiments = new r.Experiments(t.experiments), this.bookmarks = t.bookmarks, this.httpClient = e, this.options = n, this.refs = t.refs, this.tags = t.tags, this.types = t.types;
      }

      return t.prototype.form = function (t) {
        var e = this.data.forms[t];
        return e ? new o.SearchForm(e, this.httpClient) : null;
      }, t.prototype.everything = function () {
        var t = this.form("everything");
        if (!t) throw new Error("Missing everything form");
        return t;
      }, t.prototype.master = function () {
        return this.masterRef.ref;
      }, t.prototype.ref = function (t) {
        var e = this.data.refs.filter(function (e) {
          return e.label === t;
        })[0];
        return e ? e.ref : null;
      }, t.prototype.currentExperiment = function () {
        return this.experiments.current();
      }, t.prototype.query = function (t, n, r) {
        void 0 === r && (r = function r() {});
        var o = "function" == typeof n ? {
          options: {},
          callback: n
        } : {
          options: n || {},
          callback: r
        },
            i = o.options,
            a = o.callback,
            c = this.everything();

        for (var u in i) {
          c = c.set(u, i[u]);
        }

        if (!i.ref) {
          var l = "";
          this.options.req ? l = this.options.req.headers.cookie || "" : "undefined" != typeof window && window.document && (l = window.document.cookie || "");
          var f = s.default.parse(l),
              h = f[e.PREVIEW_COOKIE],
              p = this.experiments.refFromCookie(f[e.EXPERIMENT_COOKIE]);
          c = c.ref(h || p || this.masterRef.ref);
        }

        return t && c.query(t), c.submit(a);
      }, t.prototype.queryFirst = function (t, e, n) {
        var r = "function" == typeof e ? {
          options: {},
          callback: e
        } : {
          options: e || {},
          callback: n || function () {}
        },
            o = r.options,
            i = r.callback;
        return o.page = 1, o.pageSize = 1, this.query(t, o).then(function (t) {
          var e = t && t.results && t.results[0];
          return i(null, e), e;
        }).catch(function (t) {
          throw i(t), t;
        });
      }, t.prototype.getByID = function (t, e, n) {
        var r = e || {};
        return r.lang || (r.lang = "*"), this.queryFirst(i.default.at("document.id", t), r, n);
      }, t.prototype.getByIDs = function (t, e, n) {
        var r = e || {};
        return r.lang || (r.lang = "*"), this.query(i.default.in("document.id", t), r, n);
      }, t.prototype.getByUID = function (t, e, n, r) {
        var o = n || {};
        return o.lang || (o.lang = "*"), this.queryFirst(i.default.at("my." + t + ".uid", e), o, r);
      }, t.prototype.getSingle = function (t, e, n) {
        var r = e || {};
        return this.queryFirst(i.default.at("document.type", t), r, n);
      }, t.prototype.getBookmark = function (t, e, n) {
        var r = this.data.bookmarks[t];
        return r ? this.getByID(r, e, n) : Promise.reject("Error retrieving bookmarked id");
      }, t.prototype.previewSession = function (t, e, n, r) {
        var o = this;
        return this.httpClient.request(t).then(function (i) {
          return i.mainDocument ? o.getByID(i.mainDocument, {
            ref: t
          }).then(function (t) {
            if (t) {
              var o = e(t);
              return r && r(null, o), o;
            }

            return r && r(null, n), n;
          }) : (r && r(null, n), Promise.resolve(n));
        }).catch(function (t) {
          throw r && r(t), t;
        });
      }, t;
    }();

    e.default = a;
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;

    var r = n(2),
        o = n(11),
        i = function () {
      function t(t, e) {
        if (this.options = e || {}, this.url = t, this.options.accessToken) {
          var n = "access_token=" + this.options.accessToken;
          this.url += (t.indexOf("?") > -1 ? "&" : "?") + n;
        }

        this.apiDataTTL = this.options.apiDataTTL || 5, this.httpClient = new o.default(this.options.requestHandler, this.options.apiCache, this.options.proxyAgent);
      }

      return t.prototype.get = function (t) {
        var e = this;
        return this.httpClient.cachedRequest(this.url, {
          ttl: this.apiDataTTL
        }).then(function (n) {
          var o = new r.default(n, e.httpClient, e.options);
          return t && t(null, o), o;
        }).catch(function (e) {
          throw t && t(e), e;
        });
      }, t;
    }();

    e.default = i;
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;

    var r = function () {
      function t(t, e) {
        this.id = t, this.api = e, this.fields = {};
      }

      return t.prototype.set = function (t, e) {
        return this.fields[t] = e, this;
      }, t.prototype.ref = function (t) {
        return this.set("ref", t);
      }, t.prototype.query = function (t) {
        return this.set("q", t);
      }, t.prototype.pageSize = function (t) {
        return this.set("pageSize", t);
      }, t.prototype.fetch = function (t) {
        return this.set("fetch", t);
      }, t.prototype.fetchLinks = function (t) {
        return this.set("fetchLinks", t);
      }, t.prototype.lang = function (t) {
        return this.set("lang", t);
      }, t.prototype.page = function (t) {
        return this.set("page", t);
      }, t.prototype.after = function (t) {
        return this.set("after", t);
      }, t.prototype.orderings = function (t) {
        return this.set("orderings", t);
      }, t.prototype.url = function () {
        var e = this;
        return this.api.get().then(function (n) {
          return t.toSearchForm(e, n).url();
        });
      }, t.prototype.submit = function (e) {
        var n = this;
        return this.api.get().then(function (r) {
          return t.toSearchForm(n, r).submit(e);
        });
      }, t.toSearchForm = function (t, e) {
        var n = e.form(t.id);
        if (n) return Object.keys(t.fields).reduce(function (e, n) {
          var r = t.fields[n];
          return "q" === n ? e.query(r) : "pageSize" === n ? e.pageSize(r) : "fetch" === n ? e.fetch(r) : "fetchLinks" === n ? e.fetchLinks(r) : "lang" === n ? e.lang(r) : "page" === n ? e.page(r) : "after" === n ? e.after(r) : "orderings" === n ? e.orderings(r) : e.set(n, r);
        }, n);
        throw new Error("Unable to access to form " + t.id);
      }, t;
    }();

    e.LazySearchForm = r;

    var o = function () {
      function t(t, e) {
        for (var n in this.httpClient = e, this.form = t, this.data = {}, t.fields) {
          t.fields[n].default && (this.data[n] = [t.fields[n].default]);
        }
      }

      return t.prototype.set = function (t, e) {
        var n = this.form.fields[t];
        if (!n) throw new Error("Unknown field " + t);
        var r = "" === e || void 0 === e ? null : e,
            o = this.data[t] || [];
        return o = n.multiple ? r ? o.concat([r]) : o : r ? [r] : o, this.data[t] = o, this;
      }, t.prototype.ref = function (t) {
        return this.set("ref", t);
      }, t.prototype.query = function (t) {
        if ("string" == typeof t) return this.query([t]);
        if (t instanceof Array) return this.set("q", "[" + t.join("") + "]");
        throw new Error("Invalid query : " + t);
      }, t.prototype.pageSize = function (t) {
        return this.set("pageSize", t);
      }, t.prototype.fetch = function (t) {
        var e = t instanceof Array ? t.join(",") : t;
        return this.set("fetch", e);
      }, t.prototype.fetchLinks = function (t) {
        var e = t instanceof Array ? t.join(",") : t;
        return this.set("fetchLinks", e);
      }, t.prototype.lang = function (t) {
        return this.set("lang", t);
      }, t.prototype.page = function (t) {
        return this.set("page", t);
      }, t.prototype.after = function (t) {
        return this.set("after", t);
      }, t.prototype.orderings = function (t) {
        return t ? this.set("orderings", "[" + t.join(",") + "]") : this;
      }, t.prototype.url = function () {
        var t = this.form.action;

        if (this.data) {
          var e = t.indexOf("?") > -1 ? "&" : "?";

          for (var n in this.data) {
            if (this.data.hasOwnProperty(n)) {
              var r = this.data[n];
              if (r) for (var o = 0; o < r.length; o++) {
                t += e + n + "=" + encodeURIComponent(r[o]), e = "&";
              }
            }
          }
        }

        return t;
      }, t.prototype.submit = function (t) {
        return this.httpClient.cachedRequest(this.url()).then(function (e) {
          return t && t(null, e), e;
        }).catch(function (e) {
          throw t && t(e), e;
        });
      }, t;
    }();

    e.SearchForm = o;
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;

    var r = function () {
      function t(t) {
        this.data = {}, this.data = t;
      }

      return t.prototype.id = function () {
        return this.data.id;
      }, t.prototype.ref = function () {
        return this.data.ref;
      }, t.prototype.label = function () {
        return this.data.label;
      }, t;
    }();

    e.Variation = r;

    var o = function () {
      function t(t) {
        this.data = {}, this.data = t, this.variations = (t.variations || []).map(function (t) {
          return new r(t);
        });
      }

      return t.prototype.id = function () {
        return this.data.id;
      }, t.prototype.googleId = function () {
        return this.data.googleId;
      }, t.prototype.name = function () {
        return this.data.name;
      }, t;
    }();

    e.Experiment = o;

    var i = function () {
      function t(t) {
        t && (this.drafts = (t.drafts || []).map(function (t) {
          return new o(t);
        }), this.running = (t.running || []).map(function (t) {
          return new o(t);
        }));
      }

      return t.prototype.current = function () {
        return this.running.length > 0 ? this.running[0] : null;
      }, t.prototype.refFromCookie = function (t) {
        if (!t || "" === t.trim()) return null;
        var e = t.trim().split(" ");
        if (e.length < 2) return null;
        var n = e[0],
            r = parseInt(e[1], 10),
            o = this.running.filter(function (t) {
          return t.googleId() === n && t.variations.length > r;
        })[0];
        return o ? o.variations[r].ref() : null;
      }, t;
    }();

    e.Experiments = i;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      if ("string" == typeof t) return '"' + t + '"';
      if ("number" == typeof t) return t.toString();
      if (t instanceof Date) return t.getTime().toString();
      if (t instanceof Array) return "[" + t.map(function (t) {
        return r(t);
      }).join(",") + "]";
      throw new Error("Unable to encode " + t + " of type " + typeof t);
    }

    e.__esModule = !0;
    var o = {
      near: function near(t, e, n, r) {
        return "[geopoint.near(" + t + ", " + e + ", " + n + ", " + r + ")]";
      }
    },
        i = {
      before: function before(t, e) {
        return "[date.before(" + t + ", " + r(e) + ")]";
      },
      after: function after(t, e) {
        return "[date.after(" + t + ", " + r(e) + ")]";
      },
      between: function between(t, e, n) {
        return "[date.between(" + t + ", " + r(e) + ", " + r(n) + ")]";
      },
      dayOfMonth: function dayOfMonth(t, e) {
        return "[date.day-of-month(" + t + ", " + e + ")]";
      },
      dayOfMonthAfter: function dayOfMonthAfter(t, e) {
        return "[date.day-of-month-after(" + t + ", " + e + ")]";
      },
      dayOfMonthBefore: function dayOfMonthBefore(t, e) {
        return "[date.day-of-month-before(" + t + ", " + e + ")]";
      },
      dayOfWeek: function dayOfWeek(t, e) {
        return "[date.day-of-week(" + t + ", " + r(e) + ")]";
      },
      dayOfWeekAfter: function dayOfWeekAfter(t, e) {
        return "[date.day-of-week-after(" + t + ", " + r(e) + ")]";
      },
      dayOfWeekBefore: function dayOfWeekBefore(t, e) {
        return "[date.day-of-week-before(" + t + ", " + r(e) + ")]";
      },
      month: function month(t, e) {
        return "[date.month(" + t + ", " + r(e) + ")]";
      },
      monthBefore: function monthBefore(t, e) {
        return "[date.month-before(" + t + ", " + r(e) + ")]";
      },
      monthAfter: function monthAfter(t, e) {
        return "[date.month-after(" + t + ", " + r(e) + ")]";
      },
      year: function year(t, e) {
        return "[date.year(" + t + ", " + e + ")]";
      },
      hour: function hour(t, e) {
        return "[date.hour(" + t + ", " + e + ")]";
      },
      hourBefore: function hourBefore(t, e) {
        return "[date.hour-before(" + t + ", " + e + ")]";
      },
      hourAfter: function hourAfter(t, e) {
        return "[date.hour-after(" + t + ", " + e + ")]";
      }
    },
        s = {
      gt: function gt(t, e) {
        return "[number.gt(" + t + ", " + e + ")]";
      },
      lt: function lt(t, e) {
        return "[number.lt(" + t + ", " + e + ")]";
      },
      inRange: function inRange(t, e, n) {
        return "[number.inRange(" + t + ", " + e + ", " + n + ")]";
      }
    };
    e.default = {
      at: function at(t, e) {
        return "[at(" + t + ", " + r(e) + ")]";
      },
      not: function not(t, e) {
        return "[not(" + t + ", " + r(e) + ")]";
      },
      missing: function missing(t) {
        return "[missing(" + t + ")]";
      },
      has: function has(t) {
        return "[has(" + t + ")]";
      },
      any: function any(t, e) {
        return "[any(" + t + ", " + r(e) + ")]";
      },
      in: function _in(t, e) {
        return "[in(" + t + ", " + r(e) + ")]";
      },
      fulltext: function fulltext(t, e) {
        return "[fulltext(" + t + ", " + r(e) + ")]";
      },
      similar: function similar(t, e) {
        return '[similar("' + t + '", ' + e + ")]";
      },
      date: i,
      dateBefore: i.before,
      dateAfter: i.after,
      dateBetween: i.between,
      dayOfMonth: i.dayOfMonth,
      dayOfMonthAfter: i.dayOfMonthAfter,
      dayOfMonthBefore: i.dayOfMonthBefore,
      dayOfWeek: i.dayOfWeek,
      dayOfWeekAfter: i.dayOfWeekAfter,
      dayOfWeekBefore: i.dayOfWeekBefore,
      month: i.month,
      monthBefore: i.monthBefore,
      monthAfter: i.monthAfter,
      year: i.year,
      hour: i.hour,
      hourBefore: i.hourBefore,
      hourAfter: i.hourAfter,
      number: s,
      gt: s.gt,
      lt: s.lt,
      inRange: s.inRange,
      near: o.near,
      geopoint: o
    };
  }, function (t, e, n) {
    "use strict";

    (function (t) {
      var r = n(0),
          o = setTimeout;

      function i() {}

      function s(t) {
        if (!(this instanceof s)) throw new TypeError("Promises must be constructed via new");
        if ("function" != typeof t) throw new TypeError("not a function");
        this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], f(t, this);
      }

      function a(t, e) {
        for (; 3 === t._state;) {
          t = t._value;
        }

        0 !== t._state ? (t._handled = !0, s._immediateFn(function () {
          var n = 1 === t._state ? e.onFulfilled : e.onRejected;

          if (null !== n) {
            var r;

            try {
              r = n(t._value);
            } catch (t) {
              return void u(e.promise, t);
            }

            c(e.promise, r);
          } else (1 === t._state ? c : u)(e.promise, t._value);
        })) : t._deferreds.push(e);
      }

      function c(t, e) {
        try {
          if (e === t) throw new TypeError("A promise cannot be resolved with itself.");

          if (e && ("object" == typeof e || "function" == typeof e)) {
            var n = e.then;
            if (e instanceof s) return t._state = 3, t._value = e, void l(t);
            if ("function" == typeof n) return void f(function (t, e) {
              return function () {
                t.apply(e, arguments);
              };
            }(n, e), t);
          }

          t._state = 1, t._value = e, l(t);
        } catch (e) {
          u(t, e);
        }
      }

      function u(t, e) {
        t._state = 2, t._value = e, l(t);
      }

      function l(t) {
        2 === t._state && 0 === t._deferreds.length && s._immediateFn(function () {
          t._handled || s._unhandledRejectionFn(t._value);
        });

        for (var e = 0, n = t._deferreds.length; e < n; e++) {
          a(t, t._deferreds[e]);
        }

        t._deferreds = null;
      }

      function f(t, e) {
        var n = !1;

        try {
          t(function (t) {
            n || (n = !0, c(e, t));
          }, function (t) {
            n || (n = !0, u(e, t));
          });
        } catch (t) {
          if (n) return;
          n = !0, u(e, t);
        }
      }

      s.prototype.catch = function (t) {
        return this.then(null, t);
      }, s.prototype.then = function (t, e) {
        var n = new this.constructor(i);
        return a(this, new function (t, e, n) {
          this.onFulfilled = "function" == typeof t ? t : null, this.onRejected = "function" == typeof e ? e : null, this.promise = n;
        }(t, e, n)), n;
      }, s.prototype.finally = r.a, s.all = function (t) {
        return new s(function (e, n) {
          if (!t || void 0 === t.length) throw new TypeError("Promise.all accepts an array");
          var r = Array.prototype.slice.call(t);
          if (0 === r.length) return e([]);
          var o = r.length;

          function i(t, s) {
            try {
              if (s && ("object" == typeof s || "function" == typeof s)) {
                var a = s.then;
                if ("function" == typeof a) return void a.call(s, function (e) {
                  i(t, e);
                }, n);
              }

              r[t] = s, 0 == --o && e(r);
            } catch (t) {
              n(t);
            }
          }

          for (var s = 0; s < r.length; s++) {
            i(s, r[s]);
          }
        });
      }, s.resolve = function (t) {
        return t && "object" == typeof t && t.constructor === s ? t : new s(function (e) {
          e(t);
        });
      }, s.reject = function (t) {
        return new s(function (e, n) {
          n(t);
        });
      }, s.race = function (t) {
        return new s(function (e, n) {
          for (var r = 0, o = t.length; r < o; r++) {
            t[r].then(e, n);
          }
        });
      }, s._immediateFn = "function" == typeof t && function (e) {
        t(e);
      } || function (t) {
        o(t, 0);
      }, s._unhandledRejectionFn = function (t) {
        "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", t);
      }, e.a = s;
    }).call(this, n(18).setImmediate);
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;

    var r = 20,
        o = 0,
        i = [],
        s = function () {
      function t(t) {
        this.options = t || {};
      }

      return t.prototype.request = function (t, e) {
        i.push({
          url: t,
          callback: e
        }), function t(e) {
          if (i.length > 0 && o < r) {
            o++;
            var n = i.shift();
            n && function (t, e, n) {
              var r = {
                headers: {
                  Accept: "application/json"
                }
              };
              e && e.proxyAgent && (r.agent = e.proxyAgent), fetch(t, r).then(function (e) {
                return ~~(e.status / 100 != 2) ? e.text().then(function () {
                  var n = new Error("Unexpected status code [" + e.status + "] on URL " + t);
                  throw n.status = e.status, n;
                }) : e.json().then(function (t) {
                  var r = e.headers.get("cache-control"),
                      o = r ? /max-age=(\d+)/.exec(r) : null,
                      i = o ? parseInt(o[1], 10) : void 0;
                  n(null, t, e, i);
                });
              }).catch(n);
            }(n.url, e, function (r, i, s, a) {
              o--, n.callback(r, i, s, a), t(e);
            });
          }
        }(this.options);
      }, t;
    }();

    e.DefaultRequestHandler = s;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      this.size = 0, this.limit = t, this._keymap = {};
    }

    e.__esModule = !0, e.MakeLRUCache = function (t) {
      return new r(t);
    }, r.prototype.put = function (t, e) {
      var n = {
        key: t,
        value: e
      };
      if (this._keymap[t] = n, this.tail ? (this.tail.newer = n, n.older = this.tail) : this.head = n, this.tail = n, this.size === this.limit) return this.shift();
      this.size++;
    }, r.prototype.shift = function () {
      var t = this.head;
      return t && (this.head.newer ? (this.head = this.head.newer, this.head.older = void 0) : this.head = void 0, t.newer = t.older = void 0, delete this._keymap[t.key]), console.log("purging ", t.key), t;
    }, r.prototype.get = function (t, e) {
      var n = this._keymap[t];
      if (void 0 !== n) return n === this.tail ? e ? n : n.value : (n.newer && (n === this.head && (this.head = n.newer), n.newer.older = n.older), n.older && (n.older.newer = n.newer), n.newer = void 0, n.older = this.tail, this.tail && (this.tail.newer = n), this.tail = n, e ? n : n.value);
    }, r.prototype.find = function (t) {
      return this._keymap[t];
    }, r.prototype.set = function (t, e) {
      var n,
          r = this.get(t, !0);
      return r ? (n = r.value, r.value = e) : (n = this.put(t, e)) && (n = n.value), n;
    }, r.prototype.remove = function (t) {
      var e = this._keymap[t];
      if (e) return delete this._keymap[e.key], e.newer && e.older ? (e.older.newer = e.newer, e.newer.older = e.older) : e.newer ? (e.newer.older = void 0, this.head = e.newer) : e.older ? (e.older.newer = void 0, this.tail = e.older) : this.head = this.tail = void 0, this.size--, e.value;
    }, r.prototype.removeAll = function () {
      this.head = this.tail = void 0, this.size = 0, this._keymap = {};
    }, "function" == typeof Object.keys ? r.prototype.keys = function () {
      return Object.keys(this._keymap);
    } : r.prototype.keys = function () {
      var t = [];

      for (var e in this._keymap) {
        t.push(e);
      }

      return t;
    }, r.prototype.forEach = function (t, e, n) {
      var r;
      if (!0 === e ? (n = !0, e = void 0) : "object" != typeof e && (e = this), n) for (r = this.tail; r;) {
        t.call(e, r.key, r.value, this), r = r.older;
      } else for (r = this.head; r;) {
        t.call(e, r.key, r.value, this), r = r.newer;
      }
    }, r.prototype.toString = function () {
      for (var t = "", e = this.head; e;) {
        t += String(e.key) + ":" + e.value, (e = e.newer) && (t += " < ");
      }

      return t;
    };
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;

    var r = n(9),
        o = function () {
      function t(t) {
        void 0 === t && (t = 1e3), this.lru = r.MakeLRUCache(t);
      }

      return t.prototype.isExpired = function (t) {
        var e = this.lru.get(t, !1);
        return !!e && 0 !== e.expiredIn && e.expiredIn < Date.now();
      }, t.prototype.get = function (t, e) {
        var n = this.lru.get(t, !1);
        n && !this.isExpired(t) ? e(null, n.data) : e && e(null);
      }, t.prototype.set = function (t, e, n, r) {
        this.lru.remove(t), this.lru.put(t, {
          data: e,
          expiredIn: n ? Date.now() + 1e3 * n : 0
        }), r && r(null);
      }, t.prototype.remove = function (t, e) {
        this.lru.remove(t), e && e(null);
      }, t.prototype.clear = function (t) {
        this.lru.removeAll(), t && t(null);
      }, t;
    }();

    e.DefaultApiCache = o;
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;

    var r = n(10),
        o = n(8),
        i = function () {
      function t(t, e, n) {
        this.requestHandler = t || new o.DefaultRequestHandler({
          proxyAgent: n
        }), this.cache = e || new r.DefaultApiCache();
      }

      return t.prototype.request = function (t, e) {
        var n = this;
        return new Promise(function (r, o) {
          n.requestHandler.request(t, function (t, n, i, s) {
            t ? (o(t), e && e(t, null, i, s)) : n && (r(n), e && e(null, n, i, s));
          });
        });
      }, t.prototype.cachedRequest = function (t, e) {
        var n = this,
            r = e || {};
        return new Promise(function (e, o) {
          !function (e) {
            var o = r.cacheKey || t;
            n.cache.get(o, function (i, s) {
              i || s ? e(i, s) : n.request(t, function (t, i, s, a) {
                if (t) e(t, null);else {
                  var c = a || r.ttl;
                  c && n.cache.set(o, i, c, e), e(null, i);
                }
              });
            });
          }(function (t, n) {
            t && o(t), n && e(n);
          });
        });
      }, t;
    }();

    e.default = i;
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;
    var r = decodeURIComponent;
    e.default = {
      parse: function parse(t, e) {
        if ("string" != typeof t) throw new TypeError("argument str must be a string");
        var n = {},
            o = e || {},
            i = t.split(/; */),
            s = o.decode || r;
        return i.forEach(function (t) {
          var e = t.indexOf("=");

          if (!(e < 0)) {
            var r = t.substr(0, e).trim(),
                o = t.substr(++e, t.length).trim();
            '"' == o[0] && (o = o.slice(1, -1)), null == n[r] && (n[r] = function (t, e) {
              try {
                return e(t);
              } catch (e) {
                return t;
              }
            }(o, s));
          }
        }), n;
      }
    };
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0;

    var r = n(4),
        o = n(3),
        i = function () {
      function t(t, e) {
        this.api = new o.default(t, e);
      }

      return t.prototype.getApi = function () {
        return this.api.get();
      }, t.prototype.everything = function () {
        return this.form("everything");
      }, t.prototype.form = function (t) {
        return new r.LazySearchForm(t, this.api);
      }, t.prototype.query = function (t, e, n) {
        return this.getApi().then(function (r) {
          return r.query(t, e, n);
        });
      }, t.prototype.queryFirst = function (t, e, n) {
        return this.getApi().then(function (r) {
          return r.queryFirst(t, e, n);
        });
      }, t.prototype.getByID = function (t, e, n) {
        return this.getApi().then(function (r) {
          return r.getByID(t, e, n);
        });
      }, t.prototype.getByIDs = function (t, e, n) {
        return this.getApi().then(function (r) {
          return r.getByIDs(t, e, n);
        });
      }, t.prototype.getByUID = function (t, e, n, r) {
        return this.getApi().then(function (o) {
          return o.getByUID(t, e, n, r);
        });
      }, t.prototype.getSingle = function (t, e, n) {
        return this.getApi().then(function (r) {
          return r.getSingle(t, e, n);
        });
      }, t.prototype.getBookmark = function (t, e, n) {
        return this.getApi().then(function (r) {
          return r.getBookmark(t, e, n);
        });
      }, t.prototype.previewSession = function (t, e, n, r) {
        return this.getApi().then(function (o) {
          return o.previewSession(t, e, n, r);
        });
      }, t.getApi = function (t, e) {
        return new o.default(t, e).get();
      }, t;
    }();

    e.DefaultClient = i;
  }, function (t, e, n) {
    "use strict";

    var r,
        o = n(6),
        i = n(5),
        s = n(13),
        a = n(3),
        c = n(2);
    !function (t) {
      function e(t, e) {
        return s.DefaultClient.getApi(t, e);
      }

      t.experimentCookie = c.EXPERIMENT_COOKIE, t.previewCookie = c.PREVIEW_COOKIE, t.Predicates = o.default, t.Experiments = i.Experiments, t.Api = a.default, t.client = function (t, e) {
        return new s.DefaultClient(t, e);
      }, t.getApi = e, t.api = function (t, n) {
        return e(t, n);
      };
    }(r || (r = {})), t.exports = r;
  }, function (t, e) {
    t.exports = r;
  }, function (t, e) {
    var n,
        r,
        o = t.exports = {};

    function i() {
      throw new Error("setTimeout has not been defined");
    }

    function s() {
      throw new Error("clearTimeout has not been defined");
    }

    function a(t) {
      if (n === setTimeout) return setTimeout(t, 0);
      if ((n === i || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);

      try {
        return n(t, 0);
      } catch (e) {
        try {
          return n.call(null, t, 0);
        } catch (e) {
          return n.call(this, t, 0);
        }
      }
    }

    !function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : i;
      } catch (t) {
        n = i;
      }

      try {
        r = "function" == typeof clearTimeout ? clearTimeout : s;
      } catch (t) {
        r = s;
      }
    }();
    var c,
        u = [],
        l = !1,
        f = -1;

    function h() {
      l && c && (l = !1, c.length ? u = c.concat(u) : f = -1, u.length && p());
    }

    function p() {
      if (!l) {
        var t = a(h);
        l = !0;

        for (var e = u.length; e;) {
          for (c = u, u = []; ++f < e;) {
            c && c[f].run();
          }

          f = -1, e = u.length;
        }

        c = null, l = !1, function (t) {
          if (r === clearTimeout) return clearTimeout(t);
          if ((r === s || !r) && clearTimeout) return r = clearTimeout, clearTimeout(t);

          try {
            r(t);
          } catch (e) {
            try {
              return r.call(null, t);
            } catch (e) {
              return r.call(this, t);
            }
          }
        }(t);
      }
    }

    function d(t, e) {
      this.fun = t, this.array = e;
    }

    function y() {}

    o.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) {
        e[n - 1] = arguments[n];
      }
      u.push(new d(t, e)), 1 !== u.length || l || a(p);
    }, d.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = y, o.addListener = y, o.once = y, o.off = y, o.removeListener = y, o.removeAllListeners = y, o.emit = y, o.prependListener = y, o.prependOnceListener = y, o.listeners = function (t) {
      return [];
    }, o.binding = function (t) {
      throw new Error("process.binding is not supported");
    }, o.cwd = function () {
      return "/";
    }, o.chdir = function (t) {
      throw new Error("process.chdir is not supported");
    }, o.umask = function () {
      return 0;
    };
  }, function (t, e, n) {
    (function (t, e) {
      !function (t, n) {
        "use strict";

        if (!t.setImmediate) {
          var r,
              o = 1,
              i = {},
              s = !1,
              a = t.document,
              c = Object.getPrototypeOf && Object.getPrototypeOf(t);
          c = c && c.setTimeout ? c : t, "[object process]" === {}.toString.call(t.process) ? r = function r(t) {
            e.nextTick(function () {
              l(t);
            });
          } : function () {
            if (t.postMessage && !t.importScripts) {
              var e = !0,
                  n = t.onmessage;
              return t.onmessage = function () {
                e = !1;
              }, t.postMessage("", "*"), t.onmessage = n, e;
            }
          }() ? function () {
            var e = "setImmediate$" + Math.random() + "$",
                n = function n(_n4) {
              _n4.source === t && "string" == typeof _n4.data && 0 === _n4.data.indexOf(e) && l(+_n4.data.slice(e.length));
            };

            t.addEventListener ? t.addEventListener("message", n, !1) : t.attachEvent("onmessage", n), r = function r(n) {
              t.postMessage(e + n, "*");
            };
          }() : t.MessageChannel ? function () {
            var t = new MessageChannel();
            t.port1.onmessage = function (t) {
              l(t.data);
            }, r = function r(e) {
              t.port2.postMessage(e);
            };
          }() : a && "onreadystatechange" in a.createElement("script") ? function () {
            var t = a.documentElement;

            r = function r(e) {
              var n = a.createElement("script");
              n.onreadystatechange = function () {
                l(e), n.onreadystatechange = null, t.removeChild(n), n = null;
              }, t.appendChild(n);
            };
          }() : r = function r(t) {
            setTimeout(l, 0, t);
          }, c.setImmediate = function (t) {
            "function" != typeof t && (t = new Function("" + t));

            for (var e = new Array(arguments.length - 1), n = 0; n < e.length; n++) {
              e[n] = arguments[n + 1];
            }

            var s = {
              callback: t,
              args: e
            };
            return i[o] = s, r(o), o++;
          }, c.clearImmediate = u;
        }

        function u(t) {
          delete i[t];
        }

        function l(t) {
          if (s) setTimeout(l, 0, t);else {
            var e = i[t];

            if (e) {
              s = !0;

              try {
                !function (t) {
                  var e = t.callback,
                      r = t.args;

                  switch (r.length) {
                    case 0:
                      e();
                      break;

                    case 1:
                      e(r[0]);
                      break;

                    case 2:
                      e(r[0], r[1]);
                      break;

                    case 3:
                      e(r[0], r[1], r[2]);
                      break;

                    default:
                      e.apply(n, r);
                  }
                }(e);
              } finally {
                u(t), s = !1;
              }
            }
          }
        }
      }("undefined" == typeof self ? void 0 === t ? this : t : self);
    }).call(this, n(1), n(16));
  }, function (t, e, n) {
    (function (t) {
      var r = void 0 !== t && t || "undefined" != typeof self && self || window,
          o = Function.prototype.apply;

      function i(t, e) {
        this._id = t, this._clearFn = e;
      }

      e.setTimeout = function () {
        return new i(o.call(setTimeout, r, arguments), clearTimeout);
      }, e.setInterval = function () {
        return new i(o.call(setInterval, r, arguments), clearInterval);
      }, e.clearTimeout = e.clearInterval = function (t) {
        t && t.close();
      }, i.prototype.unref = i.prototype.ref = function () {}, i.prototype.close = function () {
        this._clearFn.call(r, this._id);
      }, e.enroll = function (t, e) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = e;
      }, e.unenroll = function (t) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = -1;
      }, e._unrefActive = e.active = function (t) {
        clearTimeout(t._idleTimeoutId);
        var e = t._idleTimeout;
        e >= 0 && (t._idleTimeoutId = setTimeout(function () {
          t._onTimeout && t._onTimeout();
        }, e));
      }, n(17), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate;
    }).call(this, n(1));
  }, function (t, e, n) {
    "use strict";

    n.r(e), function (t) {
      var e = n(7),
          r = n(0),
          o = function () {
        if ("undefined" != typeof self) return self;
        if ("undefined" != typeof window) return window;
        if (void 0 !== t) return t;
        throw new Error("unable to locate global object");
      }();

      o.Promise ? o.Promise.prototype.finally || (o.Promise.prototype.finally = r.a) : o.Promise = e.a;
    }.call(this, n(1));
  }, function (t, e, n) {
    n(19), n(15), t.exports = n(14);
  }]));
}, function (t, e) {
  !function (t) {
    if (!t.fetch) {
      var e = {
        searchParams: "URLSearchParams" in t,
        iterable: "Symbol" in t && "iterator" in Symbol,
        blob: "FileReader" in t && "Blob" in t && function () {
          try {
            return new Blob(), !0;
          } catch (t) {
            return !1;
          }
        }(),
        formData: "FormData" in t,
        arrayBuffer: "ArrayBuffer" in t
      };
      if (e.arrayBuffer) var n = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
          r = function r(t) {
        return t && DataView.prototype.isPrototypeOf(t);
      },
          o = ArrayBuffer.isView || function (t) {
        return t && n.indexOf(Object.prototype.toString.call(t)) > -1;
      };
      l.prototype.append = function (t, e) {
        t = a(t), e = c(e);
        var n = this.map[t];
        this.map[t] = n ? n + "," + e : e;
      }, l.prototype.delete = function (t) {
        delete this.map[a(t)];
      }, l.prototype.get = function (t) {
        return t = a(t), this.has(t) ? this.map[t] : null;
      }, l.prototype.has = function (t) {
        return this.map.hasOwnProperty(a(t));
      }, l.prototype.set = function (t, e) {
        this.map[a(t)] = c(e);
      }, l.prototype.forEach = function (t, e) {
        for (var n in this.map) {
          this.map.hasOwnProperty(n) && t.call(e, this.map[n], n, this);
        }
      }, l.prototype.keys = function () {
        var t = [];
        return this.forEach(function (e, n) {
          t.push(n);
        }), u(t);
      }, l.prototype.values = function () {
        var t = [];
        return this.forEach(function (e) {
          t.push(e);
        }), u(t);
      }, l.prototype.entries = function () {
        var t = [];
        return this.forEach(function (e, n) {
          t.push([n, e]);
        }), u(t);
      }, e.iterable && (l.prototype[Symbol.iterator] = l.prototype.entries);
      var i = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
      g.prototype.clone = function () {
        return new g(this, {
          body: this._bodyInit
        });
      }, y.call(g.prototype), y.call(m.prototype), m.prototype.clone = function () {
        return new m(this._bodyInit, {
          status: this.status,
          statusText: this.statusText,
          headers: new l(this.headers),
          url: this.url
        });
      }, m.error = function () {
        var t = new m(null, {
          status: 0,
          statusText: ""
        });
        return t.type = "error", t;
      };
      var s = [301, 302, 303, 307, 308];
      m.redirect = function (t, e) {
        if (-1 === s.indexOf(e)) throw new RangeError("Invalid status code");
        return new m(null, {
          status: e,
          headers: {
            location: t
          }
        });
      }, t.Headers = l, t.Request = g, t.Response = m, t.fetch = function (t, n) {
        return new Promise(function (r, o) {
          var i = new g(t, n),
              s = new XMLHttpRequest();
          s.onload = function () {
            var t,
                e,
                n = {
              status: s.status,
              statusText: s.statusText,
              headers: (t = s.getAllResponseHeaders() || "", e = new l(), t.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (t) {
                var n = t.split(":"),
                    r = n.shift().trim();

                if (r) {
                  var o = n.join(":").trim();
                  e.append(r, o);
                }
              }), e)
            };
            n.url = "responseURL" in s ? s.responseURL : n.headers.get("X-Request-URL");
            var o = "response" in s ? s.response : s.responseText;
            r(new m(o, n));
          }, s.onerror = function () {
            o(new TypeError("Network request failed"));
          }, s.ontimeout = function () {
            o(new TypeError("Network request failed"));
          }, s.open(i.method, i.url, !0), "include" === i.credentials ? s.withCredentials = !0 : "omit" === i.credentials && (s.withCredentials = !1), "responseType" in s && e.blob && (s.responseType = "blob"), i.headers.forEach(function (t, e) {
            s.setRequestHeader(e, t);
          }), s.send(void 0 === i._bodyInit ? null : i._bodyInit);
        });
      }, t.fetch.polyfill = !0;
    }

    function a(t) {
      if ("string" != typeof t && (t = String(t)), /[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(t)) throw new TypeError("Invalid character in header field name");
      return t.toLowerCase();
    }

    function c(t) {
      return "string" != typeof t && (t = String(t)), t;
    }

    function u(t) {
      var n = {
        next: function next() {
          var e = t.shift();
          return {
            done: void 0 === e,
            value: e
          };
        }
      };
      return e.iterable && (n[Symbol.iterator] = function () {
        return n;
      }), n;
    }

    function l(t) {
      this.map = {}, t instanceof l ? t.forEach(function (t, e) {
        this.append(e, t);
      }, this) : Array.isArray(t) ? t.forEach(function (t) {
        this.append(t[0], t[1]);
      }, this) : t && Object.getOwnPropertyNames(t).forEach(function (e) {
        this.append(e, t[e]);
      }, this);
    }

    function f(t) {
      if (t.bodyUsed) return Promise.reject(new TypeError("Already read"));
      t.bodyUsed = !0;
    }

    function h(t) {
      return new Promise(function (e, n) {
        t.onload = function () {
          e(t.result);
        }, t.onerror = function () {
          n(t.error);
        };
      });
    }

    function p(t) {
      var e = new FileReader(),
          n = h(e);
      return e.readAsArrayBuffer(t), n;
    }

    function d(t) {
      if (t.slice) return t.slice(0);
      var e = new Uint8Array(t.byteLength);
      return e.set(new Uint8Array(t)), e.buffer;
    }

    function y() {
      return this.bodyUsed = !1, this._initBody = function (t) {
        if (this._bodyInit = t, t) {
          if ("string" == typeof t) this._bodyText = t;else if (e.blob && Blob.prototype.isPrototypeOf(t)) this._bodyBlob = t;else if (e.formData && FormData.prototype.isPrototypeOf(t)) this._bodyFormData = t;else if (e.searchParams && URLSearchParams.prototype.isPrototypeOf(t)) this._bodyText = t.toString();else if (e.arrayBuffer && e.blob && r(t)) this._bodyArrayBuffer = d(t.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer]);else {
            if (!e.arrayBuffer || !ArrayBuffer.prototype.isPrototypeOf(t) && !o(t)) throw new Error("unsupported BodyInit type");
            this._bodyArrayBuffer = d(t);
          }
        } else this._bodyText = "";
        this.headers.get("content-type") || ("string" == typeof t ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : e.searchParams && URLSearchParams.prototype.isPrototypeOf(t) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
      }, e.blob && (this.blob = function () {
        var t = f(this);
        if (t) return t;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        if (this._bodyFormData) throw new Error("could not read FormData body as blob");
        return Promise.resolve(new Blob([this._bodyText]));
      }, this.arrayBuffer = function () {
        return this._bodyArrayBuffer ? f(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(p);
      }), this.text = function () {
        var t,
            e,
            n,
            r = f(this);
        if (r) return r;
        if (this._bodyBlob) return t = this._bodyBlob, e = new FileReader(), n = h(e), e.readAsText(t), n;
        if (this._bodyArrayBuffer) return Promise.resolve(function (t) {
          for (var e = new Uint8Array(t), n = new Array(e.length), r = 0; r < e.length; r++) {
            n[r] = String.fromCharCode(e[r]);
          }

          return n.join("");
        }(this._bodyArrayBuffer));
        if (this._bodyFormData) throw new Error("could not read FormData body as text");
        return Promise.resolve(this._bodyText);
      }, e.formData && (this.formData = function () {
        return this.text().then(v);
      }), this.json = function () {
        return this.text().then(JSON.parse);
      }, this;
    }

    function g(t, e) {
      var n,
          r,
          o = (e = e || {}).body;

      if (t instanceof g) {
        if (t.bodyUsed) throw new TypeError("Already read");
        this.url = t.url, this.credentials = t.credentials, e.headers || (this.headers = new l(t.headers)), this.method = t.method, this.mode = t.mode, o || null == t._bodyInit || (o = t._bodyInit, t.bodyUsed = !0);
      } else this.url = String(t);

      if (this.credentials = e.credentials || this.credentials || "omit", !e.headers && this.headers || (this.headers = new l(e.headers)), this.method = (n = e.method || this.method || "GET", r = n.toUpperCase(), i.indexOf(r) > -1 ? r : n), this.mode = e.mode || this.mode || null, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");

      this._initBody(o);
    }

    function v(t) {
      var e = new FormData();
      return t.trim().split("&").forEach(function (t) {
        if (t) {
          var n = t.split("="),
              r = n.shift().replace(/\+/g, " "),
              o = n.join("=").replace(/\+/g, " ");
          e.append(decodeURIComponent(r), decodeURIComponent(o));
        }
      }), e;
    }

    function m(t, e) {
      e || (e = {}), this.type = "default", this.status = void 0 === e.status ? 200 : e.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in e ? e.statusText : "OK", this.headers = new l(e.headers), this.url = e.url || "", this._initBody(t);
    }
  }("undefined" != typeof self ? self : this);
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });

  e.ComponentHelpers =
  /*#__PURE__*/
  function () {
    function _class14() {
      _classCallCheck(this, _class14);
    }

    _createClass(_class14, [{
      key: "getBuiltPage",
      value: function getBuiltPage(t, e) {
        var _this16 = this;

        var n = {
          title: t.page.page_title ? t.page.page_title[0].text : "",
          components: [],
          meta: t.page
        };
        return t.page.body.map(function (r, o) {
          var i = _this16.getComponentName(r.slice_type),
              s = _this16.getComponentProps(t, r, o),
              a = _this16.getComponent(i, s, e);

          return a && n.components.push(a), !1;
        }), delete n.meta.body, n;
      }
    }, {
      key: "getComponent",
      value: function getComponent(t, e, n) {
        return t in n ? {
          key: t,
          component: n[t],
          props: e
        } : null;
      }
    }, {
      key: "getComponentProps",
      value: function getComponentProps(t, e, n) {
        var r = this.sliceToFunction(e.slice_type);
        return r in t.session.componentPropList ? t.session.componentPropList[r](n, e, t) : {};
      }
    }, {
      key: "getComponentName",
      value: function getComponentName(t) {
        var e = this.sliceToFunction(t);
        return e.charAt(0).toUpperCase() + e.slice(1);
      }
    }, {
      key: "sliceToFunction",
      value: function sliceToFunction(t) {
        return t.replace(/_/g, " ").toLowerCase().split(" ").map(function (t, e) {
          return e > 0 ? t.charAt(0).toUpperCase() + t.substring(1) : t;
        }).join(" ").replace(/ /g, "");
      }
    }]);

    return _class14;
  }();
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.IntegrationPlatform = void 0;
  var r = i(n(79)),
      o = i(n(2));

  function i(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for (var n in t) {
      if (Object.prototype.hasOwnProperty.call(t, n)) {
        var r = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(t, n) : {};
        r.get || r.set ? Object.defineProperty(e, n, r) : e[n] = t[n];
      }
    }
    return e.default = t, e;
  }

  e.IntegrationPlatform =
  /*#__PURE__*/
  function () {
    function _class15(t) {
      _classCallCheck(this, _class15);

      this.loadDomains(t);
    }

    _createClass(_class15, [{
      key: "loadDomains",
      value: function loadDomains() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        for (var _e6 = 0; _e6 < Object.keys(r).length; _e6 += 1) {
          var _n5 = Object.keys(r)[_e6],
              _i3 = _n5.toLowerCase();

          if (void 0 !== this[_i3]) return o.logger.error("Resource already exists");
          "function" == typeof r[_n5] && (this[_i3] = new r[_n5](t));
        }

        return !0;
      }
    }]);

    return _class15;
  }();
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = n(80);
  Object.keys(r).forEach(function (t) {
    "default" !== t && "__esModule" !== t && Object.defineProperty(e, t, {
      enumerable: !0,
      get: function get() {
        return r[t];
      }
    });
  });
  var o = n(81);
  Object.keys(o).forEach(function (t) {
    "default" !== t && "__esModule" !== t && Object.defineProperty(e, t, {
      enumerable: !0,
      get: function get() {
        return o[t];
      }
    });
  });
  var i = n(82);
  Object.keys(i).forEach(function (t) {
    "default" !== t && "__esModule" !== t && Object.defineProperty(e, t, {
      enumerable: !0,
      get: function get() {
        return i[t];
      }
    });
  });
  var s = n(83);
  Object.keys(s).forEach(function (t) {
    "default" !== t && "__esModule" !== t && Object.defineProperty(e, t, {
      enumerable: !0,
      get: function get() {
        return s[t];
      }
    });
  });
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Finance = void 0;
  var r = n(10);

  e.Finance =
  /*#__PURE__*/
  function (_r$Domain) {
    _inherits(_class16, _r$Domain);

    function _class16() {
      _classCallCheck(this, _class16);

      return _possibleConstructorReturn(this, _getPrototypeOf(_class16).apply(this, arguments));
    }

    _createClass(_class16, [{
      key: "getLeaseById",
      value: function getLeaseById() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.request("/Leases/{leaseId}", t, {}, e);
      }
    }, {
      key: "getAccountsById",
      value: function getAccountsById() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.request("/leases/{leaseId}/accounts", t, {}, e);
      }
    }, {
      key: "getDocumentsById",
      value: function getDocumentsById() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.request("/leases/{leaseId}/documents", t, {}, e);
      }
    }, {
      key: "getDirectDebitById",
      value: function getDirectDebitById() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.request("/leases/{leaseId}/directdebit", t, {}, e);
      }
    }, {
      key: "getFuturePaymentsById",
      value: function getFuturePaymentsById() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.request("/leases/{leaseId}/payments/future?pageNumber={pageNumber}&pageSize={pageSize}", t, {}, e);
      }
    }, {
      key: "getPastPaymentsById",
      value: function getPastPaymentsById() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.request("/leases/{leaseId}/payments/past", t, {}, e);
      }
    }, {
      key: "getHoldingDepositsById",
      value: function getHoldingDepositsById() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.request("/leases/{leaseId}/deposits/holding", t, {}, e);
      }
    }, {
      key: "getSecurityDepositById",
      value: function getSecurityDepositById() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.request("/leases/{leaseId}/deposits/security", t, {}, e);
      }
    }]);

    return _class16;
  }(r.Domain);
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Customer = void 0;
  var r = n(10);

  e.Customer =
  /*#__PURE__*/
  function (_r$Domain2) {
    _inherits(_class17, _r$Domain2);

    function _class17() {
      _classCallCheck(this, _class17);

      return _possibleConstructorReturn(this, _getPrototypeOf(_class17).apply(this, arguments));
    }

    _createClass(_class17, [{
      key: "getByEmail",
      value: function getByEmail() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.request("/Customer/{email}", t, {}, e);
      }
    }, {
      key: "getProfile",
      value: function getProfile() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.request("/Profile", t, {}, e);
      }
    }]);

    return _class17;
  }(r.Domain);
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Amenities = void 0;
  var r = n(10);

  e.Amenities =
  /*#__PURE__*/
  function (_r$Domain3) {
    _inherits(_class18, _r$Domain3);

    function _class18() {
      _classCallCheck(this, _class18);

      return _possibleConstructorReturn(this, _getPrototypeOf(_class18).apply(this, arguments));
    }

    _createClass(_class18, [{
      key: "getAmenityById",
      value: function getAmenityById() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.request("/bookings/amenities/{id}?leaseID={leaseID}", t, {}, e);
      }
    }, {
      key: "getAmenitiesById",
      value: function getAmenitiesById() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.request("/bookings/amenities?leaseId={leaseId}", t, {}, e);
      }
    }, {
      key: "getAvailabilityById",
      value: function getAvailabilityById() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.request("/bookings/amenities/{id}/availability?DateRequested={DateRequested}&RequestedDuration={RequestedDuration}", t, {}, e);
      }
    }, {
      key: "amenityBooking",
      value: function amenityBooking() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.request("/bookings", t, {
          method: "POST"
        }, e);
      }
    }]);

    return _class18;
  }(r.Domain);
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Fault = void 0;
  var r = n(10);

  e.Fault =
  /*#__PURE__*/
  function (_r$Domain4) {
    _inherits(_class19, _r$Domain4);

    function _class19() {
      _classCallCheck(this, _class19);

      return _possibleConstructorReturn(this, _getPrototypeOf(_class19).apply(this, arguments));
    }

    _createClass(_class19, [{
      key: "getCategoriesByFaultType",
      value: function getCategoriesByFaultType() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var n = "/tickets/faultCategories".concat(t.faultType ? "?faultType={faultType}" : "");
        return this.request(n, t, {}, e);
      }
    }, {
      key: "createNewTicket",
      value: function createNewTicket() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.request("/tickets", t, {
          method: "POST"
        }, e);
      }
    }]);

    return _class19;
  }(r.Domain);
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Notifications = void 0;
  var r = n(5);

  e.Notifications =
  /*#__PURE__*/
  function () {
    function _class20() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, _class20);

      this.config = t, this.endpointRepo = new r.Repository(this.config.endpoint);
    }

    _createClass(_class20, [{
      key: "addAuth",
      value: function addAuth() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var e = t;
        return e.token = this.config.endpoint.token, e;
      }
    }, {
      key: "request",
      value: function request() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var n = this.addAuth(e);
        return this.endpointRepo.getItem(t, {}, n);
      }
    }, {
      key: "onEvent",
      value: function onEvent() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        this.endpointRepo.endpoint && this.endpointRepo.endpoint.get().onEvent(t, e);
      }
    }]);

    return _class20;
  }();
}]);